import '../scss/components/_ownerrevenue.scss'
import React, { useState, useEffect } from 'react'
import {
  getPGRevenueStatus,
  autoGenerateRent,
  process_rent_payment,
  autoGenerateElectricityBill,
  getTenantStatement,
  getSecurityDeposit,
  getTenantPendingExpenses,
  receiveSecurityDeposit,
  adjustSecurityDeposit,
  refundSecurityDeposit,
  receiveTenantExpense,
  getSettlement,
  generateSettlement,
  processSettlement,
  getOverallDue,
  processOverallPayment
} from '../apis/services/pgApi'

const STATUS_CFG = {
  PAID:        { label: 'Paid',       dot: 'green', bg: '#F0FDF4', border: 'green', text: 'green' },
  DUE:         { label: 'Due',        dot: 'blue', bg: '#f0f6ff', border: 'blue', text: 'blue' },
  OVERDUE:     { label: 'Overdue',    dot: 'orange', bg: '#FFF7ED', border: 'orange', text: 'orange' },
  "NOT PAID":  { label: 'Not Paid',   dot: 'red', bg: '#FFF1F2', border: 'red', text: 'red' },
  VACANT:      { label: 'Vacant',     dot: 'gray', bg: '#F9FAFB', border: 'gray', text: 'gray' },
}

const RENT_STATUS_CFG = {
  PAID:     { label: 'Paid',     dot: 'green', bg: '#F0FDF4', border: 'green', text: 'green' },
  DUE:      { label: 'Due',      dot: 'blue', bg: '#f0f6ff', border: 'blue', text: 'blue' },
  OVERDUE:  { label: 'Overdue',  dot: 'orange', bg: '#FFF7ED', border: 'orange', text: 'orange' },
  "NOT PAID":  { label: 'Not Paid',  dot: 'red', bg: '#FFF1F2', border: 'red', text: 'red' },
  NA:       { label: 'N/A',      dot: 'gray', bg: '#F9FAFB', border: 'gray', text: 'gray' },
}

const fmt = n => `₹${(n || 0).toLocaleString('en-IN')}`

const STATUS_FILTERS = [
  { key: 'PAID', label: 'Paid' ,bg: 'green'},
  { key: 'DUE', label: 'Due' ,bg: 'blue'},
  { key: 'OVERDUE', label: 'Overdue' ,bg: 'orange'},
  { key: 'NOT PAID', label: 'Not Paid' ,bg: 'red'},
]

const getStatusColor = (status) => {
  switch(status) {
    case 'PAID':
      return { bg: '#DCFCE7', color: '#166534', dot: '#22C55E' }
    case 'DUE':
      return { bg: '#f0f6ff', color: '#1b2d80', dot: '#1e49c0' }
    case 'OVERDUE':
      return { bg: '#FFEDD5', color: '#9A3412', dot: '#F97316' }
    case 'NOT PAID':
      return { bg: '#FEE2E2', color: '#991B1B', dot: '#EF4444' }
    default:
      return { bg: '#F3F4F6', color: '#6B7280', dot: '#9CA3AF' }
  }
}

// ─── Security Deposit Modal ────────────────────────────────
// ─── Security Deposit Modal ────────────────────────────────
// const SecurityDepositModal = ({ depositData, admissionId, onClose, onTransactionComplete }) => {
//   const [transactionType, setTransactionType] = useState('')
//   const [amount, setAmount] = useState('')
//   const [isSubmitting, setIsSubmitting] = useState(false)
//   const [message, setMessage] = useState('')
//   const [messageType, setMessageType] = useState('success')
//   const [transactions, setTransactions] = useState([])
//   const [depositInfo, setDepositInfo] = useState(null)

//   // Load deposit data with transactions
//   useEffect(() => {
//     if (depositData) {
//       setDepositInfo(depositData)
//       setTransactions(depositData.Transactions || [])
//     }
//   }, [depositData])

//   const handleSubmit = async (e) => {
//     e.preventDefault()
    
//     if (!transactionType || !amount || parseFloat(amount) <= 0) {
//       setMessage('Please select transaction type and enter a valid amount')
//       setMessageType('error')
//       return
//     }

//     setIsSubmitting(true)
//     setMessage('')

//     try {
//       const requestData = {
//         AdmissionID: admissionId,
//         Amount: parseFloat(amount)
//       }

//       let response
//       switch (transactionType) {
//         case 'RECEIVED':
//           response = await receiveSecurityDeposit(requestData)
//           break
//         case 'ADJUSTED':
//           response = await adjustSecurityDeposit(requestData)
//           break
//         case 'REFUND':
//           response = await refundSecurityDeposit(requestData)
//           break
//         default:
//           throw new Error('Invalid transaction type')
//       }

//       setMessage('Transaction completed successfully!')
//       setMessageType('success')
      
//       // Refresh deposit data
//       const updatedDeposit = await getSecurityDeposit(admissionId)
//       if (updatedDeposit?.data) {
//         setDepositInfo(updatedDeposit.data)
//         setTransactions(updatedDeposit.data.Transactions || [])
//         if (onTransactionComplete) {
//           onTransactionComplete(updatedDeposit.data)
//         }
//       }

//       // Reset form
//       setTransactionType('')
//       setAmount('')
      
//       // Auto close after 2 seconds
//       setTimeout(() => {
//         onClose()
//       }, 2000)

//     } catch (error) {
//       console.error('Transaction error:', error)
//       setMessage(error.message || 'Transaction failed. Please try again.')
//       setMessageType('error')
//     } finally {
//       setIsSubmitting(false)
//     }
//   }

//   const resetForm = () => {
//     setTransactionType('')
//     setAmount('')
//     setMessage('')
//   }

//   if (!depositInfo) {
//     return (
//       <div className="rv-modal-overlay" onClick={onClose}>
//         <div className="rv-sd-modal" onClick={e => e.stopPropagation()}>
//           <div className="rv-sd-head">
//             <h3 className="rv-sd-title">Security Deposit Details</h3>
//             <button className="rv-sd-close" onClick={onClose}>
//               <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//                 <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
//               </svg>
//             </button>
//           </div>
//           <div className="rv-sd-body">
//             <div className="rv-sd-loading">Loading deposit details...</div>
//           </div>
//         </div>
//       </div>
//     )
//   }

//   const statusColor = {
//     PAID: 'rv-sd-status-paid',
//     PARTIAL: 'rv-sd-status-partial',
//     PENDING: 'rv-sd-status-pending'
//   }[depositInfo.Status] || ''

//   const getStatusColorClass = (transactionType) => {
//     switch(transactionType) {
//       case 'RECEIVED': return 'rv-sd-type-received'
//       case 'ADJUSTED': return 'rv-sd-type-adjusted'
//       case 'REFUND': return 'rv-sd-type-refund'
//       default: return ''
//     }
//   }

//   return (
//     <div className="rv-modal-overlay" onClick={onClose}>
//       <div className="rv-sd-modal" onClick={e => e.stopPropagation()}>
//         <div className="rv-sd-head">
//           <h3 className="rv-sd-title">Security Deposit Details</h3>
//           <button className="rv-sd-close" onClick={onClose}>
//             <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//               <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
//             </svg>
//           </button>
//         </div>

//         <div className="rv-sd-body">
//           {/* Deposit Information Grid */}
//           <div className="rv-sd-info-grid">
//             <div className="rv-sd-info-item">
//               <span className="rv-sd-label">Deposit Amount</span>
//               <span className="rv-sd-value rv-sd-deposit">{fmt(depositInfo.DepositAmount)}</span>
//             </div>
//             <div className="rv-sd-info-item">
//               <span className="rv-sd-label">Received Amount</span>
//               <span className="rv-sd-value rv-sd-received">{fmt(depositInfo.ReceivedAmount)}</span>
//             </div>
//             <div className="rv-sd-info-item">
//               <span className="rv-sd-label">Adjusted Amount</span>
//               <span className="rv-sd-value">{fmt(depositInfo.AdjustedAmount)}</span>
//             </div>
//             <div className="rv-sd-info-item">
//               <span className="rv-sd-label">Refund Amount</span>
//               <span className="rv-sd-value">{fmt(depositInfo.RefundAmount)}</span>
//             </div>
//             <div className="rv-sd-info-item">
//               <span className="rv-sd-label">Balance</span>
//               <span className="rv-sd-value rv-sd-balance">{fmt(depositInfo.Balance)}</span>
//             </div>
//             <div className="rv-sd-info-item">
//               <span className="rv-sd-label">Status</span>
//               <span className={`rv-sd-status ${statusColor}`}>
//                 {depositInfo.Status || 'N/A'}
//               </span>
//             </div>
//           </div>

//           {/* Transaction History */}
//           <div className="rv-sd-section">
//             <h4 className="rv-sd-section-title">Transaction History</h4>
//             <div className="rv-sd-table-wrapper">
//               {transactions && transactions.length > 0 ? (
//                 <table className="rv-sd-table">
//                   <thead>
//                     <tr>
//                       <th>Date</th>
//                       <th>Type</th>
//                       <th>Amount</th>
//                       <th>Remarks</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {transactions.map((tx, index) => (
//                       <tr key={tx.TransactionID || index}>
//                         <td>{new Date(tx.TransactionDate).toLocaleDateString('en-IN', { 
//                           day: 'numeric', 
//                           month: 'short', 
//                           year: 'numeric',
//                           hour: '2-digit',
//                           minute: '2-digit'
//                         })}</td>
//                         <td>
//                           <span className={`rv-sd-transaction-type ${getStatusColorClass(tx.TransactionType)}`}>
//                             {tx.TransactionType}
//                           </span>
//                         </td>
//                         <td>{fmt(tx.Amount)}</td>
//                         <td>{tx.Remarks || '-'}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               ) : (
//                 <div className="rv-sd-empty">No transactions found</div>
//               )}
//             </div>
//           </div>

//           {/* Add Transaction Form */}
//           <div className="rv-sd-section rv-sd-action-section">
//             <h4 className="rv-sd-section-title">Add Transaction</h4>
            
//             <form onSubmit={handleSubmit}>
//               <div className="rv-sd-form-row">
//                 <div className="rv-sd-form-group">
//                   <label className="rv-sd-form-label">Transaction Type</label>
//                   <select 
//                     className="rv-sd-form-select" 
//                     value={transactionType}
//                     onChange={(e) => setTransactionType(e.target.value)}
//                     required
//                   >
//                     <option value="">Select Type</option>
//                     <option value="RECEIVED">RECEIVED</option>
//                     <option value="ADJUSTED">ADJUSTED</option>
//                     <option value="REFUND">REFUND</option>
//                   </select>
//                 </div>

//                 <div className="rv-sd-form-group">
//                   <label className="rv-sd-form-label">Amount</label>
//                   <input 
//                     type="number" 
//                     className="rv-sd-form-input" 
//                     placeholder="Enter amount"
//                     value={amount}
//                     onChange={(e) => setAmount(e.target.value)}
//                     step="0.01"
//                     min="0.01"
//                     required
//                   />
//                 </div>
//               </div>

//               {message && (
//                 <div className={`rv-sd-message rv-sd-message-${messageType}`}>
//                   {message}
//                 </div>
//               )}

//               <div className="rv-sd-form-actions">
//                 <button 
//                   type="button" 
//                   className="rv-sd-btn rv-sd-btn-secondary"
//                   onClick={resetForm}
//                 >
//                   Cancel
//                 </button>
//                 <button 
//                   type="submit" 
//                   className="rv-sd-btn rv-sd-btn-primary"
//                   disabled={isSubmitting}
//                 >
//                   {isSubmitting ? (
//                     <>
//                       <span className="rv-sd-spinner"></span>
//                       Processing...
//                     </>
//                   ) : (
//                     'Submit'
//                   )}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// ─── Security Deposit Modal ────────────────────────────────
// const SecurityDepositModal = ({ depositData, admissionId, onClose, onTransactionComplete }) => {
//   const [transactionType, setTransactionType] = useState('')
//   const [amount, setAmount] = useState('')
//   const [isSubmitting, setIsSubmitting] = useState(false)
//   const [message, setMessage] = useState('')
//   const [messageType, setMessageType] = useState('success')
//   const [transactions, setTransactions] = useState([])
//   const [depositInfo, setDepositInfo] = useState(null)
  
//   // Additional fields for ADJUSTED
//   const [referenceType, setReferenceType] = useState('TENANTEXPENSE')
//   const [referenceId, setReferenceId] = useState('9')
  
//   // Additional fields for REFUND
//   const [paymentMode, setPaymentMode] = useState('CASH')
//   const [referenceNo, setReferenceNo] = useState('')

//   // Load deposit data with transactions
//   useEffect(() => {
//     if (depositData) {
//       setDepositInfo(depositData)
//       setTransactions(depositData.Transactions || [])
//     }
//   }, [depositData])

//   const handleSubmit = async (e) => {
//     e.preventDefault()
    
//     if (!transactionType || !amount || parseFloat(amount) <= 0) {
//       setMessage('Please select transaction type and enter a valid amount')
//       setMessageType('error')
//       return
//     }

//     setIsSubmitting(true)
//     setMessage('')

//     try {
//       const parsedAmount = parseFloat(amount)
//       let response

//       switch (transactionType) {
//         case 'RECEIVED':
//           // RECEIVED - uses AdmissionID
//           response = await receiveSecurityDeposit({
//             AdmissionID: admissionId,
//             Amount: parsedAmount
//           })
//           break

//         case 'ADJUSTED':
//           // ADJUSTED - uses DepositID, ReferenceType='TENANTEXPENSE', ReferenceID=9
//           if (!depositInfo?.DepositID) {
//             throw new Error('Deposit ID not found')
//           }
//           const refId=parseInt(referenceId)
//           response = await adjustSecurityDeposit({
//             DepositID: depositInfo.DepositID,
//             ReferenceType: referenceType || 'TENANTEXPENSE',
//             ReferenceID: parseInt(referenceId) || 9,
//             Amount: parsedAmount,
//             Remarks: `Security deposit adjustment - ${referenceType}`,
//             CreatedBy: 1
//           })
//           break

//         case 'REFUND':
//           // REFUND - uses DepositID
//           if (!depositInfo?.DepositID) {
//             throw new Error('Deposit ID not found')
//           }
//           response = await refundSecurityDeposit({
//             DepositID: depositInfo.DepositID,
//             RefundAmount: parsedAmount,
//             RefundDate: new Date().toISOString().split('T')[0],
//             PaymentMode: paymentMode || 'CASH',
//             ReferenceNo: referenceNo || null,
//             Remarks: 'Security deposit refund',
//             CreatedBy: 1
//           })
//           break

//         default:
//           throw new Error('Invalid transaction type')
//       }

//       // Check if response indicates success
//       if (response && response.success === false) {
//         throw new Error(response.message || 'Transaction failed')
//       }

//       setMessage('Transaction completed successfully!')
//       setMessageType('success')
      
//       // Refresh deposit data
//       const updatedDeposit = await getSecurityDeposit(admissionId)
//       if (updatedDeposit?.data) {
//         setDepositInfo(updatedDeposit.data)
//         setTransactions(updatedDeposit.data.Transactions || [])
//         if (onTransactionComplete) {
//           onTransactionComplete(updatedDeposit.data)
//         }
//       }

//       // Reset form
//       setTransactionType('')
//       setAmount('')
//       setReferenceType('TENANTEXPENSE')
//       setReferenceId('9')
//       setPaymentMode('CASH')
//       setReferenceNo('')
      
//       // Auto close after 2 seconds
//       setTimeout(() => {
//         onClose()
//       }, 2000)

//     } catch (error) {
//       console.error('Transaction error:', error)
//       setMessage(error.message || 'Transaction failed. Please try again.')
//       setMessageType('error')
//     } finally {
//       setIsSubmitting(false)
//     }
//   }

//   const resetForm = () => {
    
//     setTransactionType('')
//     setAmount('')
//     setReferenceType('TENANTEXPENSE')
//     setReferenceId('9')
//     setPaymentMode('CASH')
//     setReferenceNo('')
//     setMessage('')
//      setTimeout(() => {
//         onClose()
//       }, 200)
//   }

//   if (!depositInfo) {
//     return (
//       <div className="rv-modal-overlay" onClick={onClose}>
//         <div className="rv-sd-modal" onClick={e => e.stopPropagation()}>
//           <div className="rv-sd-head">
//             <h3 className="rv-sd-title">Security Deposit Details</h3>
//             <button className="rv-sd-close" onClick={onClose}>
//               <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//                 <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
//               </svg>
//             </button>
//           </div>
//           <div className="rv-sd-body">
//             <div className="rv-sd-loading">Loading deposit details...</div>
//           </div>
//         </div>
//       </div>
//     )
//   }

//   const statusColor = {
//     PAID: 'rv-sd-status-paid',
//     PARTIAL: 'rv-sd-status-partial',
//     PENDING: 'rv-sd-status-pending',
//     CLOSED: 'rv-sd-status-closed'
//   }[depositInfo.Status] || ''

//   const getStatusColorClass = (transactionType) => {
//     switch(transactionType) {
//       case 'RECEIVED': return 'rv-sd-type-received'
//       case 'ADJUSTED': return 'rv-sd-type-adjusted'
//       case 'REFUND': return 'rv-sd-type-refund'
//       default: return ''
//     }
//   }

//   return (
//     <div className="rv-modal-overlay" onClick={onClose}>
//       <div className="rv-sd-modal" onClick={e => e.stopPropagation()}>
//         <div className="rv-sd-head">
//           <h3 className="rv-sd-title">Security Deposit Details</h3>
//           <button className="rv-sd-close" onClick={onClose}>
//             <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//               <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
//             </svg>
//           </button>
//         </div>

//         <div className="rv-sd-body">
//           {/* Deposit Information Grid */}
//           <div className="rv-sd-info-grid">
//             {/* <div className="rv-sd-info-item">
//               <span className="rv-sd-label">Deposit ID</span>
//               <span className="rv-sd-value">{depositInfo.DepositID}</span>
//             </div> */}
//             <div className="rv-sd-info-item">
//               <span className="rv-sd-label">Deposit Amount</span>
//               <span className="rv-sd-value rv-sd-deposit">{fmt(depositInfo.DepositAmount)}</span>
//             </div>
//             <div className="rv-sd-info-item">
//               <span className="rv-sd-label">Received Amount</span>
//               <span className="rv-sd-value rv-sd-received">{fmt(depositInfo.ReceivedAmount)}</span>
//             </div>
//             <div className="rv-sd-info-item">
//               <span className="rv-sd-label">Remaining Amount</span>
//               <span className="rv-sd-value rv-sd-received">{fmt(depositInfo.DepositAmount-depositInfo.ReceivedAmount)}</span>
//             </div>
//             <div className="rv-sd-info-item">
//               <span className="rv-sd-label">Adjusted Amount</span>
//               <span className="rv-sd-value">{fmt(depositInfo.AdjustedAmount)}</span>
//             </div>
//             <div className="rv-sd-info-item">
//               <span className="rv-sd-label">Refund Amount</span>
//               <span className="rv-sd-value">{fmt(depositInfo.RefundAmount)}</span>
//             </div>
//             <div className="rv-sd-info-item">
//               <span className="rv-sd-label">Balance</span>
//               <span className="rv-sd-value rv-sd-balance">{fmt(depositInfo.Balance)}</span>
//             </div>
//             <div className="rv-sd-info-item">
//               <span className="rv-sd-label">Status</span>
//               <span className={`rv-sd-status ${statusColor}`}>
//                 {depositInfo.Status || 'N/A'}
//               </span>
//             </div>
//             <div className="rv-sd-info-item">
//               <span className="rv-sd-label">Deposit Date</span>
//               <span className="rv-sd-value">
//                 {new Date(depositInfo.DepositDate).toLocaleDateString('en-IN', { 
//                   day: 'numeric', 
//                   month: 'short', 
//                   year: 'numeric' 
//                 })}
//               </span>
//             </div>
//           </div>

//           {/* Transaction History */}
//           <div className="rv-sd-section">
//             <h4 className="rv-sd-section-title">Transaction History</h4>
//             <div className="rv-sd-table-wrapper">
//               {transactions && transactions.length > 0 ? (
//                 <table className="rv-sd-table">
//                   <thead>
//                     <tr>
//                       <th>Date</th>
//                       <th>Type</th>
//                       <th>Amount</th>
//                       <th>Remarks</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {transactions.map((tx, index) => (
//                       <tr key={tx.TransactionID || index}>
//                         <td>{new Date(tx.TransactionDate).toLocaleDateString('en-IN', { 
//                           day: 'numeric', 
//                           month: 'short', 
//                           year: 'numeric',
//                           hour: '2-digit',
//                           minute: '2-digit'
//                         })}</td>
//                         <td>
//                           <span className={`rv-sd-transaction-type ${getStatusColorClass(tx.TransactionType)}`}>
//                             {tx.TransactionType}
//                           </span>
//                         </td>
//                         <td>{fmt(tx.Amount)}</td>
//                         <td>{tx.Remarks || '-'}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               ) : (
//                 <div className="rv-sd-empty">No transactions found</div>
//               )}
//             </div>
//           </div>

//           {/* Add Transaction Form */}
//           <div className="rv-sd-section rv-sd-action-section">
//             <h4 className="rv-sd-section-title">Add Transaction</h4>
            
//             <form onSubmit={handleSubmit}>
//               <div className="rv-sd-form-row">
//                 <div className="rv-sd-form-group">
//                   <label className="rv-sd-form-label">Transaction Type</label>
//                   <select 
//                     className="rv-sd-form-select" 
//                     value={transactionType}
//                     onChange={(e) => setTransactionType(e.target.value)}
//                     required
//                   >
//                     <option value="">Select Type</option>
//                     <option value="RECEIVED">RECEIVED</option>
//                     <option value="ADJUSTED">ADJUSTED</option>
//                     <option value="REFUND">REFUND</option>
//                   </select>
//                 </div>

//                 <div className="rv-sd-form-group">
//                   <label className="rv-sd-form-label">Amount</label>
//                   <input 
//                     type="number" 
//                     className="rv-sd-form-input" 
//                     placeholder="Enter amount"
//                     value={amount}
//                     onChange={(e) => setAmount(e.target.value)}
//                     step="0.01"
//                     min="0.01"
//                     required
//                   />
//                 </div>
//               </div>

//               {/* Additional fields for ADJUSTED */}
//               {transactionType === 'ADJUSTED' && (
//                 <div className="rv-sd-form-row" style={{ marginTop: '12px' }}>
//                   <div className="rv-sd-form-group">
//                     <label className="rv-sd-form-label">Reference Type</label>
//                     <select 
//                       className="rv-sd-form-select"
//                       value={referenceType}
//                       onChange={(e) => {
//                         setReferenceType(e.target.value)
//                         if (e.target.value === 'TENANTEXPENSE') {
//                           setReferenceId('9') // Default reference ID for TENANTEXPENSE
//                         }else if (e.target.value === 'RENTINVOICE') {
//                           setReferenceId('3') // Clear reference ID for RENTINVOICE
//                         }else if (e.target.value === 'ELECTRICITY') {
//                           setReferenceId('6') // Clear reference ID for ELECTRICITY
//                         }else if (e.target.value === 'FOOD') {
//                           setReferenceId('7') // Clear reference ID for FOOD
//                         }
                      
//                       }}
//                       required
//                     >
//                       <option value="TENANTEXPENSE">Tenant Expense</option>
//                       <option value="RENTINVOICE">Rent Invoice</option>
//                       <option value="ELECTRICITY">Electricity</option>
//                       <option value="FOOD">Food</option>
//                     </select>
//                   </div>
//                   {/* <div className="rv-sd-form-group">
//                     <label className="rv-sd-form-label">Reference ID</label>
//                     <input 
//                       type="number" 
//                       className="rv-sd-form-input"
//                       placeholder="Enter reference ID"
//                       value={referenceId}
//                       onChange={(e) => setReferenceId(e.target.value)}
//                       required
//                     />
//                   </div> */}
//                 </div>
//               )}

//               {/* Additional fields for REFUND */}
//               {transactionType === 'REFUND' && (
//                 <div className="rv-sd-form-row" style={{ marginTop: '12px' }}>
//                   <div className="rv-sd-form-group">
//                     <label className="rv-sd-form-label">Payment Mode</label>
//                     <select 
//                       className="rv-sd-form-select"
//                       value={paymentMode}
//                       onChange={(e) => setPaymentMode(e.target.value)}
//                     >
//                       <option value="CASH">Cash</option>
//                       <option value="UPI">UPI</option>
//                       <option value="BANK">Bank Transfer</option>
//                       <option value="CHEQUE">Cheque</option>
//                     </select>
//                   </div>
//                   <div className="rv-sd-form-group">
//                     <label className="rv-sd-form-label">Reference No</label>
//                     <input 
//                       type="text" 
//                       className="rv-sd-form-input"
//                       placeholder="Enter reference number"
//                       value={referenceNo}
//                       onChange={(e) => setReferenceNo(e.target.value)}
//                     />
//                   </div>
//                 </div>
//               )}

//               {message && (
//                 <div className={`rv-sd-message rv-sd-message-${messageType}`}>
//                   {message}
//                 </div>
//               )}

//               <div className="rv-sd-form-actions">
//                 <button 
//                   type="button" 
//                   className="rv-sd-btn rv-sd-btn-secondary"
//                   onClick={resetForm}
//                 >
//                   Cancel
//                 </button>
//                 <button 
//                   type="submit" 
//                   className="rv-sd-btn rv-sd-btn-primary"
//                   disabled={isSubmitting}
//                 >
//                   {isSubmitting ? (
//                     <>
//                       <span className="rv-sd-spinner"></span>
//                       Processing...
//                     </>
//                   ) : (
//                     'Submit'
//                   )}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

const SecurityDepositModal = ({ depositData, admissionId, onClose, onTransactionComplete }) => {
  const [transactionType, setTransactionType] = useState('')
  const [amount, setAmount] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState('success')
  const [transactions, setTransactions] = useState([])
  const [depositInfo, setDepositInfo] = useState(null)
  
  // Additional fields for ADJUSTED
  const [referenceType, setReferenceType] = useState('TENANTEXPENSE')
  const [referenceId, setReferenceId] = useState('9')
  const [adjustPaymentMode, setAdjustPaymentMode] = useState('CASH') // NEW: Payment mode for ADJUSTED
  const [adjustReferenceNo, setAdjustReferenceNo] = useState('') // NEW: Reference No for ADJUSTED
  
  // Additional fields for REFUND
  const [paymentMode, setPaymentMode] = useState('CASH')
  const [referenceNo, setReferenceNo] = useState('')

  // Load deposit data with transactions
  useEffect(() => {
    if (depositData) {
      setDepositInfo(depositData)
      setTransactions(depositData.Transactions || [])
    }
  }, [depositData])



  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!transactionType || !amount || parseFloat(amount) <= 0) {
      setMessage('Please select transaction type and enter a valid amount')
      setMessageType('error')
      return
    }

    setIsSubmitting(true)
    setMessage('')

    try {
      const parsedAmount = parseFloat(amount)
      const userId = parseInt(localStorage.getItem('userId') || 1)
      let response

      switch (transactionType) {
        case 'RECEIVED':
          response = await receiveSecurityDeposit({
            AdmissionID: admissionId,
            Amount: parsedAmount,
            CreatedBy: userId
          })
          break

        case 'ADJUSTED':
          if (!depositInfo?.DepositID) {
            throw new Error('Deposit ID not found')
          }
          response = await adjustSecurityDeposit({
            DepositID: depositInfo.DepositID,
            ReferenceType: referenceType || 'TENANTEXPENSE',
            ReferenceID: parseInt(referenceId) || 9,
            Amount: parsedAmount,
            PaymentMode: adjustPaymentMode || 'CASH', // NEW: Payment mode for adjustment
            ReferenceNo: adjustReferenceNo || null, // NEW: Reference No for adjustment
            Remarks: `Security deposit adjustment - ${referenceType}`,
            CreatedBy: userId
          })
          break

        case 'REFUND':
          if (!depositInfo?.DepositID) {
            throw new Error('Deposit ID not found')
          }
          response = await refundSecurityDeposit({
            DepositID: depositInfo.DepositID,
            RefundAmount: parsedAmount,
            RefundDate: new Date().toISOString().split('T')[0],
            PaymentMode: paymentMode || 'CASH',
            ReferenceNo: referenceNo || null,
            Remarks: 'Security deposit refund',
            CreatedBy: userId
          })
          break

        default:
          throw new Error('Invalid transaction type')
      }

      // Check if response indicates success
      if (response && response.success === false) {
        throw new Error(response.message || 'Transaction failed')
      }

      setMessage('Transaction completed successfully!')
      setMessageType('success')
      
      // Refresh deposit data
      const updatedDeposit = await getSecurityDeposit(admissionId)
      if (updatedDeposit?.data) {
        setDepositInfo(updatedDeposit.data)
        setTransactions(updatedDeposit.data.Transactions || [])
        if (onTransactionComplete) {
          onTransactionComplete(updatedDeposit.data)
        }
      }

      // Reset form
      setTransactionType('')
      setAmount('')
      setReferenceType('TENANTEXPENSE')
      setReferenceId('9')
      setAdjustPaymentMode('CASH')
      setAdjustReferenceNo('')
      setPaymentMode('CASH')
      setReferenceNo('')
      
      // Auto close after 2 seconds
      setTimeout(() => {
        onClose()
      }, 2000)

    } catch (error) {
      console.error('Transaction error:', error)
      setMessage(error.message || 'Transaction failed. Please try again.')
      setMessageType('error')
    } finally {
      setIsSubmitting(false)
    }
  }

  const resetForm = () => {
    setTransactionType('')
    setAmount('')
    setReferenceType('TENANTEXPENSE')
    setReferenceId('9')
    setAdjustPaymentMode('CASH')
    setAdjustReferenceNo('')
    setPaymentMode('CASH')
    setReferenceNo('')
    setMessage('')
    setTimeout(() => {
      onClose()
    }, 200)
  }

  if (!depositInfo) {
    return (
      <div className="rv-modal-overlay" onClick={onClose}>
        <div className="rv-sd-modal" onClick={e => e.stopPropagation()}>
          <div className="rv-sd-head">
            <h3 className="rv-sd-title">Security Deposit Details</h3>
            <button className="rv-sd-close" onClick={onClose}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>
          <div className="rv-sd-body">
            <div className="rv-sd-loading">No deposit details found</div>
          </div>
        </div>
      </div>
    )
  }

  const statusColor = {
    PAID: 'rv-sd-status-paid',
    PARTIAL: 'rv-sd-status-partial',
    PENDING: 'rv-sd-status-pending',
    CLOSED: 'rv-sd-status-closed'
  }[depositInfo.Status] || ''

  const getStatusColorClass = (transactionType) => {
    switch(transactionType) {
      case 'RECEIVED': return 'rv-sd-type-received'
      case 'ADJUSTED': return 'rv-sd-type-adjusted'
      case 'REFUND': return 'rv-sd-type-refund'
      default: return ''
    }
  }

  return (
    <div className="rv-modal-overlay" onClick={onClose}>
      <div className="rv-sd-modal" onClick={e => e.stopPropagation()}>
        <div className="rv-sd-head">
          <h3 className="rv-sd-title">Security Deposit Details</h3>
          <button className="rv-sd-close" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <div className="rv-sd-body">
          {/* Deposit Information Grid */}
          <div className="rv-sd-info-grid">
            <div className="rv-sd-info-item">
              <span className="rv-sd-label">Security Deposit</span>
              <span className="rv-sd-value rv-sd-deposit">{fmt(depositInfo.DepositAmount)}</span>
            </div>
            <div className="rv-sd-info-item">
              <span className="rv-sd-label">Security Received</span>
              <span className="rv-sd-value rv-sd-received">{fmt(depositInfo.ReceivedAmount)}</span>
            </div>
            <div className="rv-sd-info-item">
              <span className="rv-sd-label">Security Pending</span>
              <span className="rv-sd-value rv-sd-received">{fmt(depositInfo.DepositAmount-depositInfo.ReceivedAmount)}</span>
            </div>
            <div className="rv-sd-info-item">
              <span className="rv-sd-label">Amount Adjusted</span>
              <span className="rv-sd-value">{fmt(depositInfo.AdjustedAmount)}</span>
            </div>
            {/* <div className="rv-sd-info-item">
              <span className="rv-sd-label">Refund Amount</span>
              <span className="rv-sd-value">{fmt(depositInfo.RefundAmount)}</span>
            </div> */}
            <div className="rv-sd-info-item">
              <span className="rv-sd-label">Security Remaining</span>
              <span className="rv-sd-value rv-sd-balance">{fmt(depositInfo.Balance)}</span>
            </div>
            {/* <div className="rv-sd-info-item">
              <span className="rv-sd-label">Status</span>
              <span className={`rv-sd-status ${statusColor}`}>
                {depositInfo.Status || 'N/A'}
              </span>
            </div> */}
            {/* <div className="rv-sd-info-item">
              <span className="rv-sd-label">Deposit Date</span>
              <span className="rv-sd-value">
                {new Date(depositInfo.DepositDate).toLocaleDateString('en-IN', { 
                  day: 'numeric', 
                  month: 'short', 
                  year: 'numeric' 
                })}
              </span>
            </div> */}
          </div>

          {/* Transaction History */}
          <div className="rv-sd-section">
            <h4 className="rv-sd-section-title">Transaction History</h4>
            <div className="rv-sd-table-wrapper">
              {transactions && transactions.length > 0 ? (
                <table className="rv-sd-table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Type</th>
                      <th>Amount</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactions.map((tx, index) => (
                      <tr key={tx.TransactionID || index}>
                        <td>{new Date(tx.TransactionDate).toLocaleDateString('en-IN', { 
                          day: 'numeric', 
                          month: 'short', 
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        })}</td>
                        <td>
                          <span className={`rv-sd-transaction-type ${getStatusColorClass(tx.TransactionType)}`}>
                            {tx.TransactionType}
                          </span>
                        </td>
                        <td>{fmt(tx.Amount)}</td>
                        <td>{tx.Remarks || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="rv-sd-empty">No transactions found</div>
              )}
            </div>
          </div>

          {/* Add Transaction Form */}
          <div className="rv-sd-section rv-sd-action-section">
            <h4 className="rv-sd-section-title">Add Transaction</h4>
            
            <form onSubmit={handleSubmit}>
              <div className="rv-sd-form-row">
                <div className="rv-sd-form-group">
                  <label className="rv-sd-form-label">Transaction Type</label>
                  <select 
                    className="rv-sd-form-select" 
                    value={transactionType}
                    onChange={(e) => setTransactionType(e.target.value)}
                    required
                  >
                    <option value="">Select Type</option>
                    <option value="RECEIVED">RECEIVED</option>
                    <option value="ADJUSTED">ADJUSTED</option>
                    {/* <option value="REFUND">REFUND</option> */}
                  </select>
                </div>

                <div className="rv-sd-form-group">
                  <label className="rv-sd-form-label">Amount</label>
                  <input 
                    type="number" 
                    className="rv-sd-form-input" 
                    placeholder="Enter amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    step="0.01"
                    min="0.01"
                    required
                  />
                </div>
              </div>

              {/* Additional fields for ADJUSTED */}
              {transactionType === 'ADJUSTED' && (
                <>
                

                  {/* NEW: Payment Mode and Reference No for ADJUSTED */}
                  <div className="rv-sd-form-row" style={{ marginTop: '12px' }}>
                    <div className="rv-sd-form-group">
                      <label className="rv-sd-form-label">Payment Mode</label>
                      <select 
                        className="rv-sd-form-select"
                        value={adjustPaymentMode}
                        onChange={(e) => setAdjustPaymentMode(e.target.value)}
                      >
                        <option value="CASH">Cash</option>
                        <option value="UPI">UPI</option>
                        <option value="BANK">Bank Transfer</option>
                        <option value="CHEQUE">Cheque</option>
                      </select>
                    </div>
                    <div className="rv-sd-form-group">
                      <label className="rv-sd-form-label">Reference No</label>
                      <input 
                        type="text" 
                        className="rv-sd-form-input"
                        placeholder="Enter reference number"
                        value={adjustReferenceNo}
                        onChange={(e) => setAdjustReferenceNo(e.target.value)}
                      />
                    </div>
                  </div>

                    <div className="rv-sd-form-row" style={{ marginTop: '12px' }}>
                    <div className="rv-sd-form-group">
                      <label className="rv-sd-form-label">Adjustment Head</label>
                      <select 
                        className="rv-sd-form-select"
                        value={referenceType}
                        onChange={(e) => {
                          setReferenceType(e.target.value)
                          if (e.target.value === 'TENANTEXPENSE') {
                            setReferenceId('9')
                          } else if (e.target.value === 'RENTINVOICE') {
                            setReferenceId('3')
                          } else if (e.target.value === 'ELECTRICITY') {
                            setReferenceId('6')
                          } else if (e.target.value === 'FOOD') {
                            setReferenceId('7')
                          }
                        }}
                        required
                      >
                        <option value="TENANTEXPENSE">Tenant Expense</option>
                        <option value="RENTINVOICE">Rent Invoice</option>
                        <option value="ELECTRICITY">Electricity</option>
                        <option value="FOOD">Food</option>
                      </select>
                    </div>
                  </div>
                </>
              )}

              {/* Additional fields for REFUND */}
              {transactionType === 'REFUND' && (
                <div className="rv-sd-form-row" style={{ marginTop: '12px' }}>
                  <div className="rv-sd-form-group">
                    <label className="rv-sd-form-label">Payment Mode</label>
                    <select 
                      className="rv-sd-form-select"
                      value={paymentMode}
                      onChange={(e) => setPaymentMode(e.target.value)}
                    >
                      <option value="CASH">Cash</option>
                      <option value="UPI">UPI</option>
                      <option value="BANK">Bank Transfer</option>
                      <option value="CHEQUE">Cheque</option>
                    </select>
                  </div>
                  <div className="rv-sd-form-group">
                    <label className="rv-sd-form-label">Reference No</label>
                    <input 
                      type="text" 
                      className="rv-sd-form-input"
                      placeholder="Enter reference number"
                      value={referenceNo}
                      onChange={(e) => setReferenceNo(e.target.value)}
                    />
                  </div>
                </div>
              )}

              {message && (
                <div className={`rv-sd-message rv-sd-message-${messageType}`}>
                  {message}
                </div>
              )}

              <div className="rv-sd-form-actions">
                <button 
                  type="button" 
                  className="rv-sd-btn rv-sd-btn-secondary"
                  onClick={resetForm}
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  className="rv-sd-btn rv-sd-btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="rv-sd-spinner"></span>
                      Processing...
                    </>
                  ) : (
                    'Submit'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}


// const SecurityDepositModal = ({ depositData, onClose }) => {
//   if (!depositData) return null

//   return (
//     <div className="rv-modal-overlay" onClick={onClose}>
//       <div className="rv-sd-modal" onClick={e => e.stopPropagation()}>
//         <div className="rv-sd-head">
//           <h3 className="rv-sd-title">Security Deposit Details</h3>
//           <button className="rv-sd-close" onClick={onClose}>
//             <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//               <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
//             </svg>
//           </button>
//         </div>
//         <div className="rv-sd-body">
//           <div className="rv-sd-row">
//             <span className="rv-sd-label">Deposit ID:</span>
//             <span className="rv-sd-value">{depositData.DepositID}</span>
//           </div>
//           <div className="rv-sd-row">
//             <span className="rv-sd-label">Deposit Amount:</span>
//             <span className="rv-sd-value">{fmt(depositData.DepositAmount)}</span>
//           </div>
//           <div className="rv-sd-row">
//             <span className="rv-sd-label">Received Amount:</span>
//             <span className="rv-sd-value rv-sd-received">{fmt(depositData.ReceivedAmount)}</span>
//           </div>
//           <div className="rv-sd-row">
//             <span className="rv-sd-label">Adjusted Amount:</span>
//             <span className="rv-sd-value">{fmt(depositData.AdjustedAmount)}</span>
//           </div>
//           <div className="rv-sd-row">
//             <span className="rv-sd-label">Refund Amount:</span>
//             <span className="rv-sd-value">{fmt(depositData.RefundAmount)}</span>
//           </div>
//           <div className="rv-sd-row">
//             <span className="rv-sd-label">Balance:</span>
//             <span className="rv-sd-value rv-sd-balance">{fmt(depositData.Balance)}</span>
//           </div>
//           <div className="rv-sd-row">
//             <span className="rv-sd-label">Status:</span>
//             <span className={`rv-sd-status rv-sd-status-${depositData.Status?.toLowerCase()}`}>
//               {depositData.Status}
//             </span>
//           </div>
//           <div className="rv-sd-row">
//             <span className="rv-sd-label">Deposit Date:</span>
//             <span className="rv-sd-value">{new Date(depositData.DepositDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
//           </div>
//           {depositData.RefundDate && (
//             <div className="rv-sd-row">
//               <span className="rv-sd-label">Refund Date:</span>
//               <span className="rv-sd-value">{new Date(depositData.RefundDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
//             </div>
//           )}
//           {depositData.Remarks && (
//             <div className="rv-sd-row">
//               <span className="rv-sd-label">Remarks:</span>
//               <span className="rv-sd-value">{depositData.Remarks}</span>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   )
// }

// ─── Pending Expenses Modal ────────────────────────────────

// ─── Pending Expenses Modal ────────────────────────────────
// ─── Pending Expenses Modal ────────────────────────────────

// ─── Pending Expenses Modal ────────────────────────────────
const PendingExpensesModal = ({ expenses, admissionId, pgId, onClose, onSuccess }) => {
  const [paymentAmount, setPaymentAmount] = useState('')
  const [paymentMode, setPaymentMode] = useState('CASH')
  const [narration, setNarration] = useState('')
  const [isProcessing, setIsProcessing] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState('success')
  const [referenceNo, setReferenceNo] = useState('') 

  // Calculate total pending amount
  const totalPendingAmount = expenses.reduce((sum, expense) => sum + (expense.NetPayable || 0), 0)

  // Validate payment amount
  const isPaymentValid = () => {
    if (!paymentAmount) return false
    const amount = parseFloat(paymentAmount)
    return amount > 0 && amount <= totalPendingAmount
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    const amount = parseFloat(paymentAmount)
    
    if (!paymentAmount || amount <= 0) {
      setMessage('Please enter a valid payment amount')
      setMessageType('error')
      return
    }

    if (amount > totalPendingAmount) {
      setMessage(`Payment amount cannot exceed total pending amount of ${fmt(totalPendingAmount)}`)
      setMessageType('error')
      return
    }

    if (!admissionId) {
      setMessage('Admission ID not found')
      setMessageType('error')
      return
    }

    setIsProcessing(true)
    setMessage('')

    try {
      const response = await receiveTenantExpense({
        AdmissionID: admissionId,
        Amount: amount,
        PaymentMode: paymentMode,
        Narration: narration || `Payment against pending expenses`,
        ReferenceNo: referenceNo.trim() || '',
        UserID: parseInt(localStorage.getItem('userId')) || 1,
      })

      if (response && response.success === false) {
        throw new Error(response.message || 'Payment failed')
      }

      setMessage(`Payment of ${fmt(amount)} received successfully!`)
      setMessageType('success')
      
      // Reset form
      setPaymentAmount('')
      setNarration('')
      setReferenceNo('')
      
      // Notify parent to refresh data
      if (onSuccess) {
        onSuccess()
      }

      // Auto close after 2 seconds
      setTimeout(() => {
        onClose()
      }, 2000)

    } catch (error) {
      console.error('Payment error:', error)
      setMessage(error.message || 'Payment failed. Please try again.')
      setMessageType('error')
    } finally {
      setIsProcessing(false)
    }
  }

  const resetForm = () => {
    setPaymentAmount('')
    setNarration('')
    setReferenceNo('')
    setMessage('')
     setTimeout(() => {
        onClose()
      }, 200)
  }

  if (!expenses || expenses.length === 0) {
    return (
      <div className="rv-modal-overlay" onClick={onClose}>
        <div className="rv-pe-modal" onClick={e => e.stopPropagation()}>
          <div className="rv-pe-head">
            <h3 className="rv-pe-title">Pending Expenses</h3>
            <button className="rv-pe-close" onClick={onClose}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>
          <div className="rv-pe-body">
            <p className="rv-pe-empty">No pending expenses found</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="rv-modal-overlay" onClick={onClose}>
      <div className="rv-pe-modal" onClick={e => e.stopPropagation()}>
        <div className="rv-pe-head">
          <h3 className="rv-pe-title">Pending Expenses</h3>
          <button className="rv-pe-close" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <div className="rv-pe-body">
          {/* Expense List - No Checkboxes */}
          <div className="rv-pe-table-wrapper">
            <table className="rv-pe-table">
              <thead>
                <tr>
                  {/* <th>Expense ID</th> */}
                  <th>Expense</th>
                  <th>Expense Date</th>
                  <th>Amount</th>
                  <th>Adjusted Amount</th>
                  <th>Paid Amount</th>
                  <th>Net Payable</th>
                  <th>Description</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {expenses.map((expense) => (
                  <tr key={expense.ExpenseID}>
                    {/* <td>{expense.ExpenseID}</td> */}
                    <td>{expense.LedgerName}</td>
                    <td>{new Date(expense.ExpenseDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</td>
                    <td className="rv-pe-amount">{fmt(expense.Amount)}</td>
                    <td className="rv-pe-amount" style={{ fontWeight: '700' }}>
                      {fmt(expense.AdvanceAdjusted || 0)}
                    </td>
                      <td className="rv-pe-amount" style={{ fontWeight: '700' }}>
                      {fmt(expense.PaidAmount || 0)}
                    </td> 
                    <td className="rv-pe-amount" style={{ fontWeight: '700' }}>
                      {fmt(expense.NetPayable || 0)}
                    </td>
                    <td>{expense.Description || '-'}</td>
                    <td>{expense.Status || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Total Pending Amount */}
          <div className="rv-pe-total">
            <span>Total Pending Amount:</span>
            <strong style={{ color: '#2563EB' }}>{fmt(totalPendingAmount)}</strong>
          </div>

          {/* Payment Form */}
          {/* <div className="rv-pe-payment-section">
            <h4 className="rv-pe-section-title">Make Payment</h4>
            
            <form onSubmit={handleSubmit}>
              <div className="rv-pe-form-row">
                <div className="rv-pe-form-group">
                  <label className="rv-pe-form-label">Payment Amount</label>
                  <div className="rv-pe-amount-input-wrap">
                    <span className="rv-pe-currency-symbol">₹</span>
                    <input
                      type="number"
                      className={`rv-pe-form-input ${paymentAmount && parseFloat(paymentAmount) > totalPendingAmount ? 'rv-pe-form-input-error' : ''}`}
                      placeholder="Enter amount"
                      value={paymentAmount}
                      onChange={(e) => {
                        const value = e.target.value
                        setPaymentAmount(value)
                        // Clear message when user types
                        if (message) setMessage('')
                      }}
                      step="0.01"
                      min="0.01"
                      max={totalPendingAmount}
                      required
                    />
                  </div>
                  {paymentAmount && parseFloat(paymentAmount) > totalPendingAmount && (
                    <span className="rv-pe-form-hint rv-pe-form-hint-error">
                      Amount exceeds total pending amount
                    </span>
                  )}
                  {paymentAmount && parseFloat(paymentAmount) <= totalPendingAmount && parseFloat(paymentAmount) > 0 && (
                    <span className="rv-pe-form-hint rv-pe-form-hint-success">
                      ✓ Valid amount
                    </span>
                  )}
                </div>

                <div className="rv-pe-form-group">
                  <label className="rv-pe-form-label">Payment Mode</label>
                  <select
                    className="rv-pe-form-select"
                    value={paymentMode}
                    onChange={(e) => setPaymentMode(e.target.value)}
                    required
                  >
                    <option value="CASH">💵 Cash</option>
                    <option value="UPI">📱 UPI</option>
                    <option value="BANK">🏦 Bank Transfer</option>
                    <option value="CHEQUE">📝 Cheque</option>
                  </select>
                </div>
              </div>

              <div className="rv-pe-form-row">
                <div className="rv-pe-form-group" style={{ marginTop: '12px' }}>
                  <label className="rv-pe-form-label">Reference No</label>
                  <input
                    type="text"
                    className="rv-pe-form-input"
                    placeholder="Enter Reference number"
                    value={referenceNo}
                    onChange={(e) => setReferenceNo(e.target.value)}
                  />
                </div>

                <div className="rv-pe-form-group" style={{ marginTop: '12px' }}>
                  <label className="rv-pe-form-label">Narration</label>
                  <input
                    type="text"
                    className="rv-pe-form-input"
                    placeholder="Enter narration"
                    value={narration}
                    onChange={(e) => setNarration(e.target.value)}
                  />
                </div>
              </div>


              {message && (
                <div className={`rv-pe-message rv-pe-message-${messageType}`}>
                  {message}
                </div>
              )}

              <div className="rv-pe-form-actions">
                <button
                  type="button"
                  className="rv-pe-btn rv-pe-btn-secondary"
                  onClick={resetForm}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="rv-pe-btn rv-pe-btn-primary"
                  disabled={isProcessing || !isPaymentValid()}
                >
                  {isProcessing ? (
                    <>
                      <span className="rv-pe-spinner"></span>
                      Processing...
                    </>
                  ) : (
                    `Pay ${paymentAmount ? fmt(parseFloat(paymentAmount)) : ''}`
                  )}
                </button>
              </div>
            </form>
          </div> */}
        </div>
      </div>
    </div>
  )
}


// ─── Overall Rent Modal ────────────────────────────────────────────────
const OverallRentModal = ({ 
  admissionId, 
  onClose, 
  onSuccess,
  overallDueData 
}) => {
  const [formData, setFormData] = useState({
    RentAmount: '',
    ElectricityAmount: '',
    ExpenseAmount: '',
    PaymentMode: 'CASH',
    ReferenceNo: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('success');
  const [errors, setErrors] = useState({});

  // Auto-fill amounts from overall due data
  // useEffect(() => {
  //   if (overallDueData) {
  //     setFormData(prev => ({
  //       ...prev,
  //       RentAmount: overallDueData.RentNetPayable?.toString() || '',
  //       ElectricityAmount: overallDueData.ElectricityNetPayable?.toString() || '',
  //       ExpenseAmount: overallDueData.ExpenseNetPayable?.toString() || ''
  //     }));
  //   }
  // }, [overallDueData]);

 
  const validate = () => {
    const newErrors = {};
    const { RentAmount, ElectricityAmount, ExpenseAmount, PaymentMode } = formData;

    // At least one amount should be > 0
    const rent = parseFloat(RentAmount) || 0;
    const electricity = parseFloat(ElectricityAmount) || 0;
    const expense = parseFloat(ExpenseAmount) || 0;

    if (rent <= 0 && electricity <= 0 && expense <= 0) {
      newErrors.general = 'At least one amount must be greater than 0';
    }

    if (!PaymentMode) {
      newErrors.PaymentMode = 'Please select payment mode';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    setIsSubmitting(true);
    setMessage('');

    try {
      const userId = localStorage.getItem('userId') || 1; // Default to 1 if not found
      
      const payload = {
        AdmissionID: admissionId,
        RentAmount: parseFloat(formData.RentAmount) || 0,
        ElectricityAmount: parseFloat(formData.ElectricityAmount) || 0,
        ExpenseAmount: parseFloat(formData.ExpenseAmount) || 0,
        PaymentMode: formData.PaymentMode,
        DueinMonth: 0, // Always 0 as per requirement
        ReferenceNo: formData.ReferenceNo?.trim() || '',
        UserId: parseInt(userId)
      };

      console.log('Overall Payment Payload:', payload);

      const response = await processOverallPayment(payload);

      if (response?.success) {
        setMessage('Payment processed successfully!');
        setMessageType('success');
        
        if (onSuccess) {
          onSuccess();
        }

        setTimeout(() => {
          onClose();
        }, 1500);
      } else {
        throw new Error(response?.message || 'Payment failed');
      }
    } catch (error) {
      console.error('Error processing overall payment:', error);
      setMessage(error.message || 'Payment failed. Please try again.');
      setMessageType('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    // Clear error for this field
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
    if (errors.general) {
      setErrors(prev => ({ ...prev, general: '' }));
    }
  };

  return (
    <div className="rv-modal-overlay" onClick={onClose}>
      <div className="rv-or-modal" onClick={e => e.stopPropagation()}>
        <div className="rv-or-head">
          <h3 className="rv-or-title">Overall Rent Payment</h3>
          <button className="rv-or-close" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <div className="rv-or-body">
          {/* Overall Due Summary */}
          {overallDueData && (
            <div className="rv-or-summary">
              <h4 className="rv-or-summary-title">Overall Due Summary</h4>
              <div className="rv-or-summary-grid">
                <div className="rv-or-summary-item">
                  <span className="rv-or-summary-label">Rent Due</span>
                  <span className="rv-or-summary-value">{fmt(overallDueData.RentNetPayable || 0)}</span>
                </div>
                <div className="rv-or-summary-item">
                  <span className="rv-or-summary-label">Electricity Due</span>
                  <span className="rv-or-summary-value">{fmt(overallDueData.ElectricityNetPayable || 0)}</span>
                </div>
                <div className="rv-or-summary-item">
                  <span className="rv-or-summary-label">Expense Due</span>
                  <span className="rv-or-summary-value">{fmt(overallDueData.ExpenseNetPayable || 0)}</span>
                </div>
                <div className="rv-or-summary-item rv-or-summary-total">
                  <span className="rv-or-summary-label">Total Due</span>
                  <span className="rv-or-summary-value rv-or-total-amount">{fmt(overallDueData.TotalDue || 0)}</span>
                </div>
              </div>
            </div>
          )}

          {/* Payment Form */}
          <div className="rv-or-form">
            <div className="rv-or-form-row">
              <div className="rv-or-form-group">
                <label className="rv-or-form-label">
                  Rent Amount
                </label>
                <input
                  type="number"
                  className="rv-or-form-input"
                  placeholder="Enter rent amount"
                  value={formData.RentAmount}
                  onChange={(e) => handleChange('RentAmount', e.target.value)}
                  step="0.01"
                  min="0"
                />
              </div>

              <div className="rv-or-form-group">
                <label className="rv-or-form-label">
                  Electricity Amount
                </label>
                <input
                  type="number"
                  className="rv-or-form-input"
                  placeholder="Enter electricity amount"
                  value={formData.ElectricityAmount}
                  onChange={(e) => handleChange('ElectricityAmount', e.target.value)}
                  step="0.01"
                  min="0"
                />
              </div>
            </div>

            <div className="rv-or-form-row">
              <div className="rv-or-form-group">
                <label className="rv-or-form-label">
                  Expense Amount
                </label>
                <input
                  type="number"
                  className="rv-or-form-input"
                  placeholder="Enter expense amount"
                  value={formData.ExpenseAmount}
                  onChange={(e) => handleChange('ExpenseAmount', e.target.value)}
                  step="0.01"
                  min="0"
                />
              </div>

              <div className="rv-or-form-group">
                <label className="rv-or-form-label">
                  Payment Mode <span className="rv-required">*</span>
                </label>
                <select
                  className={`rv-or-form-select ${errors.PaymentMode ? 'rv-or-form-error' : ''}`}
                  value={formData.PaymentMode}
                  onChange={(e) => handleChange('PaymentMode', e.target.value)}
                >
                  <option value="CASH">💵 Cash</option>
                  <option value="UPI">📱 UPI</option>
                  <option value="BANK">🏦 Bank Transfer</option>
                  <option value="CHEQUE">📝 Cheque</option>
                </select>
                {errors.PaymentMode && (
                  <span className="rv-or-error-text">{errors.PaymentMode}</span>
                )}
              </div>
            </div>

            <div className="rv-or-form-row">
              <div className="rv-or-form-group rv-or-form-full">
                <label className="rv-or-form-label">Reference No</label>
                <input
                  type="text"
                  className="rv-or-form-input"
                  placeholder="Enter reference number"
                  value={formData.ReferenceNo}
                  onChange={(e) => handleChange('ReferenceNo', e.target.value)}
                />
              </div>
            </div>

            {errors.general && (
              <div className="rv-or-error-text rv-or-error-general">
                {errors.general}
              </div>
            )}

            {message && (
              <div className={`rv-or-message rv-or-message-${messageType}`}>
                {message}
              </div>
            )}

            <div className="rv-or-form-actions">
              <button
                type="button"
                className="rv-or-btn rv-or-btn-secondary"
                onClick={onClose}
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <button
                type="button"
                className="rv-or-btn rv-or-btn-primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span className="rv-or-spinner"></span>
                    Processing...
                  </>
                ) : (
                  'Submit Payment'
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


// const PendingExpensesModal = ({ expenses, admissionId, pgId, onClose, onSuccess }) => {
//   const [selectedExpenses, setSelectedExpenses] = useState([])
//   const [paymentAmount, setPaymentAmount] = useState('')
//   const [paymentMode, setPaymentMode] = useState('CASH')
//   const [narration, setNarration] = useState('')
//   const [isProcessing, setIsProcessing] = useState(false)
//   const [message, setMessage] = useState('')
//   const [messageType, setMessageType] = useState('success')
//   const [selectAll, setSelectAll] = useState(false)

//   // Calculate total selected amount
//   const totalSelectedAmount = selectedExpenses.reduce((sum, expenseId) => {
//     const expense = expenses.find(e => e.ExpenseID === expenseId)
//     return sum + (expense?.NetPayable || 0)
//   }, 0)

//   // Auto-set payment amount when expenses are selected
//   useEffect(() => {
//     if (totalSelectedAmount > 0) {
//       setPaymentAmount(totalSelectedAmount.toString())
//     } else {
//       setPaymentAmount('')
//     }
//   }, [selectedExpenses, totalSelectedAmount])

//   const handleSelectExpense = (expenseId) => {
//     setSelectedExpenses(prev => {
//       if (prev.includes(expenseId)) {
//         return prev.filter(id => id !== expenseId)
//       } else {
//         return [...prev, expenseId]
//       }
//     })
//   }

//   const handleSelectAll = () => {
//     if (selectAll) {
//       setSelectedExpenses([])
//     } else {
//       setSelectedExpenses(expenses.map(e => e.ExpenseID))
//     }
//     setSelectAll(!selectAll)
//   }

//   const handleSubmit = async (e) => {
//     e.preventDefault()
    
//     if (selectedExpenses.length === 0) {
//       setMessage('Please select at least one expense to pay')
//       setMessageType('error')
//       return
//     }

//     if (!paymentAmount || parseFloat(paymentAmount) <= 0) {
//       setMessage('Please enter a valid payment amount')
//       setMessageType('error')
//       return
//     }

//     if (!admissionId) {
//       setMessage('Admission ID not found')
//       setMessageType('error')
//       return
//     }

//     setIsProcessing(true)
//     setMessage('')

//     try {
//       const response = await receiveTenantExpense({
//         AdmissionID: admissionId,
//         Amount: parseFloat(paymentAmount),
//         PaymentMode: paymentMode,
//         Narration: narration || `Payment for ${selectedExpenses.length} expense(s)`,
//         UserID: 1
//       })

//       if (response && response.success === false) {
//         throw new Error(response.message || 'Payment failed')
//       }

//       setMessage(`Payment of ${fmt(parseFloat(paymentAmount))} received successfully!`)
//       setMessageType('success')
      
//       // Reset form
//       setSelectedExpenses([])
//       setSelectAll(false)
//       setPaymentAmount('')
//       setNarration('')
      
//       // Notify parent to refresh data
//       if (onSuccess) {
//         onSuccess()
//       }

//       // Auto close after 2 seconds
//       setTimeout(() => {
//         onClose()
//       }, 2000)

//     } catch (error) {
//       console.error('Payment error:', error)
//       setMessage(error.message || 'Payment failed. Please try again.')
//       setMessageType('error')
//     } finally {
//       setIsProcessing(false)
//     }
//   }

//   const resetForm = () => {
//     setSelectedExpenses([])
//     setSelectAll(false)
//     setPaymentAmount('')
//     setNarration('')
//     setMessage('')
//   }

//   if (!expenses || expenses.length === 0) {
//     return (
//       <div className="rv-modal-overlay" onClick={onClose}>
//         <div className="rv-pe-modal" onClick={e => e.stopPropagation()}>
//           <div className="rv-pe-head">
//             <h3 className="rv-pe-title">Pending Expenses</h3>
//             <button className="rv-pe-close" onClick={onClose}>
//               <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//                 <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
//               </svg>
//             </button>
//           </div>
//           <div className="rv-pe-body">
//             <p className="rv-pe-empty">No pending expenses found</p>
//           </div>
//         </div>
//       </div>
//     )
//   }

//   return (
//     <div className="rv-modal-overlay" onClick={onClose}>
//       <div className="rv-pe-modal" onClick={e => e.stopPropagation()}>
//         <div className="rv-pe-head">
//           <h3 className="rv-pe-title">Pending Expenses</h3>
//           <button className="rv-pe-close" onClick={onClose}>
//             <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//               <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
//             </svg>
//           </button>
//         </div>

//         <div className="rv-pe-body">
//           {/* Expense List */}
//           <div className="rv-pe-table-wrapper">
//             <table className="rv-pe-table">
//               <thead>
//                 <tr>
//                   <th style={{ width: '40px' }}>
//                     <input
//                       type="checkbox"
//                       checked={selectAll}
//                       onChange={handleSelectAll}
//                     />
//                   </th>
//                   <th>Expense ID</th>
//                   <th>Ledger Name</th>
//                   <th>Expense Date</th>
//                   <th>Amount</th>
//                   <th>Net Payable</th>
//                   <th>Description</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {expenses.map((expense) => (
//                   <tr key={expense.ExpenseID}>
//                     <td>
//                       <input
//                         type="checkbox"
//                         checked={selectedExpenses.includes(expense.ExpenseID)}
//                         onChange={() => handleSelectExpense(expense.ExpenseID)}
//                       />
//                     </td>
//                     <td>{expense.ExpenseID}</td>
//                     <td>{expense.LedgerName}</td>
//                     <td>{new Date(expense.ExpenseDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</td>
//                     <td className="rv-pe-amount">{fmt(expense.Amount)}</td>
//                     <td className="rv-pe-amount" style={{ fontWeight: '700' }}>
//                       {fmt(expense.NetPayable || 0)}
//                     </td>
//                     <td>{expense.Description || '-'}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <div className="rv-pe-total">
//             <span>Selected Total:</span>
//             <strong style={{ color: '#2563EB' }}>{fmt(totalSelectedAmount)}</strong>
//           </div>

//           {/* Payment Form */}
//           <div className="rv-pe-payment-section">
//             <h4 className="rv-pe-section-title">Make Payment</h4>
            
//             <form onSubmit={handleSubmit}>
//               <div className="rv-pe-form-row">
//                 <div className="rv-pe-form-group">
//                   <label className="rv-pe-form-label">Payment Amount</label>
//                   <div className="rv-pe-amount-input-wrap">
//                     <span className="rv-pe-currency-symbol">₹</span>
//                     <input
//                       type="number"
//                       className="rv-pe-form-input"
//                       placeholder="Enter amount"
//                       value={paymentAmount}
//                       onChange={(e) => setPaymentAmount(e.target.value)}
//                       step="0.01"
//                       min="0.01"
//                       required
//                     />
//                   </div>
//                 </div>

//                 <div className="rv-pe-form-group">
//                   <label className="rv-pe-form-label">Payment Mode</label>
//                   <select
//                     className="rv-pe-form-select"
//                     value={paymentMode}
//                     onChange={(e) => setPaymentMode(e.target.value)}
//                     required
//                   >
//                     <option value="CASH">💵 Cash</option>
//                     <option value="UPI">📱 UPI</option>
//                     <option value="BANK">🏦 Bank Transfer</option>
//                     <option value="CHEQUE">📝 Cheque</option>
//                   </select>
//                 </div>
//               </div>

//               <div className="rv-pe-form-group" style={{ marginTop: '12px' }}>
//                 <label className="rv-pe-form-label">Narration (Optional)</label>
//                 <input
//                   type="text"
//                   className="rv-pe-form-input"
//                   placeholder="Enter narration"
//                   value={narration}
//                   onChange={(e) => setNarration(e.target.value)}
//                 />
//               </div>

//               {message && (
//                 <div className={`rv-pe-message rv-pe-message-${messageType}`}>
//                   {message}
//                 </div>
//               )}

//               <div className="rv-pe-form-actions">
//                 <button
//                   type="button"
//                   className="rv-pe-btn rv-pe-btn-secondary"
//                   onClick={resetForm}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="rv-pe-btn rv-pe-btn-primary"
//                   disabled={isProcessing || selectedExpenses.length === 0}
//                 >
//                   {isProcessing ? (
//                     <>
//                       <span className="rv-pe-spinner"></span>
//                       Processing...
//                     </>
//                   ) : (
//                     `Pay ${fmt(totalSelectedAmount)}`
//                   )}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }


// const PendingExpensesModal = ({ expenses, onClose }) => {
//   if (!expenses || expenses.length === 0) {
//     return (
//       <div className="rv-modal-overlay" onClick={onClose}>
//         <div className="rv-pe-modal" onClick={e => e.stopPropagation()}>
//           <div className="rv-pe-head">
//             <h3 className="rv-pe-title">Pending Expenses</h3>
//             <button className="rv-pe-close" onClick={onClose}>
//               <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//                 <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
//               </svg>
//             </button>
//           </div>
//           <div className="rv-pe-body">
//             <p className="rv-pe-empty">No pending expenses found</p>
//           </div>
//         </div>
//       </div>
//     )
//   }

//   return (
//     <div className="rv-modal-overlay" onClick={onClose}>
//       <div className="rv-pe-modal" onClick={e => e.stopPropagation()}>
//         <div className="rv-pe-head">
//           <h3 className="rv-pe-title">Pending Expenses</h3>
//           <button className="rv-pe-close" onClick={onClose}>
//             <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//               <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
//             </svg>
//           </button>
//         </div>
//         <div className="rv-pe-body">
//           <div className="rv-pe-table-wrapper">
//             <table className="rv-pe-table">
//               <thead>
//                 <tr>
//                   <th>Expense ID</th>
//                   <th>Ledger Name</th>
//                   <th>Expense Date</th>
//                   <th>Amount</th>
//                   <th>Description</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {expenses.map((expense, idx) => (
//                   <tr key={idx}>
//                     <td>{expense.ExpenseID}</td>
//                     <td>{expense.LedgerName}</td>
//                     <td>{new Date(expense.ExpenseDate).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</td>
//                     <td className="rv-pe-amount">{fmt(expense.Amount)}</td>
//                     <td>{expense.Description || '-'}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div className="rv-pe-total">
//             <span>Total Expenses:</span>
//             <strong>{fmt(expenses.reduce((sum, exp) => sum + (exp.Amount || 0), 0))}</strong>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// ─── RentPaymentModal (with Send Reminder button) ────────────────

// ─── RentPaymentModal (with Send Reminder button) ────────────────


// ─── RentPaymentModal (with Final Settlement section) ────────────────


const RentPaymentModal = ({ pgId, bed, onClose, onSuccess, onSendReminder }) => {
  const [paymentMode, setPaymentMode] = useState('CASH')
  const [netPayment, setNetPayment] = useState('')
  const [referenceNo, setReferenceNo] = useState('')
  const [isProcessing, setIsProcessing] = useState(false)
  const [error, setError] = useState('')
  const [tenantStatement, setTenantStatement] = useState([])
  const [isLoadingStatement, setIsLoadingStatement] = useState(false)
  

  // ─── State for Overall Rent Modal ──────────────────────────────
  const [showOverallRentModal, setShowOverallRentModal] = useState(false);
  const [overallDueData, setOverallDueData] = useState(null);
  const [isLoadingOverallDue, setIsLoadingOverallDue] = useState(false);


  // New state for security deposit and expenses
  const [securityDeposit, setSecurityDeposit] = useState(null)
  const [pendingExpenses, setPendingExpenses] = useState([])
  const [isLoadingDeposit, setIsLoadingDeposit] = useState(false)
  const [isLoadingExpenses, setIsLoadingExpenses] = useState(false)
  const [showSecurityModal, setShowSecurityModal] = useState(false)
  const [showExpensesModal, setShowExpensesModal] = useState(false)
  const [currentAdmissionId, setCurrentAdmissionId] = useState(null)

  // --- NEW: Final Settlement State ---
  const [settlementData, setSettlementData] = useState(null)
  const [isLoadingSettlement, setIsLoadingSettlement] = useState(false)
  const [isGeneratingSettlement, setIsGeneratingSettlement] = useState(false)
  const [isProcessingSettlement, setIsProcessingSettlement] = useState(false)
  const [settlementError, setSettlementError] = useState('')
  const [settlementSuccess, setSettlementSuccess] = useState('')
  const [showSettlementSection, setShowSettlementSection] = useState(false)
  const [isSettlementExpanded, setIsSettlementExpanded] = useState(false)
  
  // NEW: Settlement payment fields
  const [settleAmount, setSettleAmount] = useState('')
  const [amountReceived, setAmountReceived] = useState('')
  const [amountRefunded, setAmountRefunded] = useState('')
  const [checkoutDate, setCheckoutDate] = useState('')
  
  // Validation error for settlement
  const [settlementValidationError, setSettlementValidationError] = useState('')

  const statusColors = getStatusColor(bed?.rentStatus)
  const showReminder = ['DUE', 'OVERDUE', 'NOT PAID'].includes(bed?.rentStatus)



  // ─── Fetch Overall Due ──────────────────────────────────────────
  const fetchOverallDue = async () => {
    if (!bed?.admissionId) return;

    setIsLoadingOverallDue(true);
    try {
      const response = await getOverallDue(bed.admissionId);
      console.log('Overall Due Response:', response);
      if (response?.success && response?.data) {
        setOverallDueData(response.data);
      }
    } catch (error) {
      console.error('Error fetching overall due:', error);
    } finally {
      setIsLoadingOverallDue(false);
    }
  };

  // ─── Fetch Overall Due on Modal Open ────────────────────────────
  useEffect(() => {
    if (bed?.admissionId) {
      fetchOverallDue();
    }
  }, [bed?.admissionId]);


  const formatDate = (dateString) => {
    if (!dateString) return 'N/A'
    const date = new Date(dateString)
    return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
  }

  // Helper to parse number
  const parseNumber = (val) => {
    const num = parseFloat(val)
    return isNaN(num) ? 0 : num
  }

  // --- NEW: Validate settlement fields ---
  const validateSettlementFields = () => {
    const netPayable = parseNumber(settlementData?.NetPayable)
    const settle = parseNumber(settleAmount)
    const received = parseNumber(amountReceived)
    const refund = parseNumber(amountRefunded)

    // If NetPayable is 0, everything should be 0
    if (netPayable === 0) {
      if (settle !== 0 || received !== 0 || refund !== 0) {
        setSettlementValidationError('When Net Payable is 0, all settlement amounts must be 0')
        return false
      }
      setSettlementValidationError('')
      return true
    }

    // For positive NetPayable (tenant owes money)
    if (netPayable > 0) {
      // At least one of settleAmount or amountReceived should be > 0
      if (settle === 0 && received === 0) {
        setSettlementValidationError('Please enter either Settle Amount or Amount Received')
        return false
      }

      // Settle Amount + Amount Received must equal Net Payable
      if (settle + received !== netPayable) {
        setSettlementValidationError(
          `Settle Amount (₹${settle}) + Amount Received (₹${received}) must equal Net Payable (₹${netPayable})`
        )
        return false
      }

      // Amount Received cannot exceed Net Payable
      if (received > netPayable) {
        setSettlementValidationError(`Amount Received (₹${received}) cannot exceed Net Payable (₹${netPayable})`)
        return false
      }

      // Settle Amount cannot exceed Net Payable
      if (settle > netPayable) {
        setSettlementValidationError(`Settle Amount (₹${settle}) cannot exceed Net Payable (₹${netPayable})`)
        return false
      }

      // Amount Refunded should be 0 or empty when NetPayable > 0
      if (refund > 0) {
        setSettlementValidationError('Amount Refunded should be 0 when Net Payable is positive')
        return false
      }

      setSettlementValidationError('')
      return true
    }

    // For negative NetPayable (owner owes tenant money)
    if (netPayable < 0) {
      const absNetPayable = Math.abs(netPayable)

      // Settle Amount and Amount Received should be 0
      if (settle > 0 || received > 0) {
        setSettlementValidationError('Settle Amount and Amount Received should be 0 when Net Payable is negative')
        return false
      }

      // Amount Refunded should equal the absolute value of Net Payable
      if (refund !== absNetPayable) {
        setSettlementValidationError(
          `Amount Refunded (₹${refund}) must equal ${absNetPayable} (absolute value of Net Payable)`
        )
        return false
      }

      if (refund === 0) {
        setSettlementValidationError(`Amount Refunded must be ₹${absNetPayable} to settle the negative balance`)
        return false
      }

      setSettlementValidationError('')
      return true
    }

    return true
  }

  // --- NEW: Check if submit should be disabled ---
  const isSettlementSubmitDisabled = () => {
    if (isProcessingSettlement) return true
    if (!settlementData) return true
    if (settlementData.Status === 'CLOSED' || settlementData.Status === 'COMPLETED') return true
    
    // Validate first
    const netPayable = parseNumber(settlementData?.NetPayable)
    
    // Check if any field has been touched
    const hasSettleAmount = settleAmount !== '' && settleAmount !== null
    const hasAmountReceived = amountReceived !== '' && amountReceived !== null
    const hasAmountRefunded = amountRefunded !== '' && amountRefunded !== null

    // For positive net payable - require at least settle amount or amount received
    if (netPayable > 0) {
      if (!hasSettleAmount && !hasAmountReceived) return true
      
      // Check validation
      const settle = parseNumber(settleAmount)
      const received = parseNumber(amountReceived)
      
      // Both fields should have valid numbers if they are filled
      if (hasSettleAmount && isNaN(settle)) return true
      if (hasAmountReceived && isNaN(received)) return true
      
      // Check the sum
      if (settle + received !== netPayable) return true
      
      // Check individual limits
      if (settle > netPayable) return true
      if (received > netPayable) return true
      
      return false
    }

    // For negative net payable
    if (netPayable < 0) {
      const absNetPayable = Math.abs(netPayable)
      
      // Settle amount and amount received must be 0
      if (hasSettleAmount && parseNumber(settleAmount) !== 0) return true
      if (hasAmountReceived && parseNumber(amountReceived) !== 0) return true
      
      // Amount refunded must equal abs net payable
      if (!hasAmountRefunded) return true
      if (parseNumber(amountRefunded) !== absNetPayable) return true
      
      return false
    }

    // For zero net payable - all must be 0
    if (netPayable === 0) {
      if (hasSettleAmount && parseNumber(settleAmount) !== 0) return true
      if (hasAmountReceived && parseNumber(amountReceived) !== 0) return true
      if (hasAmountRefunded && parseNumber(amountRefunded) !== 0) return true
      return false
    }

    return true
  }

  // --- NEW: Fetch Settlement Data ---
  const fetchSettlement = async (admissionId) => {
    if (!admissionId) return
    
    setIsLoadingSettlement(true)
    setSettlementError('')
    setSettlementSuccess('')
    setSettlementValidationError('')
    
    try {
      const response = await getSettlement(admissionId)
      console.log('Settlement response:', response)
      
      if (response?.success && response?.data) {
        setSettlementData(response.data)
        setShowSettlementSection(true)
        
        // Set checkout date
        if (response.data.CheckoutDate) {
          const date = new Date(response.data.CheckoutDate)
          const istDate = new Date(date.getTime() + (5.5 * 60 * 60 * 1000))
          const year = istDate.getFullYear()
          const month = String(istDate.getMonth() + 1).padStart(2, '0')
          const day = String(istDate.getDate()).padStart(2, '0')
          const formattedDate = `${year}-${month}-${day}`
          setCheckoutDate(formattedDate)
          console.log('Checkout date set for input:', formattedDate)
        }
      } else {
        setSettlementData(null)
        setShowSettlementSection(true)
      }
    } catch (err) {
      console.error('Error fetching settlement:', err)
      setSettlementData(null)
      setShowSettlementSection(true)
    } finally {
      setIsLoadingSettlement(false)
    }
  }

  // --- NEW: Generate Settlement ---
  const handleGenerateSettlement = async () => {
    if (!bed?.admissionId) {
      setSettlementError('No admission ID found')
      return
    }

    setIsGeneratingSettlement(true)
    setSettlementError('')
    setSettlementSuccess('')
    setSettlementValidationError('')

    try {
      const requestData = {
        AdmissionID: bed.admissionId,
        CheckoutDate: new Date().toISOString().split('T')[0],
        Remarks: 'Final settlement generation',
        CreatedBy: parseInt(localStorage.getItem('userId')) || 1
      }

      const response = await generateSettlement(requestData)
      console.log('Generate settlement response:', response)

      if (response?.success && response?.data) {
        setSettlementSuccess('Settlement generated successfully!')
        await fetchSettlement(bed.admissionId)
      } else {
        setSettlementError(response?.message || 'Failed to generate settlement')
      }
    } catch (err) {
      console.error('Error generating settlement:', err)
      setSettlementError(err.message || 'Failed to generate settlement')
    } finally {
      setIsGeneratingSettlement(false)
    }
  }

  // --- NEW: Process Settlement (Submit) with validation ---
  const handleProcessSettlement = async () => {
    if (!settlementData?.SettlementID) {
      setSettlementError('No settlement ID found')
      return
    }

    // Run validation
    if (!validateSettlementFields()) {
      return
    }

    const netPayable = parseNumber(settlementData.NetPayable)
    const settle = parseNumber(settleAmount)
    const received = parseNumber(amountReceived)
    const refund = parseNumber(amountRefunded)

    setIsProcessingSettlement(true)
    setSettlementError('')
    setSettlementSuccess('')
    setSettlementValidationError('')

    try {
      const userId = parseInt(localStorage.getItem('userId')) || 1
      
      let apiCheckoutDate = null
      if (checkoutDate) {
        apiCheckoutDate = checkoutDate
        console.log('Checkout date for API:', apiCheckoutDate)
      }

      const requestData = {
        SettlementID: settlementData.SettlementID,
        AmountReceived: received,
        AmountRefunded: refund,
        AmountSettlement: settle, // Add settle amount to the request
        CheckoutDate: apiCheckoutDate,
        CreatedBy: userId
      }

      console.log('Process settlement request:', requestData)

      const response = await processSettlement(requestData)
      console.log('Process settlement response:', response)

      if (response?.success === true) {
        const successMsg = response?.message || 'Settlement processed successfully!'
        setSettlementSuccess(successMsg)
        alert(successMsg)

        await fetchSettlement(bed.admissionId)
        if (onSuccess) {
          onSuccess(bed.bedId, 'SETTLED')
        }
        setTimeout(() => {
          onClose()
        }, 2000)
      } else {
        setSettlementError(response?.message || 'Failed to process settlement')
      }
    } catch (err) {
      console.error('Error processing settlement:', err)
      setSettlementError(err.message || 'Failed to process settlement')
    } finally {
      setIsProcessingSettlement(false)
    }
  }

  // Reset settlement fields when settlement data changes
  useEffect(() => {
    if (settlementData) {
      const netPayable = parseNumber(settlementData.NetPayable)
      
      // Reset fields based on net payable
      if (netPayable > 0) {
        // Don't auto-fill, let owner decide
        setSettleAmount('')
        setAmountReceived('')
        setAmountRefunded('0')
      } else if (netPayable < 0) {
        setSettleAmount('0')
        setAmountReceived('0')
        setAmountRefunded(Math.abs(netPayable).toString())
      } else {
        setSettleAmount('0')
        setAmountReceived('0')
        setAmountRefunded('0')
      }
    }
  }, [settlementData])

  // Fetch tenant statement
  useEffect(() => {
    const fetchTenantStatement = async () => {
      if (bed?.admissionId && pgId) {
        setIsLoadingStatement(true)
        try {
          const response = await getTenantStatement(bed.admissionId, pgId)
          setTenantStatement(response || [])
        } catch (err) {
          console.error('Error fetching tenant statement:', err)
          setTenantStatement([])
        } finally {
          setIsLoadingStatement(false)
        }
      }
    }
    fetchTenantStatement()
  }, [bed?.admissionId, pgId])

  // Fetch security deposit with transactions
  useEffect(() => {
    const fetchSecurityDeposit = async () => {
      if (!bed?.admissionId) return
      
      setIsLoadingDeposit(true)
      try {
        const response = await getSecurityDeposit(bed.admissionId)
        console.log('Fetched security deposit:', response)
        if (response?.data) {
          setSecurityDeposit(response.data)
        } else {
          setSecurityDeposit(null)
        }
      } catch (err) {
        console.error('Error fetching security deposit:', err)
        setSecurityDeposit(null)
      } finally {
        setIsLoadingDeposit(false)
      }
    }
    fetchSecurityDeposit()
  }, [bed?.admissionId])

  // Fetch pending expenses
  useEffect(() => {
    const fetchPendingExpenses = async () => {
      if (!bed?.admissionId || !pgId) return
      
      setCurrentAdmissionId(bed.admissionId)
      setIsLoadingExpenses(true)
      try {
        const response = await getTenantPendingExpenses(pgId, bed.admissionId)
        console.log('Fetched pending expenses:', response)
        if (response?.data && Array.isArray(response.data)) {
          setPendingExpenses(response.data)
        } else {
          setPendingExpenses([])
        }
      } catch (err) {
        console.error('Error fetching pending expenses:', err)
        setPendingExpenses([])
      } finally {
        setIsLoadingExpenses(false)
      }
    }
    fetchPendingExpenses()
  }, [bed?.admissionId, pgId])

  // --- NEW: Fetch settlement when modal opens ---
  useEffect(() => {
    if (bed?.admissionId) {
      fetchSettlement(bed.admissionId)
    }
  }, [bed?.admissionId])

  if (!bed) return null

  const handleSubmit = async () => {
    if (!netPayment || netPayment.trim() === '') {
      setError('Please enter net payment amount')
      return
    }
    const paymentAmount = parseInt(netPayment)
    if (isNaN(paymentAmount) || paymentAmount <= 0) {
      setError('Please enter a valid payment amount')
      return
    }
    if (!bed?.admissionId) {
      setError('No admission ID found')
      return
    }

    setIsProcessing(true)
    setError('')

    try {
      const paymentData = {
        AdmissionID: bed.admissionId,
        PaymentAmount: paymentAmount,
        PaymentMode: paymentMode,
        DueinMonth: bed.RentdueInMonth,
        ReferenceNo: referenceNo.trim() || '',
        UserId: parseInt(localStorage.getItem('userId')) || 1
      }
      const response = await process_rent_payment(paymentData)
      console.log('Payment response:', response)
      if (response.success) {
        onSuccess(bed.bedId, '')
        setTimeout(() => {
          onClose()
        }, 500)
      } else {
        setError(response.message || 'Payment failed')
      }
    } catch (err) {
      setError(err.message || 'An error occurred')
    } finally {
      setIsProcessing(false)
    }
  }

  const maxPayable = bed.NetPayable || bed.rent || 0

  const handleReminderClick = () => {
    if (onSendReminder) {
      onSendReminder(bed)
    }
    onClose()
  }

  const totalPendingExpenses = pendingExpenses.reduce((sum, exp) => sum + (exp.NetPayable || 0), 0)

  const handleTransactionComplete = (updatedDeposit) => {
    setSecurityDeposit(updatedDeposit)
    if (onSuccess) {
      onSuccess(bed.bedId, updatedDeposit.Status)
    }
  }

  const formatSettlementAmount = (amount) => {
    return `₹${(amount || 0).toLocaleString('en-IN')}`
  }

  const toggleSettlement = () => {
    setIsSettlementExpanded(!isSettlementExpanded)
  }

  // Get validation message for display
  const getValidationMessage = () => {
    const netPayable = parseNumber(settlementData?.NetPayable)
    
    if (netPayable > 0) {
      const settle = parseNumber(settleAmount)
      const received = parseNumber(amountReceived)
      const sum = settle + received
      
      if (settleAmount === '' && amountReceived === '') {
        return { type: 'info', message: `Enter either Settle Amount or Amount Received to total ₹${netPayable}` }
      }
      
      if (settleAmount !== '' && amountReceived !== '') {
        if (sum !== netPayable) {
          return { 
            type: 'error', 
            message: `Settle Amount (₹${settle}) + Amount Received (₹${received}) = ₹${sum}, but Net Payable is ₹${netPayable}` 
          }
        }
        return { type: 'success', message: `✓ Total matches Net Payable (₹${netPayable})` }
      }
      
      if (settleAmount !== '') {
        if (settle === netPayable) {
          return { type: 'success', message: `✓ Settle Amount matches Net Payable (₹${netPayable})` }
        }
        return { type: 'error', message: `Settle Amount (₹${settle}) must equal Net Payable (₹${netPayable})` }
      }
      
      if (amountReceived !== '') {
        if (received === netPayable) {
          return { type: 'success', message: `✓ Amount Received matches Net Payable (₹${netPayable})` }
        }
        return { type: 'error', message: `Amount Received (₹${received}) must equal Net Payable (₹${netPayable})` }
      }
    }
    
    if (netPayable < 0) {
      const absNetPayable = Math.abs(netPayable)
      const refund = parseNumber(amountRefunded)
      
      if (amountRefunded === '') {
        return { type: 'info', message: `Enter Amount Refunded of ₹${absNetPayable}` }
      }
      
      if (refund !== absNetPayable) {
        return { type: 'error', message: `Amount Refunded (₹${refund}) must equal ₹${absNetPayable}` }
      }
      
      return { type: 'success', message: `✓ Amount Refunded matches (₹${absNetPayable})` }
    }
    
    if (netPayable === 0) {
      return { type: 'success', message: '✓ Net Payable is 0, no settlement amount required' }
    }
    
    return null
  }

  return (
    <div className="rv-modal-overlay">
      <div className="rv-rent-popover rv-modal-compact" onClick={e => e.stopPropagation()}>
        <div className="rv-rp-head">
          <span className="rv-rp-name">{bed.name || 'Tenant'}</span>
          <button className="rv-rp-close" onClick={onClose}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <div className="rv-rp-status-due-row">
          <div className="rv-rp-status">
            <span className="rv-rp-label">Status:</span>
            <span className="rv-rp-badge" style={{ background: statusColors.bg, color: statusColors.color }}>
              <span className="rv-rp-dot" style={{ background: statusColors.dot }} />
              {bed.rentStatus === 'NOT PAID' ? 'NOT PAID' : (bed.rentStatus || 'NA')}
            </span>
          </div>
          <div className="rv-rp-reminder-wrapper">
            {showReminder && (
              <button
                className="rv-rp-reminder-btn"
                onClick={handleReminderClick}
                title="Send WhatsApp reminder"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" />
                  <path d="M13.73 21a2 2 0 01-3.46 0" />
                </svg>
                Send Reminder
              </button>
            )}
          </div>
        </div>

        {/* Security Deposit and Expense Buttons Row */}
        <div className="rv-rp-action-buttons">

          <button
            className="rv-rp-action-btn rv-rp-overall-btn"
            onClick={() => setShowOverallRentModal(true)}
            disabled={isLoadingOverallDue}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="3" width="20" height="18" rx="2" stroke="currentColor" />
              <path d="M8 7h8M8 11h6M8 15h4" stroke="currentColor" strokeLinecap="round" />
            </svg>
            Overall Rent
            {!isLoadingOverallDue && overallDueData && overallDueData.TotalDue > 0 && (
              <span className="rv-rp-action-amount rv-rp-overall-amount">
                {fmt(overallDueData.TotalDue)}
              </span>
            )}
            {isLoadingOverallDue && <span className="rv-rp-action-loader">...</span>}
          </button>


          <button
            className="rv-rp-action-btn rv-rp-deposit-btn"
            onClick={() => setShowSecurityModal(true)}
            disabled={isLoadingDeposit}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" />
              <path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16" stroke="currentColor" />
            </svg>
            Security Deposit
            {!isLoadingDeposit && securityDeposit && (
              <span className="rv-rp-action-amount rv-rp-deposit-amount">
                {fmt(securityDeposit.Balance || 0)}
              </span>
            )}
            {isLoadingDeposit && <span className="rv-rp-action-loader">...</span>}
          </button>

          <button
            className="rv-rp-action-btn rv-rp-expense-btn"
            onClick={() => setShowExpensesModal(true)}
            disabled={isLoadingExpenses}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="3" width="20" height="18" rx="2" stroke="currentColor" />
              <path d="M8 7h8M8 11h6M8 15h4" stroke="currentColor" strokeLinecap="round" />
            </svg>
            Expenses
            {!isLoadingExpenses && pendingExpenses.length > 0 && (
              <span className="rv-rp-action-amount rv-rp-expense-amount">
                {fmt(totalPendingExpenses)}
              </span>
            )}
            {isLoadingExpenses && <span className="rv-rp-action-loader">...</span>}
          </button>
        </div>

        {/* --- UPDATED: Final Settlement Section with Validation --- */}
        {showSettlementSection && (
          <div className="rv-settlement-section">
            <div 
              className="rv-settlement-header rv-settlement-toggle" 
              onClick={toggleSettlement}
              style={{ cursor: 'pointer' }}
            >
              <div className="rv-settlement-header-left">
                <h4 className="rv-settlement-title">Full and Final Settlement</h4>
                {isLoadingSettlement && (
                  <span className="rv-settlement-loader">Loading...</span>
                )}
              </div>
              <button 
                className="rv-settlement-toggle-btn"
                aria-label={isSettlementExpanded ? 'Collapse settlement' : 'Expand settlement'}
                onClick={(e) => {
                  e.stopPropagation()
                  toggleSettlement()
                }}
              >
                <svg 
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2"
                  style={{
                    transform: isSettlementExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s ease'
                  }}
                >
                  <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>

            {/* Settlement content */}
            {isSettlementExpanded && (
              <>
                {isLoadingSettlement ? (
                  <div className="rv-settlement-loading">
                    <span className="rv-spinner-small"></span> Loading settlement details...
                  </div>
                ) : settlementData ? (
                  <>
                    <div className="rv-settlement-wrapper">
                      {/* Left Section */}
                      <div className="rv-settlement-left">
                        <div className="rv-settlement-item">
                          <span className="rv-settlement-label">Rent Due</span>
                          <span className="rv-settlement-value rv-settlement-amount">{formatSettlementAmount(settlementData.RentDue)}</span>
                        </div>
                        <div className="rv-settlement-item">
                          <span className="rv-settlement-label">Electricity Due</span>
                          <span className="rv-settlement-value rv-settlement-amount">{formatSettlementAmount(settlementData.ElectricityDue)}</span>
                        </div>
                        <div className="rv-settlement-item">
                          <span className="rv-settlement-label">Expense Due</span>
                          <span className="rv-settlement-value rv-settlement-amount">{formatSettlementAmount(settlementData.ExpenseDue)}</span>
                        </div>
                        <div className="rv-settlement-item">
                          <span className="rv-settlement-label">Total Due</span>
                          <span className="rv-settlement-value">{formatSettlementAmount(settlementData.TotalDue)}</span>
                        </div>
                      </div>

                      {/* Right Section */}
                      <div className="rv-settlement-right">
                        <div className="rv-settlement-item">
                          <span className="rv-settlement-label">Security Deposit</span>
                          <span className="rv-settlement-value rv-settlement-deposit">{formatSettlementAmount(settlementData.SecurityDeposit)}</span>
                        </div>
                        <div className="rv-settlement-item">
                          <span className="rv-settlement-label">Net Payable</span>
                          <span className="rv-settlement-value rv-settlement-net">{formatSettlementAmount(settlementData.NetPayable)}</span>
                        </div>
                      </div>
                    </div>

                    {/* Settlement Payment Fields with Validation */}
                    <div className="rv-settlement-payment-fields">
                      <div className="rv-settlement-field-row">
                        <div className="rv-settlement-field-group" style={{ width: '100%' }}>
                          <label className="rv-settlement-field-label">
                            Checkout Date
                          </label>
                          <div className="rv-settlement-input-wrap">
                            <input
                              type="date"
                              className="rv-settlement-field-input"
                              value={checkoutDate}
                              onChange={(e) => setCheckoutDate(e.target.value)}
                            />
                          </div>
                          {settlementData?.CheckoutDate && (
                            <span className="rv-settlement-field-hint">
                              Current: {formatDate(settlementData.CheckoutDate)}
                            </span>
                          )}
                        </div>

                        <div className="rv-settlement-field-group">
                          <label className="rv-settlement-field-label">
                            Settle Amount
                            {parseNumber(settlementData?.NetPayable) > 0 && (
                              <span className="rv-required">*</span>
                            )}
                          </label>
                          <div className="rv-settlement-input-wrap">
                            <span className="rv-settlement-currency-symbol">₹</span>
                            <input
                              type="number"
                              className={`rv-settlement-field-input ${
                                settlementValidationError && settleAmount !== '' ? 'rv-settlement-field-error' : ''
                              }`}
                              placeholder="Enter settle amount"
                              value={settleAmount}
                              onChange={(e) => {
                                setSettleAmount(e.target.value)
                                setSettlementValidationError('')
                              }}
                              step="0.01"
                              min="0"
                              disabled={parseNumber(settlementData?.NetPayable) <= 0}
                            />
                          </div>
                          {parseNumber(settlementData?.NetPayable) > 0 && (
                            <span className="rv-settlement-field-hint">
                              Amount to waive/write off
                            </span>
                          )}
                          {parseNumber(settlementData?.NetPayable) <= 0 && (
                            <span className="rv-settlement-field-hint">
                              Not applicable (Net Payable is {formatSettlementAmount(settlementData?.NetPayable)})
                            </span>
                          )}
                        </div>

                        <div className="rv-settlement-field-group">
                          <label className="rv-settlement-field-label">
                            Amount Received
                            {parseNumber(settlementData?.NetPayable) > 0 && (
                              <span className="rv-required">*</span>
                            )}
                          </label>
                          <div className="rv-settlement-input-wrap">
                            <span className="rv-settlement-currency-symbol">₹</span>
                            <input
                              type="number"
                              className={`rv-settlement-field-input ${
                                settlementValidationError && amountReceived !== '' ? 'rv-settlement-field-error' : ''
                              }`}
                              placeholder="Enter amount received"
                              value={amountReceived}
                              onChange={(e) => {
                                setAmountReceived(e.target.value)
                                setSettlementValidationError('')
                              }}
                              step="0.01"
                              min="0"
                              disabled={parseNumber(settlementData?.NetPayable) <= 0}
                            />
                          </div>
                          {parseNumber(settlementData?.NetPayable) > 0 && (
                            <span className="rv-settlement-field-hint">
                              Actual amount paid by tenant
                            </span>
                          )}
                          {parseNumber(settlementData?.NetPayable) <= 0 && (
                            <span className="rv-settlement-field-hint">
                              Not applicable (Net Payable is {formatSettlementAmount(settlementData?.NetPayable)})
                            </span>
                          )}
                        </div>

                        <div className="rv-settlement-field-group">
                          <label className="rv-settlement-field-label">
                            Amount Refunded
                            {parseNumber(settlementData?.NetPayable) < 0 && (
                              <span className="rv-required">*</span>
                            )}
                          </label>
                          <div className="rv-settlement-input-wrap">
                            <span className="rv-settlement-currency-symbol">₹</span>
                            <input
                              type="number"
                              className={`rv-settlement-field-input ${
                                settlementValidationError && amountRefunded !== '' ? 'rv-settlement-field-error' : ''
                              }`}
                              placeholder="Enter amount refunded"
                              value={amountRefunded}
                              onChange={(e) => {
                                setAmountRefunded(e.target.value)
                                setSettlementValidationError('')
                              }}
                              step="0.01"
                              min="0"
                              disabled={parseNumber(settlementData?.NetPayable) >= 0}
                            />
                          </div>
                          {parseNumber(settlementData?.NetPayable) < 0 && (
                            <span className="rv-settlement-field-hint">
                              Must equal {formatSettlementAmount(Math.abs(settlementData.NetPayable))}
                            </span>
                          )}
                          {parseNumber(settlementData?.NetPayable) >= 0 && (
                            <span className="rv-settlement-field-hint">
                              Not applicable (Net Payable is {formatSettlementAmount(settlementData?.NetPayable)})
                            </span>
                          )}
                        </div>
                      </div>

                      {/* Validation Message */}
                      {(() => {
                        const msg = getValidationMessage()
                        if (!msg) return null
                        return (
                          <div className={`rv-settlement-validation-message ${
                            msg.type === 'success' ? 'rv-settlement-validation-success' : 
                            msg.type === 'error' ? 'rv-settlement-validation-error' : 
                            'rv-settlement-validation-info'
                          }`}>
                            {msg.message}
                          </div>
                        )
                      })()}
                    </div>

                    {/* Submit Button */}
                    {settlementData.Status !== 'CLOSED' && settlementData.Status !== 'COMPLETED' && (
                      <button
                        className="rv-settlement-submit-btn"
                        onClick={handleProcessSettlement}
                        disabled={isSettlementSubmitDisabled()}
                      >
                        {isProcessingSettlement ? (
                          <>
                            <span className="rv-spinner-small"></span>
                            Processing...
                          </>
                        ) : (
                          'Submit Settlement'
                        )}
                      </button>
                    )}

                    {settlementData.Status === 'CLOSED' && (
                      <div className="rv-settlement-closed-msg">
                        ✓ Settlement already processed
                      </div>
                    )}
                  </>
                ) : (
                  // No settlement found - Show Generate button
                  <div className="rv-settlement-empty">
                    <p className="rv-settlement-empty-text">No settlement found for this tenant</p>
                    <button
                      className="rv-settlement-generate-btn"
                      onClick={handleGenerateSettlement}
                      disabled={isGeneratingSettlement}
                    >
                      {isGeneratingSettlement ? (
                        <>
                          <span className="rv-spinner-small"></span>
                          Generating...
                        </>
                      ) : (
                        'Generate Settlement'
                      )}
                    </button>
                  </div>
                )}

                {/* Settlement Messages */}
                {settlementError && (
                  <div className="rv-settlement-error">{settlementError}</div>
                )}
                {settlementSuccess && (
                  <div className="rv-settlement-success">{settlementSuccess}</div>
                )}
              </>
            )}
          </div>
        )}

        {/* Rest of the component remains same */}
        {isLoadingStatement ? (
          <div className="rv-statement-loading">
            <span className="rv-spinner-small"></span> Loading statement...
          </div>
        ) : tenantStatement.length > 0 ? (
          <div className="rv-tenant-statement">
            <div className="rv-statement-title">Monthly Statement</div>
            <div className="rv-statement-table-wrapper">
              <table className="rv-statement-table">
                <thead>
                  <tr>
                    <th>Month</th>
                    <th>Year</th>
                    <th>Monthly Rent (₹)</th>
                    <th>Electricity (₹)</th>
                    <th>Rent Due (₹)</th>
                    <th>Paid (₹)</th>
                    <th>Security Adjusted (₹)</th>
                    <th>Net Payable (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  {tenantStatement.map((item, idx) => (
                    <tr key={idx}>
                      <td>{item.MonthName}</td>
                      <td>{item.InvoiceYear}</td>
                      <td>{(item.RentAmount || 0).toLocaleString('en-IN')}</td>
                      <td>{(item.ElectricityAmount || 0).toLocaleString('en-IN')}</td>
                      <td>{(item.TotalAmount || 0).toLocaleString('en-IN')}</td>
                      <td className="rv-paid-amount">{(item.PaidAmount || 0).toLocaleString('en-IN')}</td>
                      <td className="rv-adjusted-amount">{(item.AdvanceAdjusted || 0).toLocaleString('en-IN')}</td>
                      <td className="rv-netpayable-amount">{(item.NetPayable || 0).toLocaleString('en-IN')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : null}

        <div className="rv-rp-amount-grid">
          <div className="rv-rp-amount-item rv-rp-netpayable-item">
            <span className="rv-rp-label">Total Net Payable:</span>
            <span className="rv-rp-value">{fmt(maxPayable)}</span>
          </div>
        </div>

        <div className="rv-rp-payment-row">
          <div className="rv-rp-netpayment">
            <label className="rv-rp-netpayment-label">
              Net Payment <span className="rv-required">*</span>
            </label>
            <div className="rv-rp-netpayment-input-wrap">
              <span className="rv-rp-currency-symbol">₹</span>
              <input
                type="number"
                className="rv-rp-netpayment-input"
                placeholder="Enter payment amount"
                value={netPayment}
                onChange={(e) => setNetPayment(e.target.value)}
                max={maxPayable}
                min="1"
                step="1"
                required
              />
            </div>
          </div>

          <div className="rv-rp-payment-mode">
            <label className="rv-rp-payment-label">Payment Mode:</label>
            <select
              value={paymentMode}
              onChange={(e) => setPaymentMode(e.target.value)}
              className="rv-rp-payment-select"
            >
              <option value="CASH">💵 CASH</option>
              <option value="UPI">📱 UPI</option>
              <option value="BANK">🏦 BANK</option>
            </select>
          </div>

          <div className="rv-rp-netpayment">
            <label className="rv-rp-netpayment-label">Reference No:</label>
            <div className="rv-rp-netpayment-input-wrap-1">
              <input
                type="text"
                className="rv-rp-netpayment-input"
                placeholder="Enter reference number"
                value={referenceNo}
                onChange={(e) => setReferenceNo(e.target.value)}
              />
            </div>
          </div>
        </div>

        {error && <div className="rv-rp-error">{error}</div>}

        <button
          className="rv-rp-mark-btn"
          onClick={handleSubmit}
          disabled={isProcessing}
        >
          {isProcessing ? 'Processing...' : 'Confirm Payment'}
        </button>
      </div>




      {/* ─── Overall Rent Modal ──────────────────────────────────────── */}
      {showOverallRentModal && (
        <OverallRentModal
          admissionId={bed?.admissionId}
          overallDueData={overallDueData}
          onClose={() => setShowOverallRentModal(false)}
          onSuccess={() => {
            // Refresh data after payment
            fetchOverallDue();
            // fetchRevenueData(); // If parent has this function
            if (onSuccess) {
              onSuccess(bed.bedId, '');
            }
          }}
        />
      )}


      {/* Security Deposit Modal */}
      {showSecurityModal && (
        <SecurityDepositModal
          depositData={securityDeposit}
          admissionId={bed?.admissionId}
          onClose={() => setShowSecurityModal(false)}
          onTransactionComplete={handleTransactionComplete}
        />
      )}

      {/* Pending Expenses Modal */}
      {showExpensesModal && (
        <PendingExpensesModal
          expenses={pendingExpenses}
          admissionId={currentAdmissionId || bed?.admissionId}
          pgId={pgId}
          onClose={() => setShowExpensesModal(false)}
          onSuccess={() => {
            const fetchExpenses = async () => {
              if (bed?.admissionId && pgId) {
                try {
                  const response = await getTenantPendingExpenses(pgId, bed.admissionId)
                  if (response?.data && Array.isArray(response.data)) {
                    setPendingExpenses(response.data)
                  }
                } catch (err) {
                  console.error('Error refreshing expenses:', err)
                }
              }
            }
            fetchExpenses()
          }}
        />
      )}
    </div>
  )
}

// const RentPaymentModal = ({ pgId, bed, onClose, onSuccess, onSendReminder }) => {
//   const [paymentMode, setPaymentMode] = useState('CASH')
//   const [netPayment, setNetPayment] = useState('')
//   const [referenceNo, setReferenceNo] = useState('')
//   const [isProcessing, setIsProcessing] = useState(false)
//   const [error, setError] = useState('')
//   const [tenantStatement, setTenantStatement] = useState([])
//   const [isLoadingStatement, setIsLoadingStatement] = useState(false)
  
//   // New state for security deposit and expenses
//   const [securityDeposit, setSecurityDeposit] = useState(null)
//   const [pendingExpenses, setPendingExpenses] = useState([])
//   const [isLoadingDeposit, setIsLoadingDeposit] = useState(false)
//   const [isLoadingExpenses, setIsLoadingExpenses] = useState(false)
//   const [showSecurityModal, setShowSecurityModal] = useState(false)
//   const [showExpensesModal, setShowExpensesModal] = useState(false)
//   const [currentAdmissionId, setCurrentAdmissionId] = useState(null)

 

//   // --- NEW: Final Settlement State ---
//   const [settlementData, setSettlementData] = useState(null)
//   const [isLoadingSettlement, setIsLoadingSettlement] = useState(false)
//   const [isGeneratingSettlement, setIsGeneratingSettlement] = useState(false)
//   const [isProcessingSettlement, setIsProcessingSettlement] = useState(false)
//   const [settlementError, setSettlementError] = useState('')
//   const [settlementSuccess, setSettlementSuccess] = useState('')
//   const [showSettlementSection, setShowSettlementSection] = useState(false)
//   const [isSettlementExpanded, setIsSettlementExpanded] = useState(false) // NEW: Toggle state

//   const statusColors = getStatusColor(bed?.rentStatus)
//   const showReminder = ['DUE', 'OVERDUE', 'NOT PAID'].includes(bed?.rentStatus)

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A'
//     const date = new Date(dateString)
//     return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
//   }

//   // --- NEW: Fetch Settlement Data ---
//   const fetchSettlement = async (admissionId) => {
//     if (!admissionId) return
    
//     setIsLoadingSettlement(true)
//     setSettlementError('')
//     setSettlementSuccess('')
    
//     try {
//       const response = await getSettlement(admissionId)
//       console.log('Settlement response:', response)
      
//       if (response?.success && response?.data) {
//         setSettlementData(response.data)
//         setShowSettlementSection(true)
//       } else {
//         setSettlementData(null)
//         setShowSettlementSection(true)
//       }
//     } catch (err) {
//       console.error('Error fetching settlement:', err)
//       setSettlementData(null)
//       setShowSettlementSection(true)
//     } finally {
//       setIsLoadingSettlement(false)
//     }
//   }

//   // --- NEW: Generate Settlement ---
//   const handleGenerateSettlement = async () => {
//     if (!bed?.admissionId) {
//       setSettlementError('No admission ID found')
//       return
//     }

//     setIsGeneratingSettlement(true)
//     setSettlementError('')
//     setSettlementSuccess('')

//     try {
//       const requestData = {
//         AdmissionID: bed.admissionId,
//         CheckoutDate: new Date().toISOString().split('T')[0],
//         Remarks: 'Final settlement generation',
//         CreatedBy: 1
//       }

//       const response = await generateSettlement(requestData)
//       console.log('Generate settlement response:', response)

//       if (response?.success && response?.data) {
//         setSettlementSuccess('Settlement generated successfully!')
//         // Fetch the updated settlement data
//         await fetchSettlement(bed.admissionId)
//       } else {
//         setSettlementError(response?.message || 'Failed to generate settlement')
//       }
//     } catch (err) {
//       console.error('Error generating settlement:', err)
//       setSettlementError(err.message || 'Failed to generate settlement')
//     } finally {
//       setIsGeneratingSettlement(false)
//     }
//   }

//   // --- NEW: Process Settlement (Submit) ---
//   const handleProcessSettlement = async () => {
//     if (!settlementData?.SettlementID) {
//       setSettlementError('No settlement ID found')
//       return
//     }

//     setIsProcessingSettlement(true)
//     setSettlementError('')
//     setSettlementSuccess('')

//     try {
//       const requestData = {
//         SettlementID: settlementData.SettlementID,
//         CreatedBy: 1
//       }

//       const response = await processSettlement(requestData)
//       console.log('Process settlement response:', response)

//       if (response?.success) {
//         setSettlementSuccess('Settlement processed successfully!')
//         // Refresh settlement data
//         await fetchSettlement(bed.admissionId)
//         // Notify parent
//         if (onSuccess) {
//           onSuccess(bed.bedId, 'SETTLED')
//         }
//         // Auto close after 2 seconds
//         setTimeout(() => {
//           onClose()
//         }, 2000)
//       } else {
//         setSettlementError(response?.message || 'Failed to process settlement')
//       }
//     } catch (err) {
//       console.error('Error processing settlement:', err)
//       setSettlementError(err.message || 'Failed to process settlement')
//     } finally {
//       setIsProcessingSettlement(false)
//     }
//   }

//   // Fetch tenant statement
//   useEffect(() => {
//     const fetchTenantStatement = async () => {
//       if (bed?.admissionId && pgId) {
//         setIsLoadingStatement(true)
//         try {
//           const response = await getTenantStatement(bed.admissionId, pgId)
//           setTenantStatement(response || [])
//         } catch (err) {
//           console.error('Error fetching tenant statement:', err)
//           setTenantStatement([])
//         } finally {
//           setIsLoadingStatement(false)
//         }
//       }
//     }
//     fetchTenantStatement()
//   }, [bed?.admissionId, pgId])

//   // Fetch security deposit with transactions
//   useEffect(() => {
//     const fetchSecurityDeposit = async () => {
//       if (!bed?.admissionId) return
      
//       setIsLoadingDeposit(true)
//       try {
//         const response = await getSecurityDeposit(bed.admissionId)
//         console.log('Fetched security deposit:', response)
//         if (response?.data) {
//           setSecurityDeposit(response.data)
//         } else {
//           setSecurityDeposit(null)
//         }
//       } catch (err) {
//         console.error('Error fetching security deposit:', err)
//         setSecurityDeposit(null)
//       } finally {
//         setIsLoadingDeposit(false)
//       }
//     }
//     fetchSecurityDeposit()
//   }, [bed?.admissionId])

//   // Fetch pending expenses
//   useEffect(() => {
//     const fetchPendingExpenses = async () => {
//       if (!bed?.admissionId || !pgId) return
      
//       setCurrentAdmissionId(bed.admissionId)
//       setIsLoadingExpenses(true)
//       try {
//         const response = await getTenantPendingExpenses(pgId, bed.admissionId)
//         console.log('Fetched pending expenses:', response)
//         if (response?.data && Array.isArray(response.data)) {
//           setPendingExpenses(response.data)
//         } else {
//           setPendingExpenses([])
//         }
//       } catch (err) {
//         console.error('Error fetching pending expenses:', err)
//         setPendingExpenses([])
//       } finally {
//         setIsLoadingExpenses(false)
//       }
//     }
//     fetchPendingExpenses()
//   }, [bed?.admissionId, pgId])

//   // --- NEW: Fetch settlement when modal opens ---
//   useEffect(() => {
//     if (bed?.admissionId) {
//       fetchSettlement(bed.admissionId)
//     }
//   }, [bed?.admissionId])

//   if (!bed) return null

//   const handleSubmit = async () => {
   
//     if (!netPayment || netPayment.trim() === '') {
//       setError('Please enter net payment amount')
//       return
//     }
//     const paymentAmount = parseInt(netPayment)
//     if (isNaN(paymentAmount) || paymentAmount <= 0) {
//       setError('Please enter a valid payment amount')
//       return
//     }
//     if (!bed?.admissionId) {
//       setError('No admission ID found')
//       return
//     }

//     setIsProcessing(true)
//     setError('')

//     try {
//       const paymentData = {
//         AdmissionID: bed.admissionId,
//         PaymentAmount: paymentAmount,
//         PaymentMode: paymentMode,
//         DueinMonth: bed.RentdueInMonth,
//         ReferenceNo: referenceNo.trim() || '',
//         UserId: parseInt(localStorage.getItem('userId')) || 1
//       }
//       const response = await process_rent_payment(paymentData)
//       console.log('Payment response:', response)
//       if (response.success) {
//         onSuccess(bed.bedId, '')
//         setTimeout(() => {
//         onClose()
//       }, 500)
//       } else {
//         setError(response.message || 'Payment failed')
//       }
//     } catch (err) {
//       setError(err.message || 'An error occurred')
//     } finally {
//       setIsProcessing(false)
//     }
//   }

//   const maxPayable = bed.NetPayable || bed.rent || 0

//   const handleReminderClick = () => {
//     if (onSendReminder) {
//       onSendReminder(bed)
//     }
//     onClose()
//   }

//   const totalPendingExpenses = pendingExpenses.reduce((sum, exp) => sum + (exp.NetPayable || 0), 0)

//   // Handle successful transaction
//   const handleTransactionComplete = (updatedDeposit) => {
//     setSecurityDeposit(updatedDeposit)
//     if (onSuccess) {
//       onSuccess(bed.bedId, updatedDeposit.Status)
//     }
//   }

//   // Format currency for settlement display
//   const formatSettlementAmount = (amount) => {
//     return `₹${(amount || 0).toLocaleString('en-IN')}`
//   }

//   // NEW: Toggle settlement section
//   const toggleSettlement = () => {
//     setIsSettlementExpanded(!isSettlementExpanded)
//   }

//   return (
//     <div className="rv-modal-overlay">
//       <div className="rv-rent-popover rv-modal-compact" onClick={e => e.stopPropagation()}>
//         <div className="rv-rp-head">
//           <span className="rv-rp-name">{bed.name || 'Tenant'}</span>
//           <button className="rv-rp-close" onClick={onClose}>
//             <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
//               <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
//             </svg>
//           </button>
//         </div>

//         <div className="rv-rp-status-due-row">
//           <div className="rv-rp-status">
//             <span className="rv-rp-label">Status:</span>
//             <span className="rv-rp-badge" style={{ background: statusColors.bg, color: statusColors.color }}>
//               <span className="rv-rp-dot" style={{ background: statusColors.dot }} />
//               {bed.rentStatus === 'NOT PAID' ? 'NOT PAID' : (bed.rentStatus || 'NA')}
//             </span>
//           </div>
//           <div className="rv-rp-reminder-wrapper">
//             {showReminder && (
//               <button
//                 className="rv-rp-reminder-btn"
//                 onClick={handleReminderClick}
//                 title="Send WhatsApp reminder"
//               >
//                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                   <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" />
//                   <path d="M13.73 21a2 2 0 01-3.46 0" />
//                 </svg>
//                 Send Reminder
//               </button>
//             )}
//           </div>
//         </div>

//         {/* Security Deposit and Expense Buttons Row */}
//         <div className="rv-rp-action-buttons">
//           <button
//             className="rv-rp-action-btn rv-rp-deposit-btn"
//             onClick={() => setShowSecurityModal(true)}
//             disabled={isLoadingDeposit}
//           >
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//               <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" />
//               <path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16" stroke="currentColor" />
//             </svg>
//             Security Deposit
//             {!isLoadingDeposit && securityDeposit && (
//               <span className="rv-rp-action-amount rv-rp-deposit-amount">
//                 {fmt(securityDeposit.Balance || 0)}
//               </span>
//             )}
//             {isLoadingDeposit && <span className="rv-rp-action-loader">...</span>}
//           </button>

//           <button
//             className="rv-rp-action-btn rv-rp-expense-btn"
//             onClick={() => setShowExpensesModal(true)}
//             disabled={isLoadingExpenses}
//           >
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//               <rect x="2" y="3" width="20" height="18" rx="2" stroke="currentColor" />
//               <path d="M8 7h8M8 11h6M8 15h4" stroke="currentColor" strokeLinecap="round" />
//             </svg>
//             Expenses
//             {!isLoadingExpenses && pendingExpenses.length > 0 && (
//               <span className="rv-rp-action-amount rv-rp-expense-amount">
//                 {fmt(totalPendingExpenses)}
//               </span>
//             )}
//             {isLoadingExpenses && <span className="rv-rp-action-loader">...</span>}
//           </button>
//         </div>

//         {/* --- UPDATED: Final Settlement Section with Toggle --- */}
//         {showSettlementSection && (
//           <div className="rv-settlement-section">
//             <div 
//               className="rv-settlement-header rv-settlement-toggle" 
//               onClick={toggleSettlement}
//               style={{ cursor: 'pointer' }}
//             >
//               <div className="rv-settlement-header-left">
//                 <h4 className="rv-settlement-title">Final Settlement</h4>
//                 {isLoadingSettlement && (
//                   <span className="rv-settlement-loader">Loading...</span>
//                 )}
//               </div>
//               <button 
//                 className="rv-settlement-toggle-btn"
//                 aria-label={isSettlementExpanded ? 'Collapse settlement' : 'Expand settlement'}
//                 onClick={(e) => {
//                   e.stopPropagation(); // Prevent double trigger
//                   toggleSettlement();
//                 }}
//               >
//                 <svg 
//                   width="20" 
//                   height="20" 
//                   viewBox="0 0 24 24" 
//                   fill="none" 
//                   stroke="currentColor" 
//                   strokeWidth="2"
//                   style={{
//                     transform: isSettlementExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
//                     transition: 'transform 0.3s ease'
//                   }}
//                 >
//                   <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round"/>
//                 </svg>
//               </button>
//             </div>

//             {/* Settlement content - conditionally rendered based on toggle state */}
//             {isSettlementExpanded && (
//               <>
//                 {isLoadingSettlement ? (
//                   <div className="rv-settlement-loading">
//                     <span className="rv-spinner-small"></span> Loading settlement details...
//                   </div>
//                 ) : settlementData ? (
//                   <>
//                     {/* Settlement Details Grid */}
//                     <div className="rv-settlement-grid">
//                       <div className="rv-settlement-item">
//                         <span className="rv-settlement-label">Settlement ID</span>
//                         <span className="rv-settlement-value">{settlementData.SettlementID || 'N/A'}</span>
//                       </div>
//                       <div className="rv-settlement-item">
//                         <span className="rv-settlement-label">Status</span>
//                         <span className={`rv-settlement-status rv-settlement-status-${settlementData.Status?.toLowerCase() || 'pending'}`}>
//                           {settlementData.Status || 'PENDING'}
//                         </span>
//                       </div>
//                       <div className="rv-settlement-item">
//                         <span className="rv-settlement-label">Checkout Date</span>
//                         <span className="rv-settlement-value">{formatDate(settlementData.CheckoutDate)}</span>
//                       </div>
//                       <div className="rv-settlement-item">
//                         <span className="rv-settlement-label">Rent Due</span>
//                         <span className="rv-settlement-value rv-settlement-amount">{formatSettlementAmount(settlementData.RentDue)}</span>
//                       </div>
//                       <div className="rv-settlement-item">
//                         <span className="rv-settlement-label">Electricity Due</span>
//                         <span className="rv-settlement-value rv-settlement-amount">{formatSettlementAmount(settlementData.ElectricityDue)}</span>
//                       </div>
//                       <div className="rv-settlement-item">
//                         <span className="rv-settlement-label">Food Due</span>
//                         <span className="rv-settlement-value rv-settlement-amount">{formatSettlementAmount(settlementData.FoodDue)}</span>
//                       </div>
//                       <div className="rv-settlement-item">
//                         <span className="rv-settlement-label">Expense Due</span>
//                         <span className="rv-settlement-value rv-settlement-amount">{formatSettlementAmount(settlementData.ExpenseDue)}</span>
//                       </div>
//                       <div className="rv-settlement-item">
//                         <span className="rv-settlement-label">Total Due</span>
//                         <span className="rv-settlement-value rv-settlement-total">{formatSettlementAmount(settlementData.TotalDue)}</span>
//                       </div>
//                       <div className="rv-settlement-item">
//                         <span className="rv-settlement-label">Security Deposit</span>
//                         <span className="rv-settlement-value rv-settlement-deposit">{formatSettlementAmount(settlementData.SecurityDeposit)}</span>
//                       </div>
//                       <div className="rv-settlement-item">
//                         <span className="rv-settlement-label">Deposit Adjusted</span>
//                         <span className="rv-settlement-value">{formatSettlementAmount(settlementData.DepositAdjusted)}</span>
//                       </div>
//                       <div className="rv-settlement-item">
//                         <span className="rv-settlement-label">Deposit Refund</span>
//                         <span className="rv-settlement-value rv-settlement-refund">{formatSettlementAmount(settlementData.DepositRefund)}</span>
//                       </div>
//                       <div className="rv-settlement-item">
//                         <span className="rv-settlement-label">Net Payable</span>
//                         <span className="rv-settlement-value rv-settlement-net">{formatSettlementAmount(settlementData.NetPayable)}</span>
//                       </div>
//                     </div>

//                     {/* Submit Button - Only show if settlement exists */}
//                     {settlementData.Status !== 'CLOSED' && settlementData.Status !== 'COMPLETED' && (
//                       <button
//                         className="rv-settlement-submit-btn"
//                         onClick={handleProcessSettlement}
//                         disabled={isProcessingSettlement}
//                       >
//                         {isProcessingSettlement ? (
//                           <>
//                             <span className="rv-spinner-small"></span>
//                             Processing...
//                           </>
//                         ) : (
//                           'Submit Settlement'
//                         )}
//                       </button>
//                     )}

//                     {settlementData.Status === 'CLOSED' && (
//                       <div className="rv-settlement-closed-msg">
//                         ✓ Settlement already processed
//                       </div>
//                     )}
//                   </>
//                 ) : (
//                   // No settlement found - Show Generate button
//                   <div className="rv-settlement-empty">
//                     <p className="rv-settlement-empty-text">No settlement found for this tenant</p>
//                     <button
//                       className="rv-settlement-generate-btn"
//                       onClick={handleGenerateSettlement}
//                       disabled={isGeneratingSettlement}
//                     >
//                       {isGeneratingSettlement ? (
//                         <>
//                           <span className="rv-spinner-small"></span>
//                           Generating...
//                         </>
//                       ) : (
//                         'Generate Settlement'
//                       )}
//                     </button>
//                   </div>
//                 )}

//                 {/* Settlement Messages */}
//                 {settlementError && (
//                   <div className="rv-settlement-error">{settlementError}</div>
//                 )}
//                 {settlementSuccess && (
//                   <div className="rv-settlement-success">{settlementSuccess}</div>
//                 )}
//               </>
//             )}
//           </div>
//         )}

//         {isLoadingStatement ? (
//           <div className="rv-statement-loading">
//             <span className="rv-spinner-small"></span> Loading statement...
//           </div>
//         ) : tenantStatement.length > 0 ? (
//           <div className="rv-tenant-statement">
//             <div className="rv-statement-title">Monthly Statement</div>
//             <div className="rv-statement-table-wrapper">
//               <table className="rv-statement-table">
//                 <thead>
//                     <tr>
//                       <th>Month</th>
//                       <th>Year</th>
//                       <th>Rent (₹)</th>
//                       <th>Electricity (₹)</th>
//                       <th>Rent Due (₹)</th>
//                       <th>Paid (₹)</th>
//                       <th>Adjusted Amount (₹)</th>
//                       <th>Net Payable (₹)</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                   {tenantStatement.map((item, idx) => (
//                     <tr key={idx}>
//                       <td>{item.MonthName}</td>
//                       <td>{item.InvoiceYear}</td>
//                       <td>{(item.RentAmount || 0).toLocaleString('en-IN')}</td>
//                       <td>{(item.ElectricityAmount || 0).toLocaleString('en-IN')}</td>
//                       <td>{(item.TotalAmount || 0).toLocaleString('en-IN')}</td>
//                       <td className="rv-paid-amount">{(item.PaidAmount || 0).toLocaleString('en-IN')}</td>
//                       <td className="rv-adjusted-amount">{(item.AdvanceAdjusted || 0).toLocaleString('en-IN')}</td>
//                       <td className="rv-netpayable-amount">{(item.NetPayable || 0).toLocaleString('en-IN')}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         ) : null}

//         <div className="rv-rp-amount-grid">
//           <div className="rv-rp-amount-item rv-rp-netpayable-item">
//             <span className="rv-rp-label">Total Net Payable:</span>
//             <span className="rv-rp-value">{fmt(maxPayable)}</span>
//           </div>
//         </div>

// <div className="rv-rp-payment-row">
// <div className="rv-rp-netpayment">
//           <label className="rv-rp-netpayment-label">
//             Net Payment <span className="rv-required">*</span>
//           </label>
//           <div className="rv-rp-netpayment-input-wrap">
//             <span className="rv-rp-currency-symbol">₹</span>
//             <input
//               type="number"
//               className="rv-rp-netpayment-input"
//               placeholder="Enter payment amount"
//               value={netPayment}
//               onChange={(e) => setNetPayment(e.target.value)}
//               max={maxPayable}
//               min="1"
//               step="1"
//               required
//             />
//           </div>
//         </div>

//         <div className="rv-rp-payment-mode">
//           <label className="rv-rp-payment-label">Payment Mode:</label>
//           <select
//             value={paymentMode}
//             onChange={(e) => setPaymentMode(e.target.value)}
//             className="rv-rp-payment-select"
//           >
//             <option value="CASH">💵 CASH</option>
//             <option value="UPI">📱 UPI</option>
//             <option value="BANK">🏦 BANK</option>
//           </select>
//         </div>

//          <div className="rv-rp-netpayment">
//             <label className="rv-rp-netpayment-label">Reference No:</label>
//            <div className="rv-rp-netpayment-input-wrap-1">
//             <input
//               type="text"
//               className="rv-rp-netpayment-input"
//               placeholder="Enter reference number"
//               value={referenceNo}
//               onChange={(e) => setReferenceNo(e.target.value)}
//             />
//           </div>
//           </div>
//   </div>

        

//         {error && <div className="rv-rp-error">{error}</div>}

//         <button
//           className="rv-rp-mark-btn"
//           onClick={handleSubmit}
//           disabled={isProcessing}
//         >
//           {isProcessing ? 'Processing...' : 'Confirm Payment'}
//         </button>
//       </div>

//       {/* Security Deposit Modal */}
//       {showSecurityModal && (
//         <SecurityDepositModal
//           depositData={securityDeposit}
//           admissionId={bed?.admissionId}
//           onClose={() => setShowSecurityModal(false)}
//           onTransactionComplete={handleTransactionComplete}
//         />
//       )}

//       {/* Pending Expenses Modal */}
//       {showExpensesModal && (
//         <PendingExpensesModal
//           expenses={pendingExpenses}
//           admissionId={currentAdmissionId || bed?.admissionId}
//           pgId={pgId}
//           onClose={() => setShowExpensesModal(false)}
//           onSuccess={() => {
//             const fetchExpenses = async () => {
//               if (bed?.admissionId && pgId) {
//                 try {
//                   const response = await getTenantPendingExpenses(pgId, bed.admissionId)
//                   if (response?.data && Array.isArray(response.data)) {
//                     setPendingExpenses(response.data)
//                   }
//                 } catch (err) {
//                   console.error('Error refreshing expenses:', err)
//                 }
//               }
//             }
//             fetchExpenses()
//           }}
//         />
//       )}
//     </div>
//   )
// }


// const RentPaymentModal = ({ pgId, bed, onClose, onSuccess, onSendReminder }) => {
//   const [paymentMode, setPaymentMode] = useState('CASH')
//   const [netPayment, setNetPayment] = useState('')
//   const [isProcessing, setIsProcessing] = useState(false)
//   const [error, setError] = useState('')
//   const [tenantStatement, setTenantStatement] = useState([])
//   const [isLoadingStatement, setIsLoadingStatement] = useState(false)
  
//   // New state for security deposit and expenses
//   const [securityDeposit, setSecurityDeposit] = useState(null)
//   const [pendingExpenses, setPendingExpenses] = useState([])
//   const [isLoadingDeposit, setIsLoadingDeposit] = useState(false)
//   const [isLoadingExpenses, setIsLoadingExpenses] = useState(false)
//   const [showSecurityModal, setShowSecurityModal] = useState(false)
//   const [showExpensesModal, setShowExpensesModal] = useState(false)
//   const [currentAdmissionId, setCurrentAdmissionId] = useState(null)

//   // --- NEW: Final Settlement State ---
//   const [settlementData, setSettlementData] = useState(null)
//   const [isLoadingSettlement, setIsLoadingSettlement] = useState(false)
//   const [isGeneratingSettlement, setIsGeneratingSettlement] = useState(false)
//   const [isProcessingSettlement, setIsProcessingSettlement] = useState(false)
//   const [settlementError, setSettlementError] = useState('')
//   const [settlementSuccess, setSettlementSuccess] = useState('')
//   const [showSettlementSection, setShowSettlementSection] = useState(false)

//   const statusColors = getStatusColor(bed?.rentStatus)
//   const showReminder = ['DUE', 'OVERDUE', 'NOT PAID'].includes(bed?.rentStatus)

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A'
//     const date = new Date(dateString)
//     return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
//   }

//   // --- NEW: Fetch Settlement Data ---
//   const fetchSettlement = async (admissionId) => {
//     if (!admissionId) return
    
//     setIsLoadingSettlement(true)
//     setSettlementError('')
//     setSettlementSuccess('')
    
//     try {
//       const response = await getSettlement(admissionId)
//       console.log('Settlement response:', response)
      
//       if (response?.success && response?.data) {
//         setSettlementData(response.data)
//         setShowSettlementSection(true)
//       } else {
//         setSettlementData(null)
//         setShowSettlementSection(true)
//       }
//     } catch (err) {
//       console.error('Error fetching settlement:', err)
//       setSettlementData(null)
//       setShowSettlementSection(true)
//     } finally {
//       setIsLoadingSettlement(false)
//     }
//   }

//   // --- NEW: Generate Settlement ---
//   const handleGenerateSettlement = async () => {
//     if (!bed?.admissionId) {
//       setSettlementError('No admission ID found')
//       return
//     }

//     setIsGeneratingSettlement(true)
//     setSettlementError('')
//     setSettlementSuccess('')

//     try {
//       const requestData = {
//         AdmissionID: bed.admissionId,
//         CheckoutDate: new Date().toISOString().split('T')[0],
//         Remarks: 'Final settlement generation',
//         CreatedBy: 1
//       }

//       const response = await generateSettlement(requestData)
//       console.log('Generate settlement response:', response)

//       if (response?.success && response?.data) {
//         setSettlementSuccess('Settlement generated successfully!')
//         // Fetch the updated settlement data
//         await fetchSettlement(bed.admissionId)
//       } else {
//         setSettlementError(response?.message || 'Failed to generate settlement')
//       }
//     } catch (err) {
//       console.error('Error generating settlement:', err)
//       setSettlementError(err.message || 'Failed to generate settlement')
//     } finally {
//       setIsGeneratingSettlement(false)
//     }
//   }

//   // --- NEW: Process Settlement (Submit) ---
//   const handleProcessSettlement = async () => {
//     if (!settlementData?.SettlementID) {
//       setSettlementError('No settlement ID found')
//       return
//     }

//     setIsProcessingSettlement(true)
//     setSettlementError('')
//     setSettlementSuccess('')

//     try {
//       const requestData = {
//         SettlementID: settlementData.SettlementID,
//         CreatedBy: 1
//       }

//       const response = await processSettlement(requestData)
//       console.log('Process settlement response:', response)

//       if (response?.success) {
//         setSettlementSuccess('Settlement processed successfully!')
//         // Refresh settlement data
//         await fetchSettlement(bed.admissionId)
//         // Notify parent
//         if (onSuccess) {
//           onSuccess(bed.bedId, 'SETTLED')
//         }
//         // Auto close after 2 seconds
//         setTimeout(() => {
//           onClose()
//         }, 2000)
//       } else {
//         setSettlementError(response?.message || 'Failed to process settlement')
//       }
//     } catch (err) {
//       console.error('Error processing settlement:', err)
//       setSettlementError(err.message || 'Failed to process settlement')
//     } finally {
//       setIsProcessingSettlement(false)
//     }
//   }

//   // Fetch tenant statement
//   useEffect(() => {
//     const fetchTenantStatement = async () => {
//       if (bed?.admissionId && pgId) {
//         setIsLoadingStatement(true)
//         try {
//           const response = await getTenantStatement(bed.admissionId, pgId)
//           setTenantStatement(response || [])
//         } catch (err) {
//           console.error('Error fetching tenant statement:', err)
//           setTenantStatement([])
//         } finally {
//           setIsLoadingStatement(false)
//         }
//       }
//     }
//     fetchTenantStatement()
//   }, [bed?.admissionId, pgId])

//   // Fetch security deposit with transactions
//   useEffect(() => {
//     const fetchSecurityDeposit = async () => {
//       if (!bed?.admissionId) return
      
//       setIsLoadingDeposit(true)
//       try {
//         const response = await getSecurityDeposit(bed.admissionId)
//         console.log('Fetched security deposit:', response)
//         if (response?.data) {
//           setSecurityDeposit(response.data)
//         } else {
//           setSecurityDeposit(null)
//         }
//       } catch (err) {
//         console.error('Error fetching security deposit:', err)
//         setSecurityDeposit(null)
//       } finally {
//         setIsLoadingDeposit(false)
//       }
//     }
//     fetchSecurityDeposit()
//   }, [bed?.admissionId])

//   // Fetch pending expenses
//   useEffect(() => {
//     const fetchPendingExpenses = async () => {
//       if (!bed?.admissionId || !pgId) return
      
//       setCurrentAdmissionId(bed.admissionId)
//       setIsLoadingExpenses(true)
//       try {
//         const response = await getTenantPendingExpenses(pgId, bed.admissionId)
//         console.log('Fetched pending expenses:', response)
//         if (response?.data && Array.isArray(response.data)) {
//           setPendingExpenses(response.data)
//         } else {
//           setPendingExpenses([])
//         }
//       } catch (err) {
//         console.error('Error fetching pending expenses:', err)
//         setPendingExpenses([])
//       } finally {
//         setIsLoadingExpenses(false)
//       }
//     }
//     fetchPendingExpenses()
//   }, [bed?.admissionId, pgId])

//   // --- NEW: Fetch settlement when modal opens ---
//   useEffect(() => {
//     if (bed?.admissionId) {
//       fetchSettlement(bed.admissionId)
//     }
//   }, [bed?.admissionId])

//   if (!bed) return null

//   const handleSubmit = async () => {
//     if (!netPayment || netPayment.trim() === '') {
//       setError('Please enter net payment amount')
//       return
//     }
//     const paymentAmount = parseInt(netPayment)
//     if (isNaN(paymentAmount) || paymentAmount <= 0) {
//       setError('Please enter a valid payment amount')
//       return
//     }
//     if (!bed?.admissionId) {
//       setError('No admission ID found')
//       return
//     }

//     setIsProcessing(true)
//     setError('')

//     try {
//       const paymentData = {
//         AdmissionID: bed.admissionId,
//         PaymentAmount: paymentAmount,
//         PaymentMode: paymentMode,
//         DueinMonth: bed.RentdueInMonth
//       }
//       const response = await process_rent_payment(paymentData)
//       if (response.success) {
//         onSuccess(bed.bedId, 'PAID')
//         onClose()
//       } else {
//         setError(response.message || 'Payment failed')
//       }
//     } catch (err) {
//       setError(err.message || 'An error occurred')
//     } finally {
//       setIsProcessing(false)
//     }
//   }

//   const maxPayable = bed.NetPayable || bed.rent || 0

//   const handleReminderClick = () => {
//     if (onSendReminder) {
//       onSendReminder(bed)
//     }
//     onClose()
//   }

//   const totalPendingExpenses = pendingExpenses.reduce((sum, exp) => sum + (exp.Amount || 0), 0)

//   // Handle successful transaction
//   const handleTransactionComplete = (updatedDeposit) => {
//     setSecurityDeposit(updatedDeposit)
//     if (onSuccess) {
//       onSuccess(bed.bedId, updatedDeposit.Status)
//     }
//   }

//   // Format currency for settlement display
//   const formatSettlementAmount = (amount) => {
//     return `₹${(amount || 0).toLocaleString('en-IN')}`
//   }

//   return (
//     <div className="rv-modal-overlay">
//       <div className="rv-rent-popover rv-modal-compact" onClick={e => e.stopPropagation()}>
//         <div className="rv-rp-head">
//           <span className="rv-rp-name">{bed.name || 'Tenant'}</span>
//           <button className="rv-rp-close" onClick={onClose}>
//             <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
//               <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
//             </svg>
//           </button>
//         </div>

//         <div className="rv-rp-status-due-row">
//           <div className="rv-rp-status">
//             <span className="rv-rp-label">Status:</span>
//             <span className="rv-rp-badge" style={{ background: statusColors.bg, color: statusColors.color }}>
//               <span className="rv-rp-dot" style={{ background: statusColors.dot }} />
//               {bed.rentStatus === 'NOT PAID' ? 'NOT PAID' : (bed.rentStatus || 'NA')}
//             </span>
//           </div>
//           <div className="rv-rp-reminder-wrapper">
//             {showReminder && (
//               <button
//                 className="rv-rp-reminder-btn"
//                 onClick={handleReminderClick}
//                 title="Send WhatsApp reminder"
//               >
//                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                   <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" />
//                   <path d="M13.73 21a2 2 0 01-3.46 0" />
//                 </svg>
//                 Send Reminder
//               </button>
//             )}
//           </div>
//         </div>

//         {/* Security Deposit and Expense Buttons Row */}
//         <div className="rv-rp-action-buttons">
//           <button
//             className="rv-rp-action-btn rv-rp-deposit-btn"
//             onClick={() => setShowSecurityModal(true)}
//             disabled={isLoadingDeposit}
//           >
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//               <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" />
//               <path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16" stroke="currentColor" />
//             </svg>
//             Security Deposit
//             {!isLoadingDeposit && securityDeposit && (
//               <span className="rv-rp-action-amount rv-rp-deposit-amount">
//                 {fmt(securityDeposit.ReceivedAmount)}
//               </span>
//             )}
//             {isLoadingDeposit && <span className="rv-rp-action-loader">...</span>}
//           </button>

//           <button
//             className="rv-rp-action-btn rv-rp-expense-btn"
//             onClick={() => setShowExpensesModal(true)}
//             disabled={isLoadingExpenses}
//           >
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//               <rect x="2" y="3" width="20" height="18" rx="2" stroke="currentColor" />
//               <path d="M8 7h8M8 11h6M8 15h4" stroke="currentColor" strokeLinecap="round" />
//             </svg>
//             Expenses
//             {!isLoadingExpenses && pendingExpenses.length > 0 && (
//               <span className="rv-rp-action-amount rv-rp-expense-amount">
//                 {fmt(totalPendingExpenses)}
//               </span>
//             )}
//             {isLoadingExpenses && <span className="rv-rp-action-loader">...</span>}
//           </button>
//         </div>

//         {/* --- NEW: Final Settlement Section --- */}
//         {showSettlementSection && (
//           <div className="rv-settlement-section">
//             <div className="rv-settlement-header">
//               <h4 className="rv-settlement-title">Final Settlement</h4>
//               {isLoadingSettlement && (
//                 <span className="rv-settlement-loader">Loading...</span>
//               )}
//             </div>

//             {isLoadingSettlement ? (
//               <div className="rv-settlement-loading">
//                 <span className="rv-spinner-small"></span> Loading settlement details...
//               </div>
//             ) : settlementData ? (
//               <>
//                 {/* Settlement Details Grid */}
//                 <div className="rv-settlement-grid">
//                   <div className="rv-settlement-item">
//                     <span className="rv-settlement-label">Settlement ID</span>
//                     <span className="rv-settlement-value">{settlementData.SettlementID || 'N/A'}</span>
//                   </div>
//                   <div className="rv-settlement-item">
//                     <span className="rv-settlement-label">Status</span>
//                     <span className={`rv-settlement-status rv-settlement-status-${settlementData.Status?.toLowerCase() || 'pending'}`}>
//                       {settlementData.Status || 'PENDING'}
//                     </span>
//                   </div>
//                   <div className="rv-settlement-item">
//                     <span className="rv-settlement-label">Checkout Date</span>
//                     <span className="rv-settlement-value">{formatDate(settlementData.CheckoutDate)}</span>
//                   </div>
//                   <div className="rv-settlement-item">
//                     <span className="rv-settlement-label">Rent Due</span>
//                     <span className="rv-settlement-value rv-settlement-amount">{formatSettlementAmount(settlementData.RentDue)}</span>
//                   </div>
//                   <div className="rv-settlement-item">
//                     <span className="rv-settlement-label">Electricity Due</span>
//                     <span className="rv-settlement-value rv-settlement-amount">{formatSettlementAmount(settlementData.ElectricityDue)}</span>
//                   </div>
//                   <div className="rv-settlement-item">
//                     <span className="rv-settlement-label">Food Due</span>
//                     <span className="rv-settlement-value rv-settlement-amount">{formatSettlementAmount(settlementData.FoodDue)}</span>
//                   </div>
//                   <div className="rv-settlement-item">
//                     <span className="rv-settlement-label">Expense Due</span>
//                     <span className="rv-settlement-value rv-settlement-amount">{formatSettlementAmount(settlementData.ExpenseDue)}</span>
//                   </div>
//                   <div className="rv-settlement-item">
//                     <span className="rv-settlement-label">Total Due</span>
//                     <span className="rv-settlement-value rv-settlement-total">{formatSettlementAmount(settlementData.TotalDue)}</span>
//                   </div>
//                   <div className="rv-settlement-item">
//                     <span className="rv-settlement-label">Security Deposit</span>
//                     <span className="rv-settlement-value rv-settlement-deposit">{formatSettlementAmount(settlementData.SecurityDeposit)}</span>
//                   </div>
//                   <div className="rv-settlement-item">
//                     <span className="rv-settlement-label">Deposit Adjusted</span>
//                     <span className="rv-settlement-value">{formatSettlementAmount(settlementData.DepositAdjusted)}</span>
//                   </div>
//                   <div className="rv-settlement-item">
//                     <span className="rv-settlement-label">Deposit Refund</span>
//                     <span className="rv-settlement-value rv-settlement-refund">{formatSettlementAmount(settlementData.DepositRefund)}</span>
//                   </div>
//                   <div className="rv-settlement-item">
//                     <span className="rv-settlement-label">Net Payable</span>
//                     <span className="rv-settlement-value rv-settlement-net">{formatSettlementAmount(settlementData.NetPayable)}</span>
//                   </div>
//                 </div>

//                 {/* Submit Button - Only show if settlement exists */}
//                 {settlementData.Status !== 'CLOSED' && settlementData.Status !== 'COMPLETED' && (
//                   <button
//                     className="rv-settlement-submit-btn"
//                     onClick={handleProcessSettlement}
//                     disabled={isProcessingSettlement}
//                   >
//                     {isProcessingSettlement ? (
//                       <>
//                         <span className="rv-spinner-small"></span>
//                         Processing...
//                       </>
//                     ) : (
//                       'Submit Settlement'
//                     )}
//                   </button>
//                 )}

//                 {settlementData.Status === 'CLOSED' && (
//                   <div className="rv-settlement-closed-msg">
//                     ✓ Settlement already processed
//                   </div>
//                 )}
//               </>
//             ) : (
//               // No settlement found - Show Generate button
//               <div className="rv-settlement-empty">
//                 <p className="rv-settlement-empty-text">No settlement found for this tenant</p>
//                 <button
//                   className="rv-settlement-generate-btn"
//                   onClick={handleGenerateSettlement}
//                   disabled={isGeneratingSettlement}
//                 >
//                   {isGeneratingSettlement ? (
//                     <>
//                       <span className="rv-spinner-small"></span>
//                       Generating...
//                     </>
//                   ) : (
//                     'Generate Settlement'
//                   )}
//                 </button>
//               </div>
//             )}

//             {/* Settlement Messages */}
//             {settlementError && (
//               <div className="rv-settlement-error">{settlementError}</div>
//             )}
//             {settlementSuccess && (
//               <div className="rv-settlement-success">{settlementSuccess}</div>
//             )}
//           </div>
//         )}

//         {isLoadingStatement ? (
//           <div className="rv-statement-loading">
//             <span className="rv-spinner-small"></span> Loading statement...
//           </div>
//         ) : tenantStatement.length > 0 ? (
//           <div className="rv-tenant-statement">
//             <div className="rv-statement-title">Monthly Statement</div>
//             <div className="rv-statement-table-wrapper">
//               <table className="rv-statement-table">
//                 <thead>
//                   <tr>
//                     <th>Month</th><th>Year</th><th>Rent (₹)</th>
//                     <th>Electricity (₹)</th><th>Rent Due (₹)</th>
//                     <th>Paid (₹)</th><th>Net Payable (₹)</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {tenantStatement.map((item, idx) => (
//                     <tr key={idx}>
//                       <td>{item.MonthName}</td>
//                       <td>{item.InvoiceYear}</td>
//                       <td>{(item.RentAmount || 0).toLocaleString('en-IN')}</td>
//                       <td>{(item.ElectricityAmount || 0).toLocaleString('en-IN')}</td>
//                       <td>{(item.TotalAmount || 0).toLocaleString('en-IN')}</td>
//                       <td className="rv-paid-amount">{(item.PaidAmount || 0).toLocaleString('en-IN')}</td>
//                       <td className="rv-netpayable-amount">{(item.NetPayable || 0).toLocaleString('en-IN')}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         ) : null}

//         <div className="rv-rp-amount-grid">
//           <div className="rv-rp-amount-item rv-rp-netpayable-item">
//             <span className="rv-rp-label">Total Net Payable:</span>
//             <span className="rv-rp-value">{fmt(maxPayable)}</span>
//           </div>
//         </div>

//         <div className="rv-rp-netpayment">
//           <label className="rv-rp-netpayment-label">
//             Net Payment <span className="rv-required">*</span>
//           </label>
//           <div className="rv-rp-netpayment-input-wrap">
//             <span className="rv-rp-currency-symbol">₹</span>
//             <input
//               type="number"
//               className="rv-rp-netpayment-input"
//               placeholder="Enter payment amount"
//               value={netPayment}
//               onChange={(e) => setNetPayment(e.target.value)}
//               max={maxPayable}
//               min="1"
//               step="1"
//               required
//             />
//           </div>
//         </div>

//         <div className="rv-rp-payment-mode">
//           <label className="rv-rp-payment-label">Payment Mode:</label>
//           <select
//             value={paymentMode}
//             onChange={(e) => setPaymentMode(e.target.value)}
//             className="rv-rp-payment-select"
//           >
//             <option value="CASH">💵 CASH</option>
//             <option value="UPI">📱 UPI</option>
//             <option value="BANK">🏦 BANK</option>
//           </select>
//         </div>

//         {error && <div className="rv-rp-error">{error}</div>}

//         <button
//           className="rv-rp-mark-btn"
//           onClick={handleSubmit}
//           disabled={isProcessing}
//         >
//           {isProcessing ? 'Processing...' : 'Confirm Payment'}
//         </button>
//       </div>

//       {/* Security Deposit Modal */}
//       {showSecurityModal && (
//         <SecurityDepositModal
//           depositData={securityDeposit}
//           admissionId={bed?.admissionId}
//           onClose={() => setShowSecurityModal(false)}
//           onTransactionComplete={handleTransactionComplete}
//         />
//       )}

//       {/* Pending Expenses Modal */}
//       {showExpensesModal && (
//         <PendingExpensesModal
//           expenses={pendingExpenses}
//           admissionId={currentAdmissionId || bed?.admissionId}
//           pgId={pgId}
//           onClose={() => setShowExpensesModal(false)}
//           onSuccess={() => {
//             const fetchExpenses = async () => {
//               if (bed?.admissionId && pgId) {
//                 try {
//                   const response = await getTenantPendingExpenses(pgId, bed.admissionId)
//                   if (response?.data && Array.isArray(response.data)) {
//                     setPendingExpenses(response.data)
//                   }
//                 } catch (err) {
//                   console.error('Error refreshing expenses:', err)
//                 }
//               }
//             }
//             fetchExpenses()
//           }}
//         />
//       )}
//     </div>
//   )
// }



// const RentPaymentModal = ({ pgId, bed, onClose, onSuccess, onSendReminder }) => {
//   const [paymentMode, setPaymentMode] = useState('CASH')
//   const [netPayment, setNetPayment] = useState('')
//   const [isProcessing, setIsProcessing] = useState(false)
//   const [error, setError] = useState('')
//   const [tenantStatement, setTenantStatement] = useState([])
//   const [isLoadingStatement, setIsLoadingStatement] = useState(false)
  
//   // New state for security deposit and expenses
//   const [securityDeposit, setSecurityDeposit] = useState(null)
//   const [pendingExpenses, setPendingExpenses] = useState([])
//   const [isLoadingDeposit, setIsLoadingDeposit] = useState(false)
//   const [isLoadingExpenses, setIsLoadingExpenses] = useState(false)
//   const [showSecurityModal, setShowSecurityModal] = useState(false)
//   const [showExpensesModal, setShowExpensesModal] = useState(false)


//   const [currentAdmissionId, setCurrentAdmissionId] = useState(null)

//   const statusColors = getStatusColor(bed?.rentStatus)
//   const showReminder = ['DUE', 'OVERDUE', 'NOT PAID'].includes(bed?.rentStatus)

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A'
//     const date = new Date(dateString)
//     return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
//   }

//   // Fetch tenant statement
//   useEffect(() => {
//     const fetchTenantStatement = async () => {
//       if (bed?.admissionId && pgId) {
//         setIsLoadingStatement(true)
//         try {
//           const response = await getTenantStatement(bed.admissionId, pgId)
//           setTenantStatement(response || [])
//         } catch (err) {
//           console.error('Error fetching tenant statement:', err)
//           setTenantStatement([])
//         } finally {
//           setIsLoadingStatement(false)
//         }
//       }
//     }
//     fetchTenantStatement()
//   }, [bed?.admissionId, pgId])

//   // Fetch security deposit with transactions
//   useEffect(() => {
//     const fetchSecurityDeposit = async () => {
//       if (!bed?.admissionId) return
      
//       setIsLoadingDeposit(true)
//       try {
//         const response = await getSecurityDeposit(bed.admissionId)
//         console.log('Fetched security deposit:', response)
//         if (response?.data) {
//           setSecurityDeposit(response.data)
//         } else {
//           setSecurityDeposit(null)
//         }
//       } catch (err) {
//         console.error('Error fetching security deposit:', err)
//         setSecurityDeposit(null)
//       } finally {
//         setIsLoadingDeposit(false)
//       }
//     }
//     fetchSecurityDeposit()
//   }, [bed?.admissionId])


  
//   // Fetch pending expenses
//   useEffect(() => {
//     const fetchPendingExpenses = async () => {
//       if (!bed?.admissionId || !pgId) return
      
//       setCurrentAdmissionId(bed.admissionId)
//       setIsLoadingExpenses(true)
//       try {
//         const response = await getTenantPendingExpenses(pgId, bed.admissionId)
//         console.log('Fetched pending expenses:', response)
//         if (response?.data && Array.isArray(response.data)) {
//           setPendingExpenses(response.data)
//         } else {
//           setPendingExpenses([])
//         }
//       } catch (err) {
//         console.error('Error fetching pending expenses:', err)
//         setPendingExpenses([])
//       } finally {
//         setIsLoadingExpenses(false)
//       }
//     }
//     fetchPendingExpenses()
//   }, [bed?.admissionId, pgId])

//   if (!bed) return null

//   const handleSubmit = async () => {
//     if (!netPayment || netPayment.trim() === '') {
//       setError('Please enter net payment amount')
//       return
//     }
//     const paymentAmount = parseInt(netPayment)
//     if (isNaN(paymentAmount) || paymentAmount <= 0) {
//       setError('Please enter a valid payment amount')
//       return
//     }
//     if (!bed?.admissionId) {
//       setError('No admission ID found')
//       return
//     }

//     setIsProcessing(true)
//     setError('')

//     try {
//       const paymentData = {
//         AdmissionID: bed.admissionId,
//         PaymentAmount: paymentAmount,
//         PaymentMode: paymentMode,
//         DueinMonth: bed.RentdueInMonth
//       }
//       const response = await process_rent_payment(paymentData)
//       if (response.success) {
//         onSuccess(bed.bedId, 'PAID')
//         onClose()
//       } else {
//         setError(response.message || 'Payment failed')
//       }
//     } catch (err) {
//       setError(err.message || 'An error occurred')
//     } finally {
//       setIsProcessing(false)
//     }
//   }

//   const maxPayable = bed.NetPayable || bed.rent || 0

//   const handleReminderClick = () => {
//     if (onSendReminder) {
//       onSendReminder(bed)
//     }
//     onClose()
//   }

//   const totalPendingExpenses = pendingExpenses.reduce((sum, exp) => sum + (exp.Amount || 0), 0)

//   // Handle successful transaction
//   const handleTransactionComplete = (updatedDeposit) => {
//     setSecurityDeposit(updatedDeposit)
//     // Optionally refresh parent data
//     if (onSuccess) {
//       onSuccess(bed.bedId, updatedDeposit.Status)
//     }
//   }

//   return (
//     <div className="rv-modal-overlay">
//       <div className="rv-rent-popover rv-modal-compact" onClick={e => e.stopPropagation()}>
//         <div className="rv-rp-head">
//           <span className="rv-rp-name">{bed.name || 'Tenant'}</span>
//           <button className="rv-rp-close" onClick={onClose}>
//             <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
//               <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
//             </svg>
//           </button>
//         </div>

//         <div className="rv-rp-status-due-row">
//           <div className="rv-rp-status">
//             <span className="rv-rp-label">Status:</span>
//             <span className="rv-rp-badge" style={{ background: statusColors.bg, color: statusColors.color }}>
//               <span className="rv-rp-dot" style={{ background: statusColors.dot }} />
//               {bed.rentStatus === 'NOT PAID' ? 'NOT PAID' : (bed.rentStatus || 'NA')}
//             </span>
//           </div>
//           <div className="rv-rp-reminder-wrapper">
//             {showReminder && (
//               <button
//                 className="rv-rp-reminder-btn"
//                 onClick={handleReminderClick}
//                 title="Send WhatsApp reminder"
//               >
//                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                   <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" />
//                   <path d="M13.73 21a2 2 0 01-3.46 0" />
//                 </svg>
//                 Send Reminder
//               </button>
//             )}
//           </div>
//         </div>

//         {/* Security Deposit and Expense Buttons Row */}
//         <div className="rv-rp-action-buttons">
//           <button
//             className="rv-rp-action-btn rv-rp-deposit-btn"
//             onClick={() => setShowSecurityModal(true)}
//             disabled={isLoadingDeposit}
//           >
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//               <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" />
//               <path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16" stroke="currentColor" />
//             </svg>
//             Security Deposit
//             {!isLoadingDeposit && securityDeposit && (
//               <span className="rv-rp-action-amount rv-rp-deposit-amount">
//                 {fmt(securityDeposit.ReceivedAmount)}
//               </span>
//             )}
//             {isLoadingDeposit && <span className="rv-rp-action-loader">...</span>}
//           </button>

//           <button
//             className="rv-rp-action-btn rv-rp-expense-btn"
//             onClick={() => setShowExpensesModal(true)}
//             disabled={isLoadingExpenses}
//           >
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//               <rect x="2" y="3" width="20" height="18" rx="2" stroke="currentColor" />
//               <path d="M8 7h8M8 11h6M8 15h4" stroke="currentColor" strokeLinecap="round" />
//             </svg>
//             Expenses
//             {!isLoadingExpenses && pendingExpenses.length > 0 && (
//               <span className="rv-rp-action-amount rv-rp-expense-amount">
//                 {fmt(totalPendingExpenses)}
//               </span>
//             )}
//             {isLoadingExpenses && <span className="rv-rp-action-loader">...</span>}
//           </button>
//         </div>

//         {isLoadingStatement ? (
//           <div className="rv-statement-loading">
//             <span className="rv-spinner-small"></span> Loading statement...
//           </div>
//         ) : tenantStatement.length > 0 ? (
//           <div className="rv-tenant-statement">
//             <div className="rv-statement-title">Monthly Statement</div>
//             <div className="rv-statement-table-wrapper">
//               <table className="rv-statement-table">
//                 <thead>
//                   <tr>
//                     <th>Month</th><th>Year</th><th>Rent (₹)</th>
//                     <th>Electricity (₹)</th><th>Total (₹)</th>
//                     <th>Paid (₹)</th><th>Net Payable (₹)</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {tenantStatement.map((item, idx) => (
//                     <tr key={idx}>
//                       <td>{item.MonthName}</td>
//                       <td>{item.InvoiceYear}</td>
//                       <td>{(item.RentAmount || 0).toLocaleString('en-IN')}</td>
//                       <td>{(item.ElectricityAmount || 0).toLocaleString('en-IN')}</td>
//                       <td>{(item.TotalAmount || 0).toLocaleString('en-IN')}</td>
//                       <td className="rv-paid-amount">{(item.PaidAmount || 0).toLocaleString('en-IN')}</td>
//                       <td className="rv-netpayable-amount">{(item.NetPayable || 0).toLocaleString('en-IN')}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         ) : null}

//         <div className="rv-rp-amount-grid">
//           <div className="rv-rp-amount-item rv-rp-netpayable-item">
//             <span className="rv-rp-label">Total Net Payable:</span>
//             <span className="rv-rp-value">{fmt(maxPayable)}</span>
//           </div>
//         </div>

//         <div className="rv-rp-netpayment">
//           <label className="rv-rp-netpayment-label">
//             Net Payment <span className="rv-required">*</span>
//           </label>
//           <div className="rv-rp-netpayment-input-wrap">
//             <span className="rv-rp-currency-symbol">₹</span>
//             <input
//               type="number"
//               className="rv-rp-netpayment-input"
//               placeholder="Enter payment amount"
//               value={netPayment}
//               onChange={(e) => setNetPayment(e.target.value)}
//               max={maxPayable}
//               min="1"
//               step="1"
//               required
//             />
//           </div>
//         </div>

//         <div className="rv-rp-payment-mode">
//           <label className="rv-rp-payment-label">Payment Mode:</label>
//           <select
//             value={paymentMode}
//             onChange={(e) => setPaymentMode(e.target.value)}
//             className="rv-rp-payment-select"
//           >
//             <option value="CASH">💵 CASH</option>
//             <option value="UPI">📱 UPI</option>
//             <option value="BANK">🏦 BANK</option>
//           </select>
//         </div>

//         {error && <div className="rv-rp-error">{error}</div>}

//         <button
//           className="rv-rp-mark-btn"
//           onClick={handleSubmit}
//           disabled={isProcessing}
//         >
//           {isProcessing ? 'Processing...' : 'Confirm Payment'}
//         </button>
//       </div>

//       {/* Security Deposit Modal - Updated with transaction handling */}
//       {showSecurityModal && (
//         <SecurityDepositModal
//           depositData={securityDeposit}
//           admissionId={bed?.admissionId}
//           onClose={() => setShowSecurityModal(false)}
//           onTransactionComplete={handleTransactionComplete}
//         />
//       )}

//       {/* Pending Expenses Modal */}
//       {showExpensesModal && (
//         // <PendingExpensesModal
//         //   expenses={pendingExpenses}
//         //   onClose={() => setShowExpensesModal(false)}
//         // />

//         <PendingExpensesModal
//           expenses={pendingExpenses}
//           admissionId={currentAdmissionId || bed?.admissionId}
//           pgId={pgId}
//           onClose={() => setShowExpensesModal(false)}
//           onSuccess={() => {
//             // Refresh expenses after payment
//             const fetchExpenses = async () => {
//               if (bed?.admissionId && pgId) {
//                 try {
//                   const response = await getTenantPendingExpenses(pgId, bed.admissionId)
//                   if (response?.data && Array.isArray(response.data)) {
//                     setPendingExpenses(response.data)
//                   }
//                 } catch (err) {
//                   console.error('Error refreshing expenses:', err)
//                 }
//               }
//             }
//             fetchExpenses()
//           }}
//         />
//       )}
//     </div>
//   )
// }

// const RentPaymentModal = ({ pgId, bed, onClose, onSuccess, onSendReminder }) => {
//   const [paymentMode, setPaymentMode] = useState('CASH')
//   const [netPayment, setNetPayment] = useState('')
//   const [isProcessing, setIsProcessing] = useState(false)
//   const [error, setError] = useState('')
//   const [tenantStatement, setTenantStatement] = useState([])
//   const [isLoadingStatement, setIsLoadingStatement] = useState(false)
  
//   // New state for security deposit and expenses
//   const [securityDeposit, setSecurityDeposit] = useState(null)
//   const [pendingExpenses, setPendingExpenses] = useState([])
//   const [isLoadingDeposit, setIsLoadingDeposit] = useState(false)
//   const [isLoadingExpenses, setIsLoadingExpenses] = useState(false)
//   const [showSecurityModal, setShowSecurityModal] = useState(false)
//   const [showExpensesModal, setShowExpensesModal] = useState(false)

//   const statusColors = getStatusColor(bed?.rentStatus)
//   const showReminder = ['DUE', 'OVERDUE', 'NOT PAID'].includes(bed?.rentStatus)

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A'
//     const date = new Date(dateString)
//     return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
//   }

//   // Fetch tenant statement
//   useEffect(() => {
//     const fetchTenantStatement = async () => {
//       if (bed?.admissionId && pgId) {
//         setIsLoadingStatement(true)
//         try {
//           const response = await getTenantStatement(bed.admissionId, pgId)
//           setTenantStatement(response || [])
//         } catch (err) {
//           console.error('Error fetching tenant statement:', err)
//           setTenantStatement([])
//         } finally {
//           setIsLoadingStatement(false)
//         }
//       }
//     }
//     fetchTenantStatement()
//   }, [bed?.admissionId, pgId])

//   // Fetch security deposit
//   useEffect(() => {
//     const fetchSecurityDeposit = async () => {
//       const admissionId = bed?.admissionId || 378 // Fallback to 378
//       setIsLoadingDeposit(true)
//       try {
//         const response = await getSecurityDeposit(admissionId)
//         console.log('Fetched security deposit:', response)
//         if (response?.data) {
//           setSecurityDeposit(response.data)
//         } else {
//           setSecurityDeposit(null)
//         }
//       } catch (err) {
//         console.error('Error fetching security deposit:', err)
//         setSecurityDeposit(null)
//       } finally {
//         setIsLoadingDeposit(false)
//       }
//     }
//     fetchSecurityDeposit()
//   }, [bed?.admissionId])

//   // Fetch pending expenses
//   useEffect(() => {
//     const fetchPendingExpenses = async () => {
//       const admissionId = bed?.admissionId || 326 // Fallback to 326
//       const pgIdValue = pgId || 5155
//       setIsLoadingExpenses(true)
//       try {
//         const response = await getTenantPendingExpenses(pgIdValue, admissionId)
//         console.log('Fetched pending expenses:', response)
//         if (response?.data && Array.isArray(response.data)) {
//           setPendingExpenses(response.data)
//         } else {
//           setPendingExpenses([])
//         }
//       } catch (err) {
//         console.error('Error fetching pending expenses:', err)
//         setPendingExpenses([])
//       } finally {
//         setIsLoadingExpenses(false)
//       }
//     }
//     fetchPendingExpenses()
//   }, [bed?.admissionId, pgId])

//   if (!bed) return null

//   const handleSubmit = async () => {
//     if (!netPayment || netPayment.trim() === '') {
//       setError('Please enter net payment amount')
//       return
//     }
//     const paymentAmount = parseInt(netPayment)
//     if (isNaN(paymentAmount) || paymentAmount <= 0) {
//       setError('Please enter a valid payment amount')
//       return
//     }
//     if (!bed?.admissionId) {
//       setError('No admission ID found')
//       return
//     }

//     setIsProcessing(true)
//     setError('')

//     try {
//       const paymentData = {
//         AdmissionID: bed.admissionId,
//         PaymentAmount: paymentAmount,
//         PaymentMode: paymentMode,
//         DueinMonth: bed.RentdueInMonth
//       }
//       const response = await process_rent_payment(paymentData)
//       if (response.success) {
//         onSuccess(bed.bedId, 'PAID')
//         onClose()
//       } else {
//         setError(response.message || 'Payment failed')
//       }
//     } catch (err) {
//       setError(err.message || 'An error occurred')
//     } finally {
//       setIsProcessing(false)
//     }
//   }

//   const maxPayable = bed.NetPayable || bed.rent || 0

//   const handleReminderClick = () => {
//     if (onSendReminder) {
//       onSendReminder(bed)
//     }
//     onClose()
//   }

//   const totalPendingExpenses = pendingExpenses.reduce((sum, exp) => sum + (exp.Amount || 0), 0)

//   return (
//     <div className="rv-modal-overlay">
//       <div className="rv-rent-popover rv-modal-compact" onClick={e => e.stopPropagation()}>
//         <div className="rv-rp-head">
//           <span className="rv-rp-name">{bed.name || 'Tenant'}</span>
//           <button className="rv-rp-close" onClick={onClose}>
//             <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
//               <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
//             </svg>
//           </button>
//         </div>

//         <div className="rv-rp-status-due-row">
//           <div className="rv-rp-status">
//             <span className="rv-rp-label">Status:</span>
//             <span className="rv-rp-badge" style={{ background: statusColors.bg, color: statusColors.color }}>
//               <span className="rv-rp-dot" style={{ background: statusColors.dot }} />
//               {bed.rentStatus === 'NOT PAID' ? 'NOT PAID' : (bed.rentStatus || 'NA')}
//             </span>
//           </div>
//           <div className="rv-rp-reminder-wrapper">
//             {showReminder && (
//               <button
//                 className="rv-rp-reminder-btn"
//                 onClick={handleReminderClick}
//                 title="Send WhatsApp reminder"
//               >
//                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                   <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" />
//                   <path d="M13.73 21a2 2 0 01-3.46 0" />
//                 </svg>
//                 Send Reminder
//               </button>
//             )}
//           </div>
//         </div>

//         {/* Security Deposit and Expense Buttons Row */}
//         <div className="rv-rp-action-buttons">
//           <button
//             className="rv-rp-action-btn rv-rp-deposit-btn"
//             onClick={() => setShowSecurityModal(true)}
//             disabled={isLoadingDeposit}
//           >
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//               <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" />
//               <path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16" stroke="currentColor" />
//             </svg>
//             Security Deposit
//             {!isLoadingDeposit && securityDeposit && (
//               <span className="rv-rp-action-amount rv-rp-deposit-amount">
//                 {fmt(securityDeposit.ReceivedAmount)}
//               </span>
//             )}
//             {isLoadingDeposit && <span className="rv-rp-action-loader">...</span>}
//           </button>

//           <button
//             className="rv-rp-action-btn rv-rp-expense-btn"
//             onClick={() => setShowExpensesModal(true)}
//             disabled={isLoadingExpenses}
//           >
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//               <rect x="2" y="3" width="20" height="18" rx="2" stroke="currentColor" />
//               <path d="M8 7h8M8 11h6M8 15h4" stroke="currentColor" strokeLinecap="round" />
//             </svg>
//             Expenses
//             {!isLoadingExpenses && pendingExpenses.length > 0 && (
//               <span className="rv-rp-action-amount rv-rp-expense-amount">
//                 {fmt(totalPendingExpenses)}
//               </span>
//             )}
//             {isLoadingExpenses && <span className="rv-rp-action-loader">...</span>}
//           </button>
//         </div>

//         {isLoadingStatement ? (
//           <div className="rv-statement-loading">
//             <span className="rv-spinner-small"></span> Loading statement...
//           </div>
//         ) : tenantStatement.length > 0 ? (
//           <div className="rv-tenant-statement">
//             <div className="rv-statement-title">Monthly Statement</div>
//             <div className="rv-statement-table-wrapper">
//               <table className="rv-statement-table">
//                 <thead>
//                   <tr>
//                     <th>Month</th><th>Year</th><th>Rent (₹)</th>
//                     <th>Electricity (₹)</th><th>Total (₹)</th>
//                     <th>Paid (₹)</th><th>Net Payable (₹)</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {tenantStatement.map((item, idx) => (
//                     <tr key={idx}>
//                       <td>{item.MonthName}</td>
//                       <td>{item.InvoiceYear}</td>
//                       <td>{(item.RentAmount || 0).toLocaleString('en-IN')}</td>
//                       <td>{(item.ElectricityAmount || 0).toLocaleString('en-IN')}</td>
//                       <td>{(item.TotalAmount || 0).toLocaleString('en-IN')}</td>
//                       <td className="rv-paid-amount">{(item.PaidAmount || 0).toLocaleString('en-IN')}</td>
//                       <td className="rv-netpayable-amount">{(item.NetPayable || 0).toLocaleString('en-IN')}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         ) : null}

//         <div className="rv-rp-amount-grid">
//           <div className="rv-rp-amount-item rv-rp-netpayable-item">
//             <span className="rv-rp-label">Total Net Payable:</span>
//             <span className="rv-rp-value">{fmt(maxPayable)}</span>
//           </div>
//         </div>

//         <div className="rv-rp-netpayment">
//           <label className="rv-rp-netpayment-label">
//             Net Payment <span className="rv-required">*</span>
//           </label>
//           <div className="rv-rp-netpayment-input-wrap">
//             <span className="rv-rp-currency-symbol">₹</span>
//             <input
//               type="number"
//               className="rv-rp-netpayment-input"
//               placeholder="Enter payment amount"
//               value={netPayment}
//               onChange={(e) => setNetPayment(e.target.value)}
//               max={maxPayable}
//               min="1"
//               step="1"
//               required
//             />
//           </div>
//         </div>

//         <div className="rv-rp-payment-mode">
//           <label className="rv-rp-payment-label">Payment Mode:</label>
//           <select
//             value={paymentMode}
//             onChange={(e) => setPaymentMode(e.target.value)}
//             className="rv-rp-payment-select"
//           >
//             <option value="CASH">💵 CASH</option>
//             <option value="UPI">📱 UPI</option>
//             <option value="BANK">🏦 BANK</option>
//           </select>
//         </div>

//         {error && <div className="rv-rp-error">{error}</div>}

//         <button
//           className="rv-rp-mark-btn"
//           onClick={handleSubmit}
//           disabled={isProcessing}
//         >
//           {isProcessing ? 'Processing...' : 'Confirm Payment'}
//         </button>
//       </div>

//       {/* Security Deposit Modal */}
//       {showSecurityModal && (
//         <SecurityDepositModal
//           depositData={securityDeposit}
//           onClose={() => setShowSecurityModal(false)}
//         />
//       )}

//       {/* Pending Expenses Modal */}
//       {showExpensesModal && (
//         <PendingExpensesModal
//           expenses={pendingExpenses}
//           onClose={() => setShowExpensesModal(false)}
//         />
//       )}
//     </div>
//   )
// }



// ─── OwnerRevenue main component ──────────────────────────────────



const OwnerRevenue = ({ selectedPG, selectedPGId }) => {
  const [floor, setFloor] = useState('all')
  const [selectedStatuses, setSelectedStatuses] = useState([])
  const [search, setSearch] = useState('')
  const [rooms, setRooms] = useState([])
  const [totals, setTotals] = useState({ total: 0, collected: 0, due: 0, overdue: 0, notPaid: 0 })
  const [floors, setFloors] = useState(['all'])
  const [localRentStatus, setLocalRentStatus] = useState({})
  const [selectedBed, setSelectedBed] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const [selectedDate, setSelectedDate] = useState(() => {
    const now = new Date();
    now.setHours(now.getHours() + 5);
    now.setMinutes(now.getMinutes() + 30);
    return now.toISOString().slice(0, 16);
  });
  const [isGenerating, setIsGenerating] = useState(false)
  const [generateMessage, setGenerateMessage] = useState(null)
  const [isGeneratingElectricity, setIsGeneratingElectricity] = useState(false)
  const [electricityMessage, setElectricityMessage] = useState(null)

  const [toast, setToast] = useState({ show: false, message: '', type: 'success' })

  const handleSendReminder = async (bed) => {
    console.log('Sending reminder for:', bed.name)
    setToast({
      show: true,
      message: `WhatsApp reminder sent to ${bed.name || 'tenant'}!`,
      type: 'success'
    })
    setTimeout(() => setToast({ show: false, message: '', type: 'success' }), 3000)
  }

  const floorOrder = {
    'Ground Floor': 0,
    '1st Floor': 1,
    '2nd Floor': 2,
    '3rd Floor': 3,
    '4th Floor': 4,
    '5th Floor': 5
  }

  const fetchRevenueData = async () => {
    try {
      const response = await getPGRevenueStatus(selectedPGId, selectedDate)
      const roomsMap = new Map()
      response.occupancyData.forEach(item => {
        const roomId = item.RoomID
        const floorStr = item.Floor || 'Unknown'
        if (!roomsMap.has(roomId)) {
          roomsMap.set(roomId, {
            id: item.RoomNumber,
            floor: floorStr,
            type: item.RoomType?.toLowerCase() || 'unknown',
            beds: []
          })
        }
        const room = roomsMap.get(roomId)
        const statusValue = item.status || item.Status || 'VACANT'
        const occupancyStatus = item.OccupancyStatus === 'VACANT' ? 'VACANT' : statusValue
        room.beds.push({
          bedId: item.BedID,
          name: item.TenantName || '',
          status: occupancyStatus || 'VACANT',
          rent: item.NetPayable || 0,
          rentStatus: statusValue || 'NA',
          admissionId: item.AdmissionID || item.admissionId,
          RentAmount: item.RentAmount,
          ElectricityAmount: item.ElectricityAmount,
          TotalAmount: item.TotalAmount,
          NetPayable: item.NetPayable,
          RentdueInMonth: item.RentDueInMonth || item.RentdueInMonth,
          DueDate: item.DueDate
        })
      })

      const roomsData = Array.from(roomsMap.values()).sort((a, b) => {
        const aFloorOrder = floorOrder[a.floor] !== undefined ? floorOrder[a.floor] : 999
        const bFloorOrder = floorOrder[b.floor] !== undefined ? floorOrder[b.floor] : 999
        if (aFloorOrder !== bFloorOrder) return aFloorOrder - bFloorOrder
        const aNum = parseInt(a.id), bNum = parseInt(b.id)
        if (!isNaN(aNum) && !isNaN(bNum)) return aNum - bNum
        return String(a.id).localeCompare(String(b.id))
      })
      setRooms(roomsData)

      const uniqueFloorsSet = new Set(roomsData.map(r => r.floor))
      const uniqueFloors = ['all', ...Array.from(uniqueFloorsSet).sort((a, b) => {
        const aOrder = floorOrder[a] !== undefined ? floorOrder[a] : 999
        const bOrder = floorOrder[b] !== undefined ? floorOrder[b] : 999
        return aOrder - bOrder
      })]
      setFloors(uniqueFloors)

      if (response.totalsArray && response.totalsArray[0]) {
        setTotals({
          total: response.totalsArray[0].Total || 0,
          collected: response.totalsArray[0].Collected || 0,
          due: response.totalsArray[0].Due || 0,
          overdue: response.totalsArray[0].Overdue || 0,
          notPaid: response.totalsArray[0].NotPaid || 0,
        })
      }
    } catch (error) {
      console.error('Error fetching revenue data:', error)
    }
  }

  useEffect(() => {
    if (selectedPGId) fetchRevenueData()
  }, [selectedPGId, selectedDate])

  const formatSQLDateTime = (dateTimeString) => {
    if (!dateTimeString) return 'N/A';
    const date = new Date(dateTimeString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const formatDisplayDateTime = (dateTimeString) => {
    if (!dateTimeString) return 'N/A';
    const date = new Date(dateTimeString);
    return date.toLocaleString('en-IN', { 
      day: 'numeric', 
      month: 'long', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  }

  const handleAutoGenerate = async () => {
    if (!selectedPGId) {
      setGenerateMessage({ type: 'error', text: 'No PG selected' })
      setTimeout(() => setGenerateMessage(null), 3000)
      return
    }
    setIsGenerating(true)
    setGenerateMessage(null)
    try {
      const formattedDateTime = formatSQLDateTime(selectedDate);
      const data = { PGID: selectedPGId, CurrDate: formattedDateTime }
      console.log('Auto-generate rent with data:', data)
      const response = await autoGenerateRent(data)
      if (response.success) {
        setGenerateMessage({ type: 'success', text: `Rent generated successfully! ${response.data?.affectedRecords || 0} records affected.` })
        await fetchRevenueData()
      } else {
        setGenerateMessage({ type: 'error', text: response.message || 'Failed to generate rent' })
      }
    } catch (error) {
      console.error('Error auto-generating rent:', error)
      setGenerateMessage({ type: 'error', text: error.message || 'An error occurred' })
    } finally {
      setIsGenerating(false)
      setTimeout(() => setGenerateMessage(null), 5000)
    }
  }

  const handleAutoGenerateElectricity = async () => {
    if (!selectedPGId) {
      setElectricityMessage({ type: 'error', text: 'No PG selected' })
      setTimeout(() => setElectricityMessage(null), 3000)
      return
    }
    const date = new Date(selectedDate)
    const month = date.getMonth() + 1
    const year = date.getFullYear()
    setIsGeneratingElectricity(true)
    setElectricityMessage(null)
    try {
      const data = { PGID: selectedPGId, Month: month, Year: year }
      console.log('Auto-generate electricity bill with data:', data)
      const response = await autoGenerateElectricityBill(data)
      if (response.success) {
        setElectricityMessage({ type: 'success', text: `Electricity bill generated successfully! ${response.data?.affectedRecords || 0} records affected.` })
        await fetchRevenueData()
      } else {
        setElectricityMessage({ type: 'error', text: response.message || 'Failed to generate electricity bill' })
      }
    } catch (error) {
      console.error('Error auto-generating electricity bill:', error)
      setElectricityMessage({ type: 'error', text: error.message || 'An error occurred' })
    } finally {
      setIsGeneratingElectricity(false)
      setTimeout(() => setElectricityMessage(null), 5000)
    }
  }

  const handleMarkRent = async (bedId, newStatus) => {
    setLocalRentStatus(prev => ({ ...prev, [bedId]: newStatus }))
    await fetchRevenueData()
  }

  const toggleStatusFilter = (statusKey) => {
    setSelectedStatuses(prev =>
      prev.includes(statusKey) ? prev.filter(s => s !== statusKey) : [...prev, statusKey]
    )
  }

  const filtered = rooms
    .map(room => {
      const filteredBeds = room.beds.filter(bed => {
        const matchesSearch = !search ||
          bed.name?.toLowerCase().includes(search.toLowerCase()) ||
          `room ${room.id}`.toLowerCase().includes(search.toLowerCase())
        let matchesStatus = true
        if (selectedStatuses.length > 0) {
          const bedStatus = localRentStatus[bed.bedId] || bed.rentStatus
          matchesStatus = selectedStatuses.includes(bedStatus)
        }
        return matchesSearch && matchesStatus
      })
      const matchesFloor = floor === 'all' || room.floor === floor
      if (matchesFloor && filteredBeds.length > 0) {
        return { ...room, beds: filteredBeds }
      }
      return null
    })
    .filter(room => room !== null)

  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })
  }

  return (
    <div className="rv-root">
      {toast.show && (
        <div className={`rv-toast rv-toast-${toast.type}`}>
          <span className="rv-toast-icon">✓</span>
          <span>{toast.message}</span>
        </div>
      )}

      {/* Commented out auto-generate section as per original */}

      {generateMessage && (
        <div className={`rv-message rv-message-${generateMessage.type}`}>
          {generateMessage.text}
        </div>
      )}
      {electricityMessage && (
        <div className={`rv-message rv-message-${electricityMessage.type}`}>
          {electricityMessage.text}
        </div>
      )}

      <div className="rv-summary">
        <div className="rv-legend">
          {['PAID','DUE','OVERDUE','NOT PAID'].map(k => (
            <span key={k} className="rv-legend-item">
              <span className="rv-dot" style={{ background: STATUS_CFG[k].dot }} />
              {STATUS_CFG[k].label}
            </span>
          ))}
        </div>
        <div className="rv-stats">
          <span>Total: <strong>{fmt(totals.total)}</strong></span>
          <span className="rv-stat-sep" />
          <span>Collected: <strong className="rv-green-1">{fmt(totals.collected)}</strong></span>
          <span className="rv-stat-sep" />
          <span>Due: <strong className="rv-blue-1">{fmt(totals.due)}</strong></span>
          <span className="rv-stat-sep" />
          <span>Overdue: <strong className="rv-orange-1">{fmt(totals.overdue)}</strong></span>
          <span className="rv-stat-sep" />
          <span>Not Paid: <strong className="rv-red-1">{fmt(totals.notPaid)}</strong></span>
        </div>
      </div>

      <div className="rv-controls">
        <div className="rv-search-wrap">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2.5" strokeLinecap="round">
            <circle cx="11" cy="11" r="8"/>
            <path d="M21 21l-4.35-4.35"/>
          </svg>
          <input className="rv-search" placeholder="Search room or tenant…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <div className="rv-filter-group">
          {floors.map(f => (
            <button key={f} className={`rv-floor-pill ${floor === f ? 'active' : ''}`} onClick={() => setFloor(f)}>
              {f === 'all' ? 'All' : f}
            </button>
          ))}
        </div>
        <div className="rv-filter-group">
          {STATUS_FILTERS.map(f => (
            <button
              key={f.key}
              className={`rv-status-pill`}
              style={{
                background: selectedStatuses.includes(f.key) ? f.bg : '#F3F4F6',
                color: selectedStatuses.includes(f.key) ? 'white' : '#4B5563',
                borderColor: selectedStatuses.includes(f.key) ? f.bg : '#E5E7EB',
                transition: 'all 0.2s ease'
              }}
              onClick={() => toggleStatusFilter(f.key)}
            >
              {f.label}
              {selectedStatuses.includes(f.key) && <span className="rv-checkmark"> ✓</span>}
            </button>
          ))}
        </div>
      </div>

      <div className="rv-grid">
        {filtered.map(room => (
          <div key={room.id} className="rv-card">
            <div className="rv-card-head">
              <div className="rv-card-head-left">
                <span className="rv-card-room">Room {room.id}</span>
                <div className="rv-card-badges">
                  <span className="rv-card-floor">{room.floor}</span>
                  <span className="rv-card-type">{room.type}</span>
                </div>
              </div>
            </div>

            <div className="rv-pill-grid">
              {room.beds.map((bed, i) => {
                const statusCfg = STATUS_CFG[bed.status] || STATUS_CFG.VACANT
                const effectiveRentStatus = localRentStatus[bed.bedId] || bed.rentStatus
                const isClickable = effectiveRentStatus !== 'PAID' && bed.status !== 'VACANT'

                return (
                  <div key={i} className="rv-pill-wrap">
                    <div
                      className={`rv-pill ${isClickable ? 'rv-pill-clickable' : ''}`}
                      style={{ background: statusCfg.bg, borderColor: statusCfg.border }}
                      onClick={() => {
                        if (isClickable) {
                          setSelectedBed(bed)
                          setIsModalOpen(true)
                        }
                      }}
                    >
                      <span className="rv-dot" style={{ background: statusCfg.dot }} />
                      <span className="rv-pill-name" style={{ color: statusCfg.text }}>
                        {bed.name || statusCfg.label}
                      </span>
                    </div>
                  </div>
                )
              })}
              {room.beds.length < 4 && [...Array(4 - room.beds.length)].map((_, i) => (
                <div key={`empty-${i}`} className="rv-pill rv-pill-ghost" />
              ))}
            </div>
          </div>
        ))}
      </div>

      {filtered.length === 0 && (
        <div className="rv-no-results">No tenants match your search criteria</div>
      )}

      {isModalOpen && (
        <RentPaymentModal
          pgId={selectedPGId}
          bed={selectedBed}
          onClose={() => { setIsModalOpen(false); setSelectedBed(null); }}
          onSuccess={handleMarkRent}
          onSendReminder={handleSendReminder}
        />
      )}
    </div>
  )
}

export default OwnerRevenue

// import '../scss/components/_ownerrevenue.scss'
// import React, { useState, useEffect } from 'react'
// import { getPGRevenueStatus, autoGenerateRent, process_rent_payment, autoGenerateElectricityBill, getTenantStatement } from '../apis/services/pgApi'

// const STATUS_CFG = {
//   PAID:        { label: 'Paid',       dot: 'green', bg: '#F0FDF4', border: 'green', text: 'green' },
//   DUE:         { label: 'Due',        dot: 'blue', bg: '#f0f6ff', border: 'blue', text: 'blue' },
//   OVERDUE:     { label: 'Overdue',    dot: 'orange', bg: '#FFF7ED', border: 'orange', text: 'orange' },
//   "NOT PAID":  { label: 'Not Paid',   dot: 'red', bg: '#FFF1F2', border: 'red', text: 'red' },
//   VACANT:      { label: 'Vacant',     dot: 'gray', bg: '#F9FAFB', border: 'gray', text: 'gray' },
// }

// const RENT_STATUS_CFG = {
//   PAID:     { label: 'Paid',     dot: 'green', bg: '#F0FDF4', border: 'green', text: 'green' },
//   DUE:      { label: 'Due',      dot: 'blue', bg: '#f0f6ff', border: 'blue', text: 'blue' },
//   OVERDUE:  { label: 'Overdue',  dot: 'orange', bg: '#FFF7ED', border: 'orange', text: 'orange' },
//   "NOT PAID":  { label: 'Not Paid',  dot: 'red', bg: '#FFF1F2', border: 'red', text: 'red' },
//   NA:       { label: 'N/A',      dot: 'gray', bg: '#F9FAFB', border: 'gray', text: 'gray' },
// }

// const fmt = n => `₹${(n || 0).toLocaleString('en-IN')}`

// const STATUS_FILTERS = [
//   { key: 'PAID', label: 'Paid' ,bg: 'green'},
//   { key: 'DUE', label: 'Due' ,bg: 'blue'},
//   { key: 'OVERDUE', label: 'Overdue' ,bg: 'orange'},
//   { key: 'NOT PAID', label: 'Not Paid' ,bg: 'red'},
// ]

// const getStatusColor = (status) => {
//   switch(status) {
//     case 'PAID':
//       return { bg: '#DCFCE7', color: '#166534', dot: '#22C55E' }
//     case 'DUE':
//       return { bg: '#f0f6ff', color: '#1b2d80', dot: '#1e49c0' }
//     case 'OVERDUE':
//       return { bg: '#FFEDD5', color: '#9A3412', dot: '#F97316' }
//     case 'NOT PAID':
//       return { bg: '#FEE2E2', color: '#991B1B', dot: '#EF4444' }
//     default:
//       return { bg: '#F3F4F6', color: '#6B7280', dot: '#9CA3AF' }
//   }
// }

// // ─── RentPaymentModal (with Send Reminder button) ────────────────
// const RentPaymentModal = ({ pgId, bed, onClose, onSuccess, onSendReminder }) => {
//   const [paymentMode, setPaymentMode] = useState('CASH')
//   const [netPayment, setNetPayment] = useState('')
//   const [isProcessing, setIsProcessing] = useState(false)
//   const [error, setError] = useState('')
//   const [tenantStatement, setTenantStatement] = useState([])
//   const [isLoadingStatement, setIsLoadingStatement] = useState(false)

//   const statusColors = getStatusColor(bed?.rentStatus)
//   const showReminder = ['DUE', 'OVERDUE', 'NOT PAID'].includes(bed?.rentStatus)

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A'
//     const date = new Date(dateString)
//     return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
//   }

//   useEffect(() => {
//     const fetchTenantStatement = async () => {
//       if (bed?.admissionId && pgId) {
//         setIsLoadingStatement(true)
//         try {
//           const response = await getTenantStatement(bed.admissionId, pgId)
//           setTenantStatement(response || [])
//         } catch (err) {
//           console.error('Error fetching tenant statement:', err)
//           setTenantStatement([])
//         } finally {
//           setIsLoadingStatement(false)
//         }
//       }
//     }
//     fetchTenantStatement()
//   }, [bed?.admissionId, pgId])

//   if (!bed) return null

//   const handleSubmit = async () => {
//     if (!netPayment || netPayment.trim() === '') {
//       setError('Please enter net payment amount')
//       return
//     }
//     const paymentAmount = parseInt(netPayment)
//     if (isNaN(paymentAmount) || paymentAmount <= 0) {
//       setError('Please enter a valid payment amount')
//       return
//     }
//     if (!bed?.admissionId) {
//       setError('No admission ID found')
//       return
//     }

//     setIsProcessing(true)
//     setError('')

//     try {
//       const paymentData = {
//         AdmissionID: bed.admissionId,
//         PaymentAmount: paymentAmount,
//         PaymentMode: paymentMode,
//         DueinMonth: bed.RentdueInMonth
//       }
//       const response = await process_rent_payment(paymentData)
//       if (response.success) {
//         onSuccess(bed.bedId, 'PAID')
//         onClose()
//       } else {
//         setError(response.message || 'Payment failed')
//       }
//     } catch (err) {
//       setError(err.message || 'An error occurred')
//     } finally {
//       setIsProcessing(false)
//     }
//   }

//   const maxPayable = bed.NetPayable || bed.rent || 0

//   const handleReminderClick = () => {
//     if (onSendReminder) {
//       onSendReminder(bed)
//     }
//     onClose() // close modal after sending reminder
//   }

//   return (
//     <div className="rv-modal-overlay">
//       <div className="rv-rent-popover rv-modal-compact" onClick={e => e.stopPropagation()}>
//         <div className="rv-rp-head">
//           <span className="rv-rp-name">{bed.name || 'Tenant'}</span>
//           <button className="rv-rp-close" onClick={onClose}>
//             <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
//               <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
//             </svg>
//           </button>
//         </div>

//         <div className="rv-rp-status-due-row">
//           <div className="rv-rp-status">
//             <span className="rv-rp-label">Status:</span>
//             <span className="rv-rp-badge" style={{ background: statusColors.bg, color: statusColors.color }}>
//               <span className="rv-rp-dot" style={{ background: statusColors.dot }} />
//               {bed.rentStatus === 'NOT PAID' ? 'NOT PAID' : (bed.rentStatus || 'NA')}
//             </span>
//           </div>
//           <div className="rv-rp-reminder-wrapper">
//             {showReminder && (
//               <button
//                 className="rv-rp-reminder-btn"
//                 onClick={handleReminderClick}
//                 title="Send WhatsApp reminder"
//               >
//                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                   <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" />
//                   <path d="M13.73 21a2 2 0 01-3.46 0" />
//                 </svg>
//                 Send Reminder
//               </button>
//             )}
//           </div>
//         </div>

//         {isLoadingStatement ? (
//           <div className="rv-statement-loading">
//             <span className="rv-spinner-small"></span> Loading statement...
//           </div>
//         ) : tenantStatement.length > 0 ? (
//           <div className="rv-tenant-statement">
//             <div className="rv-statement-title">Monthly Statement</div>
//             <div className="rv-statement-table-wrapper">
//               <table className="rv-statement-table">
//                 <thead>
//                   <tr>
//                     <th>Month</th><th>Year</th><th>Rent (₹)</th>
//                     <th>Electricity (₹)</th><th>Total (₹)</th>
//                     <th>Paid (₹)</th><th>Net Payable (₹)</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {tenantStatement.map((item, idx) => (
//                     <tr key={idx}>
//                       <td>{item.MonthName}</td>
//                       <td>{item.InvoiceYear}</td>
//                       <td>{(item.RentAmount || 0).toLocaleString('en-IN')}</td>
//                       <td>{(item.ElectricityAmount || 0).toLocaleString('en-IN')}</td>
//                       <td>{(item.TotalAmount || 0).toLocaleString('en-IN')}</td>
//                       <td className="rv-paid-amount">{(item.PaidAmount || 0).toLocaleString('en-IN')}</td>
//                       <td className="rv-netpayable-amount">{(item.NetPayable || 0).toLocaleString('en-IN')}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         ) : null}

//         <div className="rv-rp-amount-grid">
//           <div className="rv-rp-amount-item rv-rp-netpayable-item">
//             <span className="rv-rp-label">Total Net Payable:</span>
//             <span className="rv-rp-value">{fmt(maxPayable)}</span>
//           </div>
//         </div>

//         <div className="rv-rp-netpayment">
//           <label className="rv-rp-netpayment-label">
//             Net Payment <span className="rv-required">*</span>
//           </label>
//           <div className="rv-rp-netpayment-input-wrap">
//             <span className="rv-rp-currency-symbol">₹</span>
//             <input
//               type="number"
//               className="rv-rp-netpayment-input"
//               placeholder="Enter payment amount"
//               value={netPayment}
//               onChange={(e) => setNetPayment(e.target.value)}
//               max={maxPayable}
//               min="1"
//               step="1"
//               required
//             />
//           </div>
//         </div>

//         <div className="rv-rp-payment-mode">
//           <label className="rv-rp-payment-label">Payment Mode:</label>
//           <select
//             value={paymentMode}
//             onChange={(e) => setPaymentMode(e.target.value)}
//             className="rv-rp-payment-select"
//           >
//             <option value="CASH">💵 CASH</option>
//             <option value="UPI">📱 UPI</option>
//             <option value="BANK">🏦 BANK</option>
//           </select>
//         </div>

//         {error && <div className="rv-rp-error">{error}</div>}

//         <button
//           className="rv-rp-mark-btn"
//           onClick={handleSubmit}
//           disabled={isProcessing}
//         >
//           {isProcessing ? 'Processing...' : 'Confirm Payment'}
//         </button>
//       </div>
//     </div>
//   )
// }

// // ─── OwnerRevenue main component ──────────────────────────────────
// const OwnerRevenue = ({ selectedPG, selectedPGId }) => {
//   const [floor, setFloor] = useState('all')
//   const [selectedStatuses, setSelectedStatuses] = useState([])
//   const [search, setSearch] = useState('')
//   const [rooms, setRooms] = useState([])
//   const [totals, setTotals] = useState({ total: 0, collected: 0, due: 0, overdue: 0, notPaid: 0 })
//   const [floors, setFloors] = useState(['all'])
//   const [localRentStatus, setLocalRentStatus] = useState({})
//   const [selectedBed, setSelectedBed] = useState(null)
//   const [isModalOpen, setIsModalOpen] = useState(false)


  
  
//   // const [selectedDate, setSelectedDate] = useState(() => new Date().toISOString().split('T')[0])
//  const [selectedDate, setSelectedDate] = useState(() => {
//     const now = new Date();
//     // Add 5 hours 30 minutes
//     now.setHours(now.getHours() + 5);
//     now.setMinutes(now.getMinutes() + 30);
//     return now.toISOString().slice(0, 16); // "2026-06-22T21:00"
//   });
//   const [isGenerating, setIsGenerating] = useState(false)
//   const [generateMessage, setGenerateMessage] = useState(null)
//   const [isGeneratingElectricity, setIsGeneratingElectricity] = useState(false)
//   const [electricityMessage, setElectricityMessage] = useState(null)

//   const [toast, setToast] = useState({ show: false, message: '', type: 'success' })

//   const handleSendReminder = async (bed) => {
//     console.log('Sending reminder for:', bed.name)
//     // TODO: Replace with actual API call
//     setToast({
//       show: true,
//       message: `WhatsApp reminder sent to ${bed.name || 'tenant'}!`,
//       type: 'success'
//     })
//     setTimeout(() => setToast({ show: false, message: '', type: 'success' }), 3000)
//   }

//   const floorOrder = {
//     'Ground Floor': 0,
//     '1st Floor': 1,
//     '2nd Floor': 2,
//     '3rd Floor': 3,
//     '4th Floor': 4,
//     '5th Floor': 5
//   }

//   const fetchRevenueData = async () => {
//     try {
//       const response = await getPGRevenueStatus(selectedPGId, selectedDate)
//       const roomsMap = new Map()
//       response.occupancyData.forEach(item => {
//         const roomId = item.RoomID
//         const floorStr = item.Floor || 'Unknown'
//         if (!roomsMap.has(roomId)) {
//           roomsMap.set(roomId, {
//             id: item.RoomNumber,
//             floor: floorStr,
//             type: item.RoomType?.toLowerCase() || 'unknown',
//             beds: []
//           })
//         }
//         const room = roomsMap.get(roomId)
//         const statusValue = item.status || item.Status || 'VACANT'
//         const occupancyStatus = item.OccupancyStatus === 'VACANT' ? 'VACANT' : statusValue
//         room.beds.push({
//           bedId: item.BedID,
//           name: item.TenantName || '',
//           status: occupancyStatus || 'VACANT',
//           rent: item.NetPayable || 0,
//           rentStatus: statusValue || 'NA',
//           admissionId: item.AdmissionID || item.admissionId,
//           RentAmount: item.RentAmount,
//           ElectricityAmount: item.ElectricityAmount,
//           TotalAmount: item.TotalAmount,
//           NetPayable: item.NetPayable,
//           RentdueInMonth: item.RentDueInMonth || item.RentdueInMonth,
//           DueDate: item.DueDate
//         })
//       })

//       const roomsData = Array.from(roomsMap.values()).sort((a, b) => {
//         const aFloorOrder = floorOrder[a.floor] !== undefined ? floorOrder[a.floor] : 999
//         const bFloorOrder = floorOrder[b.floor] !== undefined ? floorOrder[b.floor] : 999
//         if (aFloorOrder !== bFloorOrder) return aFloorOrder - bFloorOrder
//         const aNum = parseInt(a.id), bNum = parseInt(b.id)
//         if (!isNaN(aNum) && !isNaN(bNum)) return aNum - bNum
//         return String(a.id).localeCompare(String(b.id))
//       })
//       setRooms(roomsData)

//       const uniqueFloorsSet = new Set(roomsData.map(r => r.floor))
//       const uniqueFloors = ['all', ...Array.from(uniqueFloorsSet).sort((a, b) => {
//         const aOrder = floorOrder[a] !== undefined ? floorOrder[a] : 999
//         const bOrder = floorOrder[b] !== undefined ? floorOrder[b] : 999
//         return aOrder - bOrder
//       })]
//       setFloors(uniqueFloors)

//       if (response.totalsArray && response.totalsArray[0]) {
//         setTotals({
//           total: response.totalsArray[0].Total || 0,
//           collected: response.totalsArray[0].Collected || 0,
//           due: response.totalsArray[0].Due || 0,
//           overdue: response.totalsArray[0].Overdue || 0,
//           notPaid: response.totalsArray[0].NotPaid || 0,
//         })
//       }
//     } catch (error) {
//       console.error('Error fetching revenue data:', error)
//     }
//   }

//   useEffect(() => {
//     if (selectedPGId) fetchRevenueData()
//   }, [selectedPGId, selectedDate])

//   // ✅ SQL DateTime Format - For API
//   const formatSQLDateTime = (dateTimeString) => {
//     if (!dateTimeString) return 'N/A';
    
//     const date = new Date(dateTimeString);
    
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     const hours = String(date.getHours()).padStart(2, '0');
//     const minutes = String(date.getMinutes()).padStart(2, '0');
//     const seconds = String(date.getSeconds()).padStart(2, '0');
    
//     return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
//   }

//   const formatDisplayDateTime = (dateTimeString) => {
//     if (!dateTimeString) return 'N/A';
//     const date = new Date(dateTimeString);
    
//     return date.toLocaleString('en-IN', { 
//       day: 'numeric', 
//       month: 'long', 
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true
//     });
//   }



//   const handleAutoGenerate = async () => {
//     if (!selectedPGId) {
//       setGenerateMessage({ type: 'error', text: 'No PG selected' })
//       setTimeout(() => setGenerateMessage(null), 3000)
//       return
//     }
//     setIsGenerating(true)
//     setGenerateMessage(null)
//     try {
//       const formattedDateTime = formatSQLDateTime(selectedDate);
//       const data = { PGID: selectedPGId, CurrDate: formattedDateTime }
//       console.log('Auto-generate rent with data:', data)
//       const response = await autoGenerateRent(data)
//       if (response.success) {
//         setGenerateMessage({ type: 'success', text: `Rent generated successfully! ${response.data?.affectedRecords || 0} records affected.` })
//         await fetchRevenueData()
//       } else {
//         setGenerateMessage({ type: 'error', text: response.message || 'Failed to generate rent' })
//       }
//     } catch (error) {
//       console.error('Error auto-generating rent:', error)
//       setGenerateMessage({ type: 'error', text: error.message || 'An error occurred' })
//     } finally {
//       setIsGenerating(false)
//       setTimeout(() => setGenerateMessage(null), 5000)
//     }
//   }

//   const handleAutoGenerateElectricity = async () => {
//     if (!selectedPGId) {
//       setElectricityMessage({ type: 'error', text: 'No PG selected' })
//       setTimeout(() => setElectricityMessage(null), 3000)
//       return
//     }
//     const date = new Date(selectedDate)
//     const month = date.getMonth() + 1
//     const year = date.getFullYear()
//     setIsGeneratingElectricity(true)
//     setElectricityMessage(null)
//     try {
      
//       const data = { PGID: selectedPGId, Month: month, Year: year }
//       console.log('Auto-generate electricity bill with data:', data)
//       const response = await autoGenerateElectricityBill(data)
//       if (response.success) {
//         setElectricityMessage({ type: 'success', text: `Electricity bill generated successfully! ${response.data?.affectedRecords || 0} records affected.` })
//         await fetchRevenueData()
//       } else {
//         setElectricityMessage({ type: 'error', text: response.message || 'Failed to generate electricity bill' })
//       }
//     } catch (error) {
//       console.error('Error auto-generating electricity bill:', error)
//       setElectricityMessage({ type: 'error', text: error.message || 'An error occurred' })
//     } finally {
//       setIsGeneratingElectricity(false)
//       setTimeout(() => setElectricityMessage(null), 5000)
//     }
//   }

//   const handleMarkRent = async (bedId, newStatus) => {
//     setLocalRentStatus(prev => ({ ...prev, [bedId]: newStatus }))
//     await fetchRevenueData()
//   }

//   const toggleStatusFilter = (statusKey) => {
//     setSelectedStatuses(prev =>
//       prev.includes(statusKey) ? prev.filter(s => s !== statusKey) : [...prev, statusKey]
//     )
//   }

//   const filtered = rooms
//     .map(room => {
//       const filteredBeds = room.beds.filter(bed => {
//         const matchesSearch = !search ||
//           bed.name?.toLowerCase().includes(search.toLowerCase()) ||
//           `room ${room.id}`.toLowerCase().includes(search.toLowerCase())
//         let matchesStatus = true
//         if (selectedStatuses.length > 0) {
//           const bedStatus = localRentStatus[bed.bedId] || bed.rentStatus
//           matchesStatus = selectedStatuses.includes(bedStatus)
//         }
//         return matchesSearch && matchesStatus
//       })
//       const matchesFloor = floor === 'all' || room.floor === floor
//       if (matchesFloor && filteredBeds.length > 0) {
//         return { ...room, beds: filteredBeds }
//       }
//       return null
//     })
//     .filter(room => room !== null)

//   const formatDate = (dateString) => {
//     const date = new Date(dateString)
//     return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })
//   }

//   return (
//     <div className="rv-root">
//       {toast.show && (
//         <div className={`rv-toast rv-toast-${toast.type}`}>
//           <span className="rv-toast-icon">✓</span>
//           <span>{toast.message}</span>
//         </div>
//       )}

//       {/* <div className="rv-auto-generate-wrapper">
//         <div className="rv-date-control">
//           <label className="rv-date-label">Select Date:</label>
//           <input
//             type="datetime-local"
//             className="rv-date-input"
//             value={selectedDate}
//             onChange={(e) => setSelectedDate(e.target.value)}
//           />
//          <span className="rv-selected-date">
//              Selected: {selectedDate ? formatDisplayDateTime(selectedDate) : 'N/A'}
//           </span>
//         </div>
//         <div className="rv-action-buttons">
//           <button
//             className="rv-auto-gen-btn"
//             onClick={handleAutoGenerate}
//             disabled={isGenerating}
//           >
//             {isGenerating ? (
//               <><span className="rv-spinner"></span> Generating Rent...</>
//             ) : (
//               <>
//                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                   <path d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9h-4m-7 9A9 9 0 013 12m9 9v-4M3 12a9 9 0 019-9m-9 9h4m7-9a9 9 0 00-9 9m9-9v4" />
//                 </svg>
//                 Auto Generate Rent
//               </>
//             )}
//           </button>
//           <button
//             className="rv-auto-gen-btn rv-electricity-btn"
//             onClick={handleAutoGenerateElectricity}
//             disabled={isGeneratingElectricity}
//           >
//             {isGeneratingElectricity ? (
//               <><span className="rv-spinner"></span> Generating Bill...</>
//             ) : (
//               <>
//                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                   <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
//                   <circle cx="12" cy="12" r="4" />
//                 </svg>
//                 Generate Electricity Bill
//               </>
//             )}
//           </button>
//         </div>
//       </div> */}

//       {generateMessage && (
//         <div className={`rv-message rv-message-${generateMessage.type}`}>
//           {generateMessage.text}
//         </div>
//       )}
//       {electricityMessage && (
//         <div className={`rv-message rv-message-${electricityMessage.type}`}>
//           {electricityMessage.text}
//         </div>
//       )}

//       <div className="rv-summary">
//         <div className="rv-legend">
//           {['PAID','DUE','OVERDUE','NOT PAID'].map(k => (
//             <span key={k} className="rv-legend-item">
//               <span className="rv-dot" style={{ background: STATUS_CFG[k].dot }} />
//               {STATUS_CFG[k].label}
//             </span>
//           ))}
//         </div>
//         <div className="rv-stats">
//           <span>Total: <strong>{fmt(totals.total)}</strong></span>
//           <span className="rv-stat-sep" />
//           <span>Collected: <strong className="rv-green-1">{fmt(totals.collected)}</strong></span>
//           <span className="rv-stat-sep" />
//           <span>Due: <strong className="rv-blue-1">{fmt(totals.due)}</strong></span>
//           <span className="rv-stat-sep" />
//           <span>Overdue: <strong className="rv-orange-1">{fmt(totals.overdue)}</strong></span>
//           <span className="rv-stat-sep" />
//           <span>Not Paid: <strong className="rv-red-1">{fmt(totals.notPaid)}</strong></span>
//         </div>
//       </div>

//       <div className="rv-controls">
//         <div className="rv-search-wrap">
//           <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2.5" strokeLinecap="round">
//             <circle cx="11" cy="11" r="8"/>
//             <path d="M21 21l-4.35-4.35"/>
//           </svg>
//           <input className="rv-search" placeholder="Search room or tenant…" value={search} onChange={e => setSearch(e.target.value)} />
//         </div>
//         <div className="rv-filter-group">
//           {floors.map(f => (
//             <button key={f} className={`rv-floor-pill ${floor === f ? 'active' : ''}`} onClick={() => setFloor(f)}>
//               {f === 'all' ? 'All' : f}
//             </button>
//           ))}
//         </div>
//         <div className="rv-filter-group">
//           {STATUS_FILTERS.map(f => (
//             <button
//               key={f.key}
//               className={`rv-status-pill`}
//               style={{
//                 background: selectedStatuses.includes(f.key) ? f.bg : '#F3F4F6',
//                 color: selectedStatuses.includes(f.key) ? 'white' : '#4B5563',
//                 borderColor: selectedStatuses.includes(f.key) ? f.bg : '#E5E7EB',
//                 transition: 'all 0.2s ease'
//               }}
//               onClick={() => toggleStatusFilter(f.key)}
//             >
//               {f.label}
//               {selectedStatuses.includes(f.key) && <span className="rv-checkmark"> ✓</span>}
//             </button>
//           ))}
//         </div>
//       </div>

//       <div className="rv-grid">
//         {filtered.map(room => (
//           <div key={room.id} className="rv-card">
//             <div className="rv-card-head">
//               <div className="rv-card-head-left">
//                 <span className="rv-card-room">Room {room.id}</span>
//                 <div className="rv-card-badges">
//                   <span className="rv-card-floor">{room.floor}</span>
//                   <span className="rv-card-type">{room.type}</span>
//                 </div>
//               </div>
//             </div>

//             <div className="rv-pill-grid">
//               {room.beds.map((bed, i) => {
//                 const statusCfg = STATUS_CFG[bed.status] || STATUS_CFG.VACANT
//                 const effectiveRentStatus = localRentStatus[bed.bedId] || bed.rentStatus
//                 const isClickable = effectiveRentStatus !== 'PAID' && bed.status !== 'VACANT'

//                 return (
//                   <div key={i} className="rv-pill-wrap">
//                     <div
//                       className={`rv-pill ${isClickable ? 'rv-pill-clickable' : ''}`}
//                       style={{ background: statusCfg.bg, borderColor: statusCfg.border }}
//                       onClick={() => {
//                         if (isClickable) {
//                           setSelectedBed(bed)
//                           setIsModalOpen(true)
//                         }
//                       }}
//                     >
//                       <span className="rv-dot" style={{ background: statusCfg.dot }} />
//                       <span className="rv-pill-name" style={{ color: statusCfg.text }}>
//                         {bed.name || statusCfg.label}
//                       </span>
//                       {/* Rent amount removed as requested */}
//                     </div>
//                   </div>
//                 )
//               })}
//               {room.beds.length < 4 && [...Array(4 - room.beds.length)].map((_, i) => (
//                 <div key={`empty-${i}`} className="rv-pill rv-pill-ghost" />
//               ))}
//             </div>
//           </div>
//         ))}
//       </div>

//       {filtered.length === 0 && (
//         <div className="rv-no-results">No tenants match your search criteria</div>
//       )}

//       {isModalOpen && (
//         <RentPaymentModal
//           pgId={selectedPGId}
//           bed={selectedBed}
//           onClose={() => { setIsModalOpen(false); setSelectedBed(null); }}
//           onSuccess={handleMarkRent}
//           onSendReminder={handleSendReminder}
//         />
//       )}
//     </div>
//   )
// }

// export default OwnerRevenue